// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'http://localhost:5001' | (string & {});
};

/**
 * ActivityNotOpenToPublic
 */
export enum ActivityNotOpenToPublic {
    ARTISTIC_COMPANY = 'ARTISTIC_COMPANY',
    ARTISTIC_PRACTICE = 'ARTISTIC_PRACTICE',
    CULTURAL_MEDIATION = 'CULTURAL_MEDIATION',
    FESTIVAL = 'FESTIVAL',
    HERITAGE_SITE = 'HERITAGE_SITE',
    HIGHER_EDUCATION_INSTITUTION = 'HIGHER_EDUCATION_INSTITUTION',
    MUNICIPALITY_CULTURAL_DEPARTMENT = 'MUNICIPALITY_CULTURAL_DEPARTMENT',
    OTHER = 'OTHER',
    PRESS_OR_MEDIA = 'PRESS_OR_MEDIA',
    PRODUCTION_OR_PROMOTION_COMPANY = 'PRODUCTION_OR_PROMOTION_COMPANY',
    PUBLISHING_HOUSE = 'PUBLISHING_HOUSE',
    RADIO_OR_MUSIC_STREAMING = 'RADIO_OR_MUSIC_STREAMING',
    SCIENTIFIC_CULTURE = 'SCIENTIFIC_CULTURE',
    TELEVISION_OR_VIDEO_STREAMING = 'TELEVISION_OR_VIDEO_STREAMING',
    TRAVELLING_CINEMA = 'TRAVELLING_CINEMA'
}

/**
 * ActivityOpenToPublic
 */
export enum ActivityOpenToPublic {
    ART_GALLERY = 'ART_GALLERY',
    ARTISTIC_PRACTICE = 'ARTISTIC_PRACTICE',
    ARTS_CENTRE = 'ARTS_CENTRE',
    BOOKSTORE = 'BOOKSTORE',
    CINEMA = 'CINEMA',
    COMMUNITY_CENTRE = 'COMMUNITY_CENTRE',
    CREATIVE_ARTS_STORE = 'CREATIVE_ARTS_STORE',
    CULTURAL_CENTRE = 'CULTURAL_CENTRE',
    DISTRIBUTION_STORE = 'DISTRIBUTION_STORE',
    FESTIVAL = 'FESTIVAL',
    HERITAGE_SITE = 'HERITAGE_SITE',
    HIGHER_EDUCATION_INSTITUTION = 'HIGHER_EDUCATION_INSTITUTION',
    LIBRARY = 'LIBRARY',
    MUSEUM = 'MUSEUM',
    MUSIC_INSTRUMENT_STORE = 'MUSIC_INSTRUMENT_STORE',
    OTHER = 'OTHER',
    PERFORMANCE_HALL = 'PERFORMANCE_HALL',
    PUBLISHING_HOUSE = 'PUBLISHING_HOUSE',
    RECORD_STORE = 'RECORD_STORE',
    SCIENTIFIC_CULTURE = 'SCIENTIFIC_CULTURE',
    TOURIST_INFORMATION_CENTRE = 'TOURIST_INFORMATION_CENTRE'
}

/**
 * AggregatedRevenueModel
 */
export type AggregatedRevenueModel = {
    /**
     * Expectedrevenue
     */
    expectedRevenue?: CollectiveRevenue | IndividualRevenue | TotalRevenue | null;
    /**
     * Revenue
     */
    revenue: CollectiveRevenue | IndividualRevenue | TotalRevenue;
};

/**
 * ArtistOfferLinkBodyModelV2
 */
export type ArtistOfferLinkBodyModelV2 = {
    /**
     * Artistid
     */
    artistId: string | null;
    /**
     * Artistname
     */
    artistName: string;
    artistType: ArtistType;
};

/**
 * ArtistOfferLinkResponseModel
 */
export type ArtistOfferLinkResponseModel = {
    /**
     * Artistid
     */
    artistId: string;
    /**
     * Artistname
     */
    artistName: string;
    artistType: ArtistType;
};

/**
 * ArtistQueryModel
 */
export type ArtistQueryModel = {
    /**
     * Search
     */
    search: string;
};

/**
 * ArtistResponseModel
 */
export type ArtistResponseModel = {
    /**
     * Description
     */
    description: string | null;
    /**
     * Id
     */
    id: string;
    /**
     * Name
     */
    name: string;
    /**
     * Thumburl
     */
    thumbUrl: string | null;
};

/**
 * ArtistType
 *
 * A link Artist <> Product also bears a type
 * An artist can be an author or a musician for different products
 */
export enum ArtistType {
    AUTHOR = 'author',
    FILM_ACTOR = 'film_actor',
    FILM_DIRECTOR = 'film_director',
    PERFORMER = 'performer',
    STAGE_DIRECTOR = 'stage_director'
}

/**
 * ArtistsResponseModel
 */
export type ArtistsResponseModel = Array<ArtistResponseModel>;

/**
 * AttachImageFormModel
 */
export type AttachImageFormModel = {
    /**
     * Alternativetext
     */
    alternativeText: string;
    /**
     * Credit
     */
    credit: string;
    /**
     * Croppingrectheight
     */
    croppingRectHeight: number;
    /**
     * Croppingrectwidth
     */
    croppingRectWidth: number;
    /**
     * Croppingrectx
     */
    croppingRectX: number;
    /**
     * Croppingrecty
     */
    croppingRectY: number;
    /**
     * Thumb
     */
    thumb?: Blob | File | null;
};

/**
 * AttachImageResponseModel
 */
export type AttachImageResponseModel = {
    /**
     * Imageurl
     */
    imageUrl: string;
};

/**
 * AudioDisabilityModel
 */
export type AudioDisabilityModel = {
    /**
     * Deafandhardofhearing
     */
    deafAndHardOfHearing?: Array<string>;
};

/**
 * BankAccountApplicationStatus
 */
export enum BankAccountApplicationStatus {
    EN_CONSTRUCTION = 'en_construction',
    EN_INSTRUCTION = 'en_instruction',
    ACCEPTE = 'accepte',
    REFUSE = 'refuse',
    SANS_SUITE = 'sans_suite',
    A_CORRIGER = 'a_corriger'
}

/**
 * BankAccountResponseModel
 */
export type BankAccountResponseModel = {
    /**
     * Datecreated
     */
    dateCreated: string;
    /**
     * Dsapplicationid
     */
    dsApplicationId: number | null;
    /**
     * Id
     */
    id: number;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Label
     */
    label: string;
    /**
     * Linkedvenues
     */
    linkedVenues: Array<LinkedVenue>;
    /**
     * Obfuscatediban
     */
    obfuscatedIban: string;
    status: BankAccountApplicationStatus;
};

/**
 * BannerMetaModel
 */
export type BannerMetaModel = {
    crop_params?: CropParamsV2;
    /**
     * Image Alternative Text
     */
    image_alternative_text?: string | null;
    /**
     * Image Credit
     */
    image_credit: string | null;
    /**
     * Original Image Url
     */
    original_image_url?: string | null;
};

/**
 * BookingExportType
 */
export enum BookingExportType {
    CSV = 'csv',
    EXCEL = 'excel'
}

/**
 * BookingOfferType
 */
export enum BookingOfferType {
    BIEN = 'BIEN',
    EVENEMENT = 'EVENEMENT'
}

/**
 * BookingRecapResponseBeneficiaryModel
 */
export type BookingRecapResponseBeneficiaryModel = {
    /**
     * Email
     */
    email?: string | null;
    /**
     * Firstname
     */
    firstname?: string | null;
    /**
     * Lastname
     */
    lastname?: string | null;
    /**
     * Phonenumber
     */
    phonenumber?: string | null;
};

/**
 * BookingRecapResponseBookingStatusHistoryModel
 */
export type BookingRecapResponseBookingStatusHistoryModel = {
    /**
     * Date
     */
    date?: string | null;
    status: BookingRecapStatus;
};

/**
 * BookingRecapResponseModel
 */
export type BookingRecapResponseModel = {
    beneficiary: BookingRecapResponseBeneficiaryModel;
    /**
     * Bookingamount
     */
    bookingAmount: number;
    /**
     * Bookingdate
     */
    bookingDate: string;
    /**
     * Bookingisduo
     */
    bookingIsDuo: boolean;
    /**
     * Bookingpricecategorylabel
     */
    bookingPriceCategoryLabel?: string | null;
    bookingStatus: BookingRecapStatus;
    /**
     * Bookingstatushistory
     */
    bookingStatusHistory: Array<BookingRecapResponseBookingStatusHistoryModel>;
    /**
     * Bookingtoken
     */
    bookingToken?: string | null;
    stock: BookingRecapResponseStockModel;
};

/**
 * BookingRecapResponseStockModel
 */
export type BookingRecapResponseStockModel = {
    /**
     * Eventbeginningdatetime
     */
    eventBeginningDatetime?: string | null;
    /**
     * Offerean
     */
    offerEan?: string | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Offeriseducational
     */
    offerIsEducational: boolean;
    /**
     * Offername
     */
    offerName: string;
};

/**
 * BookingRecapStatus
 */
export enum BookingRecapStatus {
    BOOKED = 'booked',
    VALIDATED = 'validated',
    CANCELLED = 'cancelled',
    REIMBURSED = 'reimbursed',
    CONFIRMED = 'confirmed',
    PENDING = 'pending'
}

/**
 * BookingStatusFilter
 */
export enum BookingStatusFilter {
    BOOKED = 'booked',
    VALIDATED = 'validated',
    REIMBURSED = 'reimbursed'
}

/**
 * BookingsExportQueryModel
 */
export type BookingsExportQueryModel = {
    /**
     * Eventdate
     */
    eventDate: string;
    status: BookingsExportStatusFilter;
};

/**
 * BookingsExportStatusFilter
 */
export enum BookingsExportStatusFilter {
    VALIDATED = 'validated',
    ALL = 'all'
}

/**
 * CategoriesResponseModel
 */
export type CategoriesResponseModel = {
    /**
     * Categories
     */
    categories: Array<CategoryResponseModel>;
    /**
     * Subcategories
     */
    subcategories: Array<SubcategoryResponseModel>;
};

/**
 * CategoryResponseModel
 */
export type CategoryResponseModel = {
    /**
     * Id
     */
    id: string;
    /**
     * Isselectable
     */
    isSelectable: boolean;
    /**
     * Prolabel
     */
    proLabel: string;
};

/**
 * ChangePasswordBodyModel
 */
export type ChangePasswordBodyModel = {
    /**
     * Newconfirmationpassword
     */
    newConfirmationPassword: string;
    /**
     * Newpassword
     */
    newPassword: string;
    /**
     * Oldpassword
     */
    oldPassword: string;
};

/**
 * ChangeProEmailBody
 */
export type ChangeProEmailBody = {
    /**
     * Token
     */
    token: string;
};

/**
 * CheckTokenBodyModel
 */
export type CheckTokenBodyModel = {
    /**
     * Token
     */
    token: string;
};

/**
 * CollectiveAdditionalFeeModel
 */
export type CollectiveAdditionalFeeModel = {
    /**
     * Amount
     */
    amount: number;
    /**
     * Label
     */
    label: string | null;
    type: CollectiveAdditionalFeeType;
};

/**
 * CollectiveAdditionalFeeResponseModel
 */
export type CollectiveAdditionalFeeResponseModel = {
    /**
     * Amount
     */
    amount: number;
    /**
     * Label
     */
    label: string | null;
    type: CollectiveAdditionalFeeType;
};

/**
 * CollectiveAdditionalFeeType
 */
export enum CollectiveAdditionalFeeType {
    ACCOMMODATION = 'ACCOMMODATION',
    TRAVEL = 'TRAVEL',
    MEAL = 'MEAL',
    CONSUMABLE_ITEMS = 'CONSUMABLE_ITEMS',
    COPYRIGHT = 'COPYRIGHT',
    BROADCASTING = 'BROADCASTING',
    APPLICATION_FEE = 'APPLICATION_FEE',
    MANAGEMENT_FEE = 'MANAGEMENT_FEE',
    OTHER = 'OTHER'
}

/**
 * CollectiveBookingCancellationReasons
 */
export enum CollectiveBookingCancellationReasons {
    OFFERER = 'OFFERER',
    BENEFICIARY = 'BENEFICIARY',
    EXPIRED = 'EXPIRED',
    FRAUD = 'FRAUD',
    FRAUD_SUSPICION = 'FRAUD_SUSPICION',
    FRAUD_INAPPROPRIATE = 'FRAUD_INAPPROPRIATE',
    REFUSED_BY_INSTITUTE = 'REFUSED_BY_INSTITUTE',
    REFUSED_BY_HEADMASTER = 'REFUSED_BY_HEADMASTER',
    PUBLIC_API = 'PUBLIC_API',
    FINANCE_INCIDENT = 'FINANCE_INCIDENT',
    BACKOFFICE = 'BACKOFFICE',
    BACKOFFICE_EVENT_CANCELLED = 'BACKOFFICE_EVENT_CANCELLED',
    BACKOFFICE_OFFER_MODIFIED = 'BACKOFFICE_OFFER_MODIFIED',
    BACKOFFICE_OFFER_WITH_WRONG_INFORMATION = 'BACKOFFICE_OFFER_WITH_WRONG_INFORMATION',
    BACKOFFICE_OFFERER_BUSINESS_CLOSED = 'BACKOFFICE_OFFERER_BUSINESS_CLOSED',
    OFFERER_CONNECT_AS = 'OFFERER_CONNECT_AS',
    OFFERER_CLOSED = 'OFFERER_CLOSED',
    VENUE_CLOSED = 'VENUE_CLOSED'
}

/**
 * CollectiveBookingStatus
 */
export enum CollectiveBookingStatus {
    PENDING = 'PENDING',
    CONFIRMED = 'CONFIRMED',
    USED = 'USED',
    CANCELLED = 'CANCELLED',
    PENDING_REIMBURSEMENT = 'PENDING_REIMBURSEMENT',
    REIMBURSED = 'REIMBURSED'
}

/**
 * CollectiveLocationType
 */
export enum CollectiveLocationType {
    SCHOOL = 'SCHOOL',
    ADDRESS = 'ADDRESS',
    TO_BE_DEFINED = 'TO_BE_DEFINED'
}

/**
 * CollectiveOfferAllowedAction
 */
export enum CollectiveOfferAllowedAction {
    CAN_EDIT_DETAILS = 'CAN_EDIT_DETAILS',
    CAN_EDIT_DATES = 'CAN_EDIT_DATES',
    CAN_EDIT_INSTITUTION = 'CAN_EDIT_INSTITUTION',
    CAN_EDIT_DISCOUNT = 'CAN_EDIT_DISCOUNT',
    CAN_DUPLICATE = 'CAN_DUPLICATE',
    CAN_CANCEL = 'CAN_CANCEL',
    CAN_ARCHIVE = 'CAN_ARCHIVE'
}

/**
 * CollectiveOfferDisplayedStatus
 */
export enum CollectiveOfferDisplayedStatus {
    PUBLISHED = 'PUBLISHED',
    UNDER_REVIEW = 'UNDER_REVIEW',
    REJECTED = 'REJECTED',
    PREBOOKED = 'PREBOOKED',
    BOOKED = 'BOOKED',
    HIDDEN = 'HIDDEN',
    EXPIRED = 'EXPIRED',
    ENDED = 'ENDED',
    CANCELLED = 'CANCELLED',
    REIMBURSED = 'REIMBURSED',
    ARCHIVED = 'ARCHIVED',
    DRAFT = 'DRAFT'
}

/**
 * CollectiveOfferHistory
 */
export type CollectiveOfferHistory = {
    /**
     * Future
     */
    future: Array<CollectiveOfferDisplayedStatus>;
    /**
     * Past
     */
    past: Array<HistoryStep>;
};

/**
 * CollectiveOfferHomeResponseModel
 */
export type CollectiveOfferHomeResponseModel = {
    /**
     * Allowedactions
     */
    allowedActions: Array<CollectiveOfferAllowedAction>;
    collectiveStock: CollectiveStockHomeResponseModel | null;
    displayedStatus: CollectiveOfferDisplayedStatus;
    /**
     * Id
     */
    id: number;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    /**
     * Name
     */
    name: string;
};

/**
 * CollectiveOfferInstitutionModel
 */
export type CollectiveOfferInstitutionModel = {
    /**
     * City
     */
    city: string;
    /**
     * Institutionid
     */
    institutionId: string;
    /**
     * Institutiontype
     */
    institutionType: string;
    /**
     * Name
     */
    name: string;
    /**
     * Postalcode
     */
    postalCode: string;
};

/**
 * CollectiveOfferLocationModel
 */
export type CollectiveOfferLocationModel = {
    /**
     * Location
     */
    location?: ({
        isVenueLocation: false;
    } & LocationBodyModelV2) | ({
        isVenueLocation: true;
    } & LocationOnlyOnVenueBodyModelV2) | null;
    /**
     * Locationcomment
     */
    locationComment?: string | null;
    locationType: CollectiveLocationType;
};

/**
 * CollectiveOfferRedactorModel
 */
export type CollectiveOfferRedactorModel = {
    /**
     * Email
     */
    email: string;
    /**
     * Firstname
     */
    firstName: string | null;
    /**
     * Lastname
     */
    lastName: string | null;
};

/**
 * CollectiveOfferResponseIdModel
 */
export type CollectiveOfferResponseIdModel = {
    /**
     * Id
     */
    id: number;
};

/**
 * CollectiveOfferResponseModel
 */
export type CollectiveOfferResponseModel = {
    /**
     * Allowedactions
     */
    allowedActions: Array<CollectiveOfferAllowedAction>;
    dates: DatesModel | null;
    displayedStatus: CollectiveOfferDisplayedStatus;
    educationalInstitution: EducationalInstitutionResponseModel | null;
    /**
     * Id
     */
    id: number;
    /**
     * Imagealternativetext
     */
    imageAlternativeText: string | null;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    location: GetCollectiveOfferLocationModel;
    /**
     * Name
     */
    name: string;
    stock: CollectiveOfferStockResponseModel | null;
};

/**
 * CollectiveOfferStockResponseModel
 */
export type CollectiveOfferStockResponseModel = {
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime: string;
    /**
     * Numberofteachers
     */
    numberOfTeachers: number;
    /**
     * Numberoftickets
     */
    numberOfTickets: number;
    /**
     * Price
     */
    price: number;
};

/**
 * CollectiveOfferTemplateAllowedAction
 */
export enum CollectiveOfferTemplateAllowedAction {
    CAN_EDIT_DETAILS = 'CAN_EDIT_DETAILS',
    CAN_DUPLICATE = 'CAN_DUPLICATE',
    CAN_ARCHIVE = 'CAN_ARCHIVE',
    CAN_CREATE_BOOKABLE_OFFER = 'CAN_CREATE_BOOKABLE_OFFER',
    CAN_PUBLISH = 'CAN_PUBLISH',
    CAN_HIDE = 'CAN_HIDE',
    CAN_SHARE = 'CAN_SHARE'
}

/**
 * CollectiveOfferTemplateHomeResponseModel
 */
export type CollectiveOfferTemplateHomeResponseModel = {
    /**
     * Allowedactions
     */
    allowedActions: Array<CollectiveOfferTemplateAllowedAction>;
    dates: DatesModel | null;
    displayedStatus: CollectiveOfferDisplayedStatus;
    /**
     * Id
     */
    id: number;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    /**
     * Name
     */
    name: string;
};

/**
 * CollectiveOfferTemplateResponseModel
 */
export type CollectiveOfferTemplateResponseModel = {
    /**
     * Allowedactions
     */
    allowedActions: Array<CollectiveOfferTemplateAllowedAction>;
    dates: DatesModel | null;
    displayedStatus: CollectiveOfferDisplayedStatus;
    /**
     * Id
     */
    id: number;
    /**
     * Imagealternativetext
     */
    imageAlternativeText: string | null;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    location: GetCollectiveOfferLocationModel;
    /**
     * Name
     */
    name: string;
};

/**
 * CollectiveOfferTemplatesHomeResponseModel
 */
export type CollectiveOfferTemplatesHomeResponseModel = {
    /**
     * Hasoffers
     */
    hasOffers: boolean;
    /**
     * Offers
     */
    offers: Array<CollectiveOfferTemplateHomeResponseModel>;
};

/**
 * CollectiveRevenue
 */
export type CollectiveRevenue = {
    /**
     * Collective
     */
    collective: number;
};

/**
 * CollectiveStockCreationBodyModel
 */
export type CollectiveStockCreationBodyModel = {
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime: string | null;
    /**
     * Collectiveadditionalfees
     */
    collectiveAdditionalFees: Array<CollectiveAdditionalFeeModel>;
    /**
     * Enddatetime
     */
    endDatetime: string;
    /**
     * Numberofteachers
     */
    numberOfTeachers: number;
    /**
     * Numberoftickets
     */
    numberOfTickets: number;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Price
     */
    price: number;
    /**
     * Serviceprice
     */
    servicePrice: number;
    /**
     * Startdatetime
     */
    startDatetime: string;
};

/**
 * CollectiveStockEditionBodyModel
 */
export type CollectiveStockEditionBodyModel = {
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime?: string | null;
    /**
     * Collectiveadditionalfees
     */
    collectiveAdditionalFees?: Array<CollectiveAdditionalFeeModel> | null;
    /**
     * Enddatetime
     */
    endDatetime?: string | null;
    /**
     * Numberofteachers
     */
    numberOfTeachers?: number | null;
    /**
     * Numberoftickets
     */
    numberOfTickets?: number | null;
    /**
     * Price
     */
    price?: number | null;
    /**
     * Serviceprice
     */
    servicePrice?: number | null;
    /**
     * Startdatetime
     */
    startDatetime?: string | null;
};

/**
 * CollectiveStockHomeResponseModel
 */
export type CollectiveStockHomeResponseModel = {
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime: string;
    /**
     * Enddatetime
     */
    endDatetime: string;
    /**
     * Numberofteachers
     */
    numberOfTeachers: number;
    /**
     * Numberoftickets
     */
    numberOfTickets: number;
    /**
     * Startdatetime
     */
    startDatetime: string;
};

/**
 * CollectiveStockResponseModel
 */
export type CollectiveStockResponseModel = {
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime: string;
    /**
     * Collectiveadditionalfees
     */
    collectiveAdditionalFees: Array<CollectiveAdditionalFeeResponseModel>;
    /**
     * Enddatetime
     */
    endDatetime: string;
    /**
     * Id
     */
    id: number;
    /**
     * Numberofteachers
     */
    numberOfTeachers: number;
    /**
     * Numberoftickets
     */
    numberOfTickets: number;
    /**
     * Price
     */
    price: number;
    /**
     * Pricedetail
     */
    priceDetail: string | null;
    /**
     * Serviceprice
     */
    servicePrice: number | null;
    /**
     * Startdatetime
     */
    startDatetime: string;
};

/**
 * Consent
 */
export type Consent = {
    /**
     * Accepted
     */
    accepted: Array<string>;
    /**
     * Mandatory
     */
    mandatory: Array<string>;
    /**
     * Refused
     */
    refused: Array<string>;
};

/**
 * CookieConsentRequest
 */
export type CookieConsentRequest = {
    /**
     * Choicedatetime
     */
    choiceDatetime: string;
    consent: Consent;
    /**
     * Deviceid
     */
    deviceId: string;
    /**
     * Userid
     */
    userId?: number;
};

/**
 * CreateOfferHighlightRequestBodyModel
 */
export type CreateOfferHighlightRequestBodyModel = {
    /**
     * Highlightids
     */
    highlightIds: Array<number>;
};

/**
 * CreateOffererBodyModel
 */
export type CreateOffererBodyModel = {
    /**
     * City
     */
    city: string;
    /**
     * Inseecode
     */
    inseeCode?: string | null;
    /**
     * Latitude
     */
    latitude?: number | null;
    /**
     * Longitude
     */
    longitude?: number | null;
    /**
     * Name
     */
    name: string;
    /**
     * Phonenumber
     */
    phoneNumber?: string | null;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Siren
     */
    siren: string;
    /**
     * Street
     */
    street?: string | null;
};

/**
 * CreateThumbnailBodyModel
 */
export type CreateThumbnailBodyModel = {
    /**
     * Alternativetext
     */
    alternativeText?: string | null;
    /**
     * Credit
     */
    credit?: string | null;
    /**
     * Croppingrectheight
     */
    croppingRectHeight?: number | null;
    /**
     * Croppingrectwidth
     */
    croppingRectWidth?: number | null;
    /**
     * Croppingrectx
     */
    croppingRectX?: number | null;
    /**
     * Croppingrecty
     */
    croppingRectY?: number | null;
    /**
     * Offerid
     */
    offerId: number;
};

/**
 * CreateThumbnailResponseModel
 */
export type CreateThumbnailResponseModel = {
    /**
     * Alternativetext
     */
    alternativeText: string | null;
    /**
     * Credit
     */
    credit?: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Url
     */
    url: string;
};

/**
 * CriteriaEnum
 */
export enum CriteriaEnum {
    CLOSURE_DETECTED = 'closure_detected'
}

/**
 * CropParamsV2
 */
export type CropParamsV2 = {
    /**
     * Height Crop Percent
     */
    height_crop_percent?: number;
    /**
     * Width Crop Percent
     */
    width_crop_percent?: number;
    /**
     * X Crop Percent
     */
    x_crop_percent?: number;
    /**
     * Y Crop Percent
     */
    y_crop_percent?: number;
};

/**
 * DMSApplicationForEAC
 */
export type DMSApplicationForEAC = {
    /**
     * Application
     */
    application: number;
    /**
     * Builddate
     */
    buildDate: string | null;
    /**
     * Depositdate
     */
    depositDate: string;
    /**
     * Expirationdate
     */
    expirationDate: string | null;
    /**
     * Instructiondate
     */
    instructionDate: string | null;
    /**
     * Lastchangedate
     */
    lastChangeDate: string;
    /**
     * Procedure
     */
    procedure: number;
    /**
     * Processingdate
     */
    processingDate: string | null;
    state: DMSApplicationstatus;
    /**
     * Userdeletiondate
     */
    userDeletionDate: string | null;
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * DMSApplicationstatus
 */
export enum DMSApplicationstatus {
    ACCEPTE = 'accepte',
    SANS_SUITE = 'sans_suite',
    EN_CONSTRUCTION = 'en_construction',
    REFUSE = 'refuse',
    EN_INSTRUCTION = 'en_instruction'
}

/**
 * DatesModel
 */
export type DatesModel = {
    /**
     * End
     */
    end: string;
    /**
     * Start
     */
    start: string;
};

/**
 * DeleteOfferRequestBody
 */
export type DeleteOfferRequestBody = {
    /**
     * Ids
     */
    ids: Array<number>;
};

/**
 * DeleteStockListBody
 */
export type DeleteStockListBody = {
    /**
     * Ids To Delete
     */
    ids_to_delete: Array<number>;
};

/**
 * DetachedVenueResponseModel
 */
export type DetachedVenueResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Publicname
     */
    publicName: string;
};

/**
 * DisplayableActivity
 */
export enum DisplayableActivity {
    ART_GALLERY = 'ART_GALLERY',
    ARTISTIC_COMPANY = 'ARTISTIC_COMPANY',
    ARTISTIC_PRACTICE = 'ARTISTIC_PRACTICE',
    ARTS_CENTRE = 'ARTS_CENTRE',
    BOOKSTORE = 'BOOKSTORE',
    CINEMA = 'CINEMA',
    COMMUNITY_CENTRE = 'COMMUNITY_CENTRE',
    CREATIVE_ARTS_STORE = 'CREATIVE_ARTS_STORE',
    CULTURAL_CENTRE = 'CULTURAL_CENTRE',
    CULTURAL_MEDIATION = 'CULTURAL_MEDIATION',
    DISTRIBUTION_STORE = 'DISTRIBUTION_STORE',
    FESTIVAL = 'FESTIVAL',
    GAMES_CENTRE = 'GAMES_CENTRE',
    HERITAGE_SITE = 'HERITAGE_SITE',
    HIGHER_EDUCATION_INSTITUTION = 'HIGHER_EDUCATION_INSTITUTION',
    LIBRARY = 'LIBRARY',
    MUNICIPALITY_CULTURAL_DEPARTMENT = 'MUNICIPALITY_CULTURAL_DEPARTMENT',
    MUSEUM = 'MUSEUM',
    MUSIC_INSTRUMENT_STORE = 'MUSIC_INSTRUMENT_STORE',
    OTHER = 'OTHER',
    PERFORMANCE_HALL = 'PERFORMANCE_HALL',
    PRESS_OR_MEDIA = 'PRESS_OR_MEDIA',
    PRODUCTION_OR_PROMOTION_COMPANY = 'PRODUCTION_OR_PROMOTION_COMPANY',
    PUBLISHING_HOUSE = 'PUBLISHING_HOUSE',
    RADIO_OR_MUSIC_STREAMING = 'RADIO_OR_MUSIC_STREAMING',
    RECORD_STORE = 'RECORD_STORE',
    SCIENTIFIC_CULTURE = 'SCIENTIFIC_CULTURE',
    TELEVISION_OR_VIDEO_STREAMING = 'TELEVISION_OR_VIDEO_STREAMING',
    TOURIST_INFORMATION_CENTRE = 'TOURIST_INFORMATION_CENTRE',
    TRAVELLING_CINEMA = 'TRAVELLING_CINEMA'
}

/**
 * DownloadBookingsQueryModel
 */
export type DownloadBookingsQueryModel = {
    /**
     * Bookingperiodbeginningdate
     */
    bookingPeriodBeginningDate?: string | null;
    /**
     * Bookingperiodendingdate
     */
    bookingPeriodEndingDate?: string | null;
    bookingStatusFilter?: BookingStatusFilter | null;
    /**
     * Eventdate
     */
    eventDate?: string | null;
    exportType?: BookingExportType | null;
    /**
     * Offerid
     */
    offerId?: number | null;
    /**
     * Offereraddressid
     */
    offererAddressId?: number | null;
    /**
     * Offererid
     */
    offererId: number;
    /**
     * Page
     */
    page?: number;
    /**
     * Venueid
     */
    venueId?: number | null;
};

/**
 * EacFormat
 */
export enum EacFormat {
    ATELIER_DE_PRATIQUE = 'Atelier de pratique',
    CONCERT = 'Concert',
    CONF_RENCE_RENCONTRE = 'Conférence, rencontre',
    FESTIVAL_SALON_CONGR_S = 'Festival, salon, congrès',
    PROJECTION_AUDIOVISUELLE = 'Projection audiovisuelle',
    REPR_SENTATION = 'Représentation',
    VISITE_GUID_E = 'Visite guidée',
    VISITE_LIBRE = 'Visite libre'
}

/**
 * EditVenueBodyModel
 */
export type EditVenueBodyModel = {
    /**
     * Activity
     */
    activity?: ActivityOpenToPublic | ActivityNotOpenToPublic | null;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean | null;
    /**
     * Banid
     */
    banId?: string | null;
    /**
     * Bookingemail
     */
    bookingEmail?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Comment
     */
    comment?: string | null;
    contact?: VenueContactModel | null;
    /**
     * Culturaldomains
     */
    culturalDomains?: Array<string> | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Inseecode
     */
    inseeCode?: string | null;
    /**
     * Isaccessibilityappliedonalloffers
     */
    isAccessibilityAppliedOnAllOffers?: boolean | null;
    /**
     * Ismanualedition
     */
    isManualEdition?: boolean | null;
    /**
     * Isopentopublic
     */
    isOpenToPublic?: boolean | null;
    /**
     * Latitude
     */
    latitude?: number | string | null;
    /**
     * Longitude
     */
    longitude?: number | string | null;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean | null;
    /**
     * Name
     */
    name?: string | null;
    openingHours?: WeekdayOpeningHoursTimespans | null;
    /**
     * Postalcode
     */
    postalCode?: string | null;
    /**
     * Publicname
     */
    publicName?: string | null;
    /**
     * Siret
     */
    siret?: string | null;
    /**
     * Street
     */
    street?: string | null;
    /**
     * Venuelabelid
     */
    venueLabelId?: number | null;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean | null;
    /**
     * Volunteeringurl
     */
    volunteeringUrl?: string | null;
    /**
     * Withdrawaldetails
     */
    withdrawalDetails?: string | null;
};

/**
 * EditVenueCollectiveDataBodyModel
 */
export type EditVenueCollectiveDataBodyModel = {
    /**
     * Activity
     */
    activity?: ActivityOpenToPublic | ActivityNotOpenToPublic | null;
    /**
     * Collectivedescription
     */
    collectiveDescription?: string | null;
    /**
     * Collectivedomains
     */
    collectiveDomains?: Array<number> | null;
    /**
     * Collectiveemail
     */
    collectiveEmail?: string | null;
    /**
     * Collectiveinterventionarea
     */
    collectiveInterventionArea?: Array<string> | null;
    /**
     * Collectivelegalstatus
     */
    collectiveLegalStatus?: number | null;
    /**
     * Collectivenetwork
     */
    collectiveNetwork?: Array<string> | null;
    /**
     * Collectivephone
     */
    collectivePhone?: string | null;
    /**
     * Collectivestudents
     */
    collectiveStudents?: Array<StudentLevels> | null;
    /**
     * Collectivewebsite
     */
    collectiveWebsite?: string | null;
};

/**
 * EducationalDomainResponseModel
 */
export type EducationalDomainResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Nationalprograms
     */
    nationalPrograms: Array<NationalProgramResponseModel>;
};

/**
 * EducationalDomainsResponseModel
 */
export type EducationalDomainsResponseModel = Array<EducationalDomainResponseModel>;

/**
 * EducationalInstitutionResponseModel
 */
export type EducationalInstitutionResponseModel = {
    /**
     * City
     */
    city: string;
    /**
     * Id
     */
    id: number;
    /**
     * Institutionid
     */
    institutionId: string;
    /**
     * Institutiontype
     */
    institutionType: string;
    /**
     * Name
     */
    name: string;
    /**
     * Phonenumber
     */
    phoneNumber: string;
    /**
     * Postalcode
     */
    postalCode: string;
};

/**
 * EducationalInstitutionsQueryModel
 */
export type EducationalInstitutionsQueryModel = {
    /**
     * Page
     */
    page?: number;
    /**
     * Perpagelimit
     */
    perPageLimit?: number;
};

/**
 * EducationalInstitutionsResponseModel
 */
export type EducationalInstitutionsResponseModel = {
    /**
     * Educationalinstitutions
     */
    educationalInstitutions: Array<EducationalInstitutionResponseModel>;
    /**
     * Page
     */
    page: number;
    /**
     * Pages
     */
    pages: number;
    /**
     * Total
     */
    total: number;
};

/**
 * EducationalRedactor
 */
export type EducationalRedactor = {
    /**
     * Email
     */
    email: string;
    /**
     * Name
     */
    name: string;
    /**
     * Surname
     */
    surname: string;
};

/**
 * EducationalRedactorQueryModel
 */
export type EducationalRedactorQueryModel = {
    /**
     * Candidate
     */
    candidate: string;
    /**
     * Uai
     */
    uai: string;
};

/**
 * EducationalRedactorResponseModel
 */
export type EducationalRedactorResponseModel = {
    /**
     * Civility
     */
    civility: string | null;
    /**
     * Email
     */
    email: string;
    /**
     * Firstname
     */
    firstName: string | null;
    /**
     * Lastname
     */
    lastName: string | null;
};

/**
 * EducationalRedactors
 */
export type EducationalRedactors = Array<EducationalRedactor>;

/**
 * EligibilityDocument
 */
export enum EligibilityDocument {
    WEBSITE = 'WEBSITE',
    RESUME_OR_PORTFOLIO = 'RESUME_OR_PORTFOLIO',
    DIPLOMAS = 'DIPLOMAS',
    SOUND_DESIGN_DIPLOMAS = 'SOUND_DESIGN_DIPLOMAS',
    PRICES = 'PRICES',
    SHOP_PICTURES = 'SHOP_PICTURES',
    SOUND_STUDIO_PICTURES = 'SOUND_STUDIO_PICTURES',
    CRIMINAL_RECORDS = 'CRIMINAL_RECORDS',
    DESCRIPTION = 'DESCRIPTION'
}

/**
 * EventDateScheduleAndPriceCategoriesCountModel
 */
export type EventDateScheduleAndPriceCategoriesCountModel = {
    /**
     * Eventdate
     */
    eventDate: string;
    /**
     * Pricecategoriescount
     */
    priceCategoriesCount: number;
    /**
     * Schedulecount
     */
    scheduleCount: number;
};

/**
 * EventDatesInfos
 */
export type EventDatesInfos = Array<EventDateScheduleAndPriceCategoriesCountModel>;

/**
 * EventStockCreateBodyModel
 */
export type EventStockCreateBodyModel = {
    /**
     * Beginningdatetime
     */
    beginningDatetime: string;
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime?: string | null;
    /**
     * Pricecategoryid
     */
    priceCategoryId: number;
    /**
     * Quantity
     */
    quantity?: number | null;
};

/**
 * EventStockUpdateBodyModel
 */
export type EventStockUpdateBodyModel = {
    /**
     * Beginningdatetime
     */
    beginningDatetime: string;
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime?: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Pricecategoryid
     */
    priceCategoryId: number;
    /**
     * Quantity
     */
    quantity?: number | null;
};

/**
 * EventStocksBulkCreateBodyModel
 */
export type EventStocksBulkCreateBodyModel = {
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Stocks
     */
    stocks: Array<EventStockCreateBodyModel>;
};

/**
 * EventStocksBulkUpdateBodyModel
 */
export type EventStocksBulkUpdateBodyModel = {
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Stocks
     */
    stocks: Array<EventStockUpdateBodyModel>;
};

/**
 * ExposureEventResponseModel
 */
export type ExposureEventResponseModel = {
    /**
     * Enddate
     */
    endDate: string | null;
    /**
     * Name
     */
    name: string | null;
    /**
     * Startdate
     */
    startDate: string;
    type: ExposureEventType;
    /**
     * Viewsonperiod
     */
    viewsOnPeriod: number | null;
};

/**
 * ExposureEventType
 */
export enum ExposureEventType {
    HIGHLIGHT = 'HIGHLIGHT',
    HEADLINE = 'HEADLINE'
}

/**
 * ExternalAccessibilityDataModel
 */
export type ExternalAccessibilityDataModel = {
    audioDisability?: AudioDisabilityModel;
    /**
     * Isaccessibleaudiodisability
     */
    isAccessibleAudioDisability?: boolean;
    /**
     * Isaccessiblementaldisability
     */
    isAccessibleMentalDisability?: boolean;
    /**
     * Isaccessiblemotordisability
     */
    isAccessibleMotorDisability?: boolean;
    /**
     * Isaccessiblevisualdisability
     */
    isAccessibleVisualDisability?: boolean;
    mentalDisability?: MentalDisabilityModel;
    motorDisability?: MotorDisabilityModel;
    visualDisability?: VisualDisabilityModel;
};

/**
 * FeatureResponseModel
 */
export type FeatureResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Name
     */
    name: string;
};

/**
 * FormatEnum
 */
export enum FormatEnum {
    CD_VINYLE = 'CD_VINYLE',
    DVD_BLU_RAY = 'DVD_BLU_RAY',
    INSTRUMENT_DE_MUSIQUE = 'INSTRUMENT_DE_MUSIQUE',
    LIVRE_PAPIER = 'LIVRE_PAPIER',
    MATERIEL_ARTS_CREATIFS = 'MATERIEL_ARTS_CREATIFS'
}

/**
 * FormatResponseModel
 */
export type FormatResponseModel = {
    format: FormatEnum;
    /**
     * Label
     */
    label: string;
};

/**
 * GetActiveEANOfferResponseModel
 */
export type GetActiveEANOfferResponseModel = {
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean;
    /**
     * Datecreated
     */
    dateCreated: string;
    /**
     * Id
     */
    id: number;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Productid
     */
    productId?: number;
    status: OfferStatus;
    subcategoryId: SubcategoryIdEnum;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean;
};

/**
 * GetBookingResponse
 */
export type GetBookingResponse = {
    /**
     * Bookingid
     */
    bookingId: string;
    /**
     * Dateofbirth
     */
    dateOfBirth: string | null;
    /**
     * Datetime
     */
    datetime: string;
    /**
     * Ean13
     */
    ean13: string | null;
    /**
     * Email
     */
    email: string;
    /**
     * Firstname
     */
    firstName: string | null;
    /**
     * Isused
     */
    isUsed: boolean;
    /**
     * Lastname
     */
    lastName: string | null;
    /**
     * Offeraddress
     */
    offerAddress: string | null;
    /**
     * Offerdepartmentcode
     */
    offerDepartmentCode: string | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Offername
     */
    offerName: string;
    offerType: BookingOfferType;
    /**
     * Phonenumber
     */
    phoneNumber: string | null;
    /**
     * Price
     */
    price: number;
    /**
     * Pricecategorylabel
     */
    priceCategoryLabel: string | null;
    /**
     * Publicofferid
     */
    publicOfferId: string;
    /**
     * Quantity
     */
    quantity: number;
    /**
     * Username
     */
    userName: string;
    /**
     * Venuename
     */
    venueName: string;
};

/**
 * GetBookingsProQueryModel
 */
export type GetBookingsProQueryModel = {
    /**
     * Bookingperiodbeginningdate
     */
    bookingPeriodBeginningDate?: string | null;
    /**
     * Bookingperiodendingdate
     */
    bookingPeriodEndingDate?: string | null;
    bookingStatusFilter?: BookingStatusFilter | null;
    /**
     * Eventdate
     */
    eventDate?: string | null;
    /**
     * Offerid
     */
    offerId?: number | null;
    /**
     * Offereraddressid
     */
    offererAddressId?: number | null;
    /**
     * Page
     */
    page?: number;
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * GetBookingsProResponseModel
 */
export type GetBookingsProResponseModel = {
    /**
     * Bookingsrecap
     */
    bookingsRecap: Array<BookingRecapResponseModel>;
    /**
     * Page
     */
    page: number;
    /**
     * Pages
     */
    pages: number;
    /**
     * Total
     */
    total: number;
};

/**
 * GetCollectiveOfferBookingResponseModel
 */
export type GetCollectiveOfferBookingResponseModel = {
    /**
     * Cancellationlimitdate
     */
    cancellationLimitDate: string;
    cancellationReason: CollectiveBookingCancellationReasons | null;
    /**
     * Confirmationlimitdate
     */
    confirmationLimitDate: string;
    /**
     * Datecreated
     */
    dateCreated: string;
    educationalRedactor: EducationalRedactorResponseModel;
    /**
     * Id
     */
    id: number;
    status: CollectiveBookingStatus;
};

/**
 * GetCollectiveOfferCollectiveStockResponseModel
 */
export type GetCollectiveOfferCollectiveStockResponseModel = {
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime: string;
    /**
     * Collectiveadditionalfees
     */
    collectiveAdditionalFees: Array<CollectiveAdditionalFeeResponseModel>;
    /**
     * Enddatetime
     */
    endDatetime: string;
    /**
     * Id
     */
    id: number;
    /**
     * Numberofteachers
     */
    numberOfTeachers: number;
    /**
     * Numberoftickets
     */
    numberOfTickets: number;
    /**
     * Price
     */
    price: number;
    /**
     * Pricedetail
     */
    priceDetail: string | null;
    /**
     * Serviceprice
     */
    servicePrice: number | null;
    /**
     * Startdatetime
     */
    startDatetime: string;
};

/**
 * GetCollectiveOfferLocationModel
 */
export type GetCollectiveOfferLocationModel = {
    location: LocationResponseModelV2 | null;
    /**
     * Locationcomment
     */
    locationComment: string | null;
    locationType: CollectiveLocationType;
};

/**
 * GetCollectiveOfferManagingOffererResponseModel
 */
export type GetCollectiveOfferManagingOffererResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Siren
     */
    siren: string;
};

/**
 * GetCollectiveOfferProviderResponseModel
 */
export type GetCollectiveOfferProviderResponseModel = {
    /**
     * Name
     */
    name: string;
};

/**
 * GetCollectiveOfferRequestResponseModel
 */
export type GetCollectiveOfferRequestResponseModel = {
    /**
     * Comment
     */
    comment: string;
    /**
     * Datecreated
     */
    dateCreated: string;
    institution: CollectiveOfferInstitutionModel;
    /**
     * Phonenumber
     */
    phoneNumber: string | null;
    redactor: CollectiveOfferRedactorModel;
    /**
     * Requesteddate
     */
    requestedDate: string | null;
    /**
     * Totalstudents
     */
    totalStudents: number | null;
    /**
     * Totalteachers
     */
    totalTeachers: number | null;
};

/**
 * GetCollectiveOfferResponseModel
 */
export type GetCollectiveOfferResponseModel = {
    /**
     * Additionaldetails
     */
    additionalDetails: string | null;
    /**
     * Allowedactions
     */
    allowedActions: Array<CollectiveOfferAllowedAction>;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean | null;
    booking: GetCollectiveOfferBookingResponseModel | null;
    /**
     * Bookingemails
     */
    bookingEmails: Array<string>;
    collectiveStock: GetCollectiveOfferCollectiveStockResponseModel | null;
    /**
     * Contactemail
     */
    contactEmail: string | null;
    /**
     * Contactphone
     */
    contactPhone: string | null;
    /**
     * Datecreated
     */
    dateCreated: string;
    dates: DatesModel | null;
    /**
     * Description
     */
    description: string;
    displayedStatus: CollectiveOfferDisplayedStatus;
    /**
     * Domains
     */
    domains: Array<OfferDomain>;
    /**
     * Durationminutes
     */
    durationMinutes: number | null;
    /**
     * Formats
     */
    formats: Array<EacFormat>;
    history: CollectiveOfferHistory;
    /**
     * Id
     */
    id: number;
    /**
     * Imagealternativetext
     */
    imageAlternativeText: string | null;
    /**
     * Imagecredit
     */
    imageCredit: string | null;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    institution: EducationalInstitutionResponseModel | null;
    /**
     * Interventionarea
     */
    interventionArea: Array<string>;
    /**
     * Ispublicapi
     */
    isPublicApi: boolean;
    /**
     * Istemplate
     */
    isTemplate?: boolean;
    location: GetCollectiveOfferLocationModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean | null;
    /**
     * Name
     */
    name: string;
    nationalProgram: NationalProgramResponseModel | null;
    provider: GetCollectiveOfferProviderResponseModel | null;
    /**
     * Students
     */
    students: Array<StudentLevels>;
    teacher: EducationalRedactorResponseModel | null;
    /**
     * Templateid
     */
    templateId: number | null;
    venue: GetCollectiveOfferVenueResponseModel;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean | null;
};

/**
 * GetCollectiveOfferTemplateResponseModel
 */
export type GetCollectiveOfferTemplateResponseModel = {
    /**
     * Allowedactions
     */
    allowedActions: Array<CollectiveOfferTemplateAllowedAction>;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean | null;
    /**
     * Bookingemails
     */
    bookingEmails: Array<string>;
    /**
     * Contactemail
     */
    contactEmail: string | null;
    contactForm: OfferContactFormEnum | null;
    /**
     * Contactphone
     */
    contactPhone: string | null;
    /**
     * Contacturl
     */
    contactUrl: string | null;
    /**
     * Datecreated
     */
    dateCreated: string;
    dates: DatesModel | null;
    /**
     * Description
     */
    description: string;
    displayedStatus: CollectiveOfferDisplayedStatus;
    /**
     * Domains
     */
    domains: Array<OfferDomain>;
    /**
     * Durationminutes
     */
    durationMinutes: number | null;
    /**
     * Formats
     */
    formats: Array<EacFormat>;
    /**
     * Id
     */
    id: number;
    /**
     * Imagealternativetext
     */
    imageAlternativeText: string | null;
    /**
     * Imagecredit
     */
    imageCredit: string | null;
    /**
     * Imageurl
     */
    imageUrl: string | null;
    /**
     * Interventionarea
     */
    interventionArea: Array<string>;
    /**
     * Istemplate
     */
    isTemplate?: boolean;
    location: GetCollectiveOfferLocationModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean | null;
    /**
     * Name
     */
    name: string;
    nationalProgram: NationalProgramResponseModel | null;
    /**
     * Pricedetail
     */
    priceDetail: string | null;
    /**
     * Students
     */
    students: Array<StudentLevels>;
    venue: GetCollectiveOfferVenueResponseModel;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean | null;
};

/**
 * GetCollectiveOfferVenueResponseModel
 */
export type GetCollectiveOfferVenueResponseModel = {
    /**
     * Departementcode
     */
    departementCode: string;
    /**
     * Id
     */
    id: number;
    /**
     * Imgalternativetext
     */
    imgAlternativeText: string | null;
    /**
     * Imgurl
     */
    imgUrl: string | null;
    managingOfferer: GetCollectiveOfferManagingOffererResponseModel;
    /**
     * Name
     */
    name: string;
    /**
     * Publicname
     */
    publicName: string;
};

/**
 * GetCombinedInvoicesQueryModel
 */
export type GetCombinedInvoicesQueryModel = {
    /**
     * Invoicereferences
     */
    invoiceReferences: Array<string>;
};

/**
 * GetEducationalOffererResponseModel
 */
export type GetEducationalOffererResponseModel = {
    /**
     * Allowedonadage
     */
    allowedOnAdage: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Managedvenues
     */
    managedVenues: Array<GetEducationalOffererVenueResponseModel>;
    /**
     * Name
     */
    name: string;
};

/**
 * GetEducationalOffererVenueResponseModel
 */
export type GetEducationalOffererVenueResponseModel = {
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Collectiveemail
     */
    collectiveEmail?: string | null;
    /**
     * Collectiveinterventionarea
     */
    collectiveInterventionArea?: Array<string> | null;
    /**
     * Collectivephone
     */
    collectivePhone?: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean | null;
    /**
     * Name
     */
    name: string;
    /**
     * Postalcode
     */
    postalCode?: string | null;
    /**
     * Publicname
     */
    publicName: string;
    /**
     * Street
     */
    street?: string | null;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean | null;
};

/**
 * GetEducationalOfferersQueryModel
 */
export type GetEducationalOfferersQueryModel = {
    /**
     * Offererid
     */
    offererId?: number | null;
};

/**
 * GetEducationalOfferersResponseModel
 */
export type GetEducationalOfferersResponseModel = {
    /**
     * Educationalofferers
     */
    educationalOfferers: Array<GetEducationalOffererResponseModel>;
};

/**
 * GetIndividualOfferResponseModel
 */
export type GetIndividualOfferResponseModel = {
    /**
     * GetOfferMediationResponseModel
     */
    activeMediation?: GetOfferMediationResponseModel;
    /**
     * Artistofferlinks
     */
    artistOfferLinks: Array<ArtistOfferLinkResponseModel>;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean;
    /**
     * Bookingalloweddatetime
     */
    bookingAllowedDatetime?: string;
    /**
     * Bookingcontact
     */
    bookingContact?: string;
    /**
     * Bookingemail
     */
    bookingEmail?: string;
    /**
     * Bookingscount
     */
    bookingsCount?: number;
    /**
     * Canbeevent
     */
    canBeEvent: boolean;
    /**
     * Datecreated
     */
    dateCreated: string;
    /**
     * Description
     */
    description?: string;
    /**
     * Durationminutes
     */
    durationMinutes?: number;
    /**
     * Externalticketofficeurl
     */
    externalTicketOfficeUrl?: string;
    extraData?: OfferExtraData;
    /**
     * Hasbookinglimitdatetimespassed
     */
    hasBookingLimitDatetimesPassed: boolean;
    /**
     * Hasculturaloutreachclaim
     */
    hasCulturalOutreachClaim: boolean;
    /**
     * Haspendingbookings
     */
    hasPendingBookings: boolean;
    /**
     * Hasstocks
     */
    hasStocks: boolean;
    /**
     * Highlightrequests
     */
    highlightRequests: Array<ShortHighlightResponseModel>;
    /**
     * Id
     */
    id: number;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Isdigital
     */
    isDigital: boolean;
    /**
     * Isduo
     */
    isDuo: boolean;
    /**
     * Iseditable
     */
    isEditable: boolean;
    /**
     * Isevent
     */
    isEvent: boolean;
    /**
     * Isheadlineoffer
     */
    isHeadlineOffer: boolean;
    /**
     * Isnational
     */
    isNational: boolean;
    /**
     * Isnonfreeoffer
     */
    isNonFreeOffer?: boolean;
    /**
     * Isthing
     */
    isThing: boolean;
    /**
     * GetOfferLastProviderResponseModel
     */
    lastProvider?: GetOfferLastProviderResponseModel;
    /**
     * LocationResponseModel
     */
    location?: LocationResponseModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Pricecategories
     */
    priceCategories?: Array<PriceCategoryResponseModel>;
    /**
     * Productid
     */
    productId?: number;
    /**
     * Publicationdate
     */
    publicationDate?: string;
    /**
     * Publicationdatetime
     */
    publicationDatetime?: string;
    status: OfferStatus;
    subcategoryId: SubcategoryIdEnum;
    /**
     * Thumburl
     */
    thumbUrl?: string;
    /**
     * Url
     */
    url?: string;
    venue: GetOfferVenueResponseModel;
    videoData: VideoData;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean;
    /**
     * Withdrawaldelay
     */
    withdrawalDelay?: number;
    /**
     * Withdrawaldetails
     */
    withdrawalDetails?: string;
    withdrawalType?: WithdrawalTypeEnum;
};

/**
 * GetMusicTypesResponse
 */
export type GetMusicTypesResponse = Array<MusicTypeResponse>;

/**
 * GetOfferExposureResponseModel
 */
export type GetOfferExposureResponseModel = {
    /**
     * Events
     */
    events: Array<ExposureEventResponseModel>;
    /**
     * Views
     */
    views: number | null;
};

/**
 * GetOfferLastProviderResponseModel
 */
export type GetOfferLastProviderResponseModel = {
    /**
     * Name
     */
    name: string;
};

/**
 * GetOfferManagingOffererResponseModel
 */
export type GetOfferManagingOffererResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * GetOfferMediationResponseModel
 */
export type GetOfferMediationResponseModel = {
    /**
     * Alternativetext
     */
    alternativeText?: string;
    /**
     * Authorid
     */
    authorId?: string;
    /**
     * Credit
     */
    credit?: string;
    /**
     * Thumburl
     */
    thumbUrl?: string;
};

/**
 * GetOfferStockResponseModel
 */
export type GetOfferStockResponseModel = {
    /**
     * Activationcodesexpirationdatetime
     */
    activationCodesExpirationDatetime?: string;
    /**
     * Beginningdatetime
     */
    beginningDatetime?: string;
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime?: string;
    /**
     * Bookingsquantity
     */
    bookingsQuantity: number;
    /**
     * Hasactivationcode
     */
    hasActivationCode: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Iseventdeletable
     */
    isEventDeletable: boolean;
    /**
     * Price
     */
    price: number;
    /**
     * Pricecategoryid
     */
    priceCategoryId?: number;
    /**
     * Quantity
     */
    quantity?: number;
    /**
     * Remainingquantity
     */
    remainingQuantity?: number | string;
};

/**
 * GetOfferVenueResponseModel
 */
export type GetOfferVenueResponseModel = {
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean;
    /**
     * Bookingemail
     */
    bookingEmail?: string;
    /**
     * City
     */
    city?: string;
    /**
     * Departementcode
     */
    departementCode?: string;
    /**
     * Id
     */
    id: number;
    managingOfferer: GetOfferManagingOffererResponseModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Postalcode
     */
    postalCode?: string;
    /**
     * Publicname
     */
    publicName: string;
    /**
     * Street
     */
    street?: string;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean;
};

/**
 * GetOffererAddressResponseModel
 */
export type GetOffererAddressResponseModel = {
    /**
     * City
     */
    city: string;
    /**
     * Departmentcode
     */
    departmentCode: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Label
     */
    label: string | null;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Street
     */
    street: string | null;
};

/**
 * GetOffererAddressesQueryModel
 */
export type GetOffererAddressesQueryModel = {
    withOffersOption?: GetOffererAddressesWithOffersOption | null;
};

/**
 * GetOffererAddressesResponseModel
 */
export type GetOffererAddressesResponseModel = Array<GetOffererAddressResponseModel>;

/**
 * GetOffererAddressesWithOffersOption
 */
export enum GetOffererAddressesWithOffersOption {
    INDIVIDUAL_OFFERS_ONLY = 'INDIVIDUAL_OFFERS_ONLY',
    COLLECTIVE_OFFERS_ONLY = 'COLLECTIVE_OFFERS_ONLY',
    COLLECTIVE_OFFER_TEMPLATES_ONLY = 'COLLECTIVE_OFFER_TEMPLATES_ONLY'
}

/**
 * GetOffererBankAccountsResponseModel
 */
export type GetOffererBankAccountsResponseModel = {
    /**
     * Bankaccounts
     */
    bankAccounts: Array<BankAccountResponseModel>;
    /**
     * Id
     */
    id: number;
    /**
     * Managedvenues
     */
    managedVenues: Array<ManagedVenue>;
};

/**
 * GetOffererMemberResponseModel
 */
export type GetOffererMemberResponseModel = {
    /**
     * Email
     */
    email: string;
    status: OffererMemberStatus;
};

/**
 * GetOffererMembersResponseModel
 */
export type GetOffererMembersResponseModel = {
    /**
     * Members
     */
    members: Array<GetOffererMemberResponseModel>;
};

/**
 * GetOffererNameResponseModel
 */
export type GetOffererNameResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Validated
     */
    validated: boolean;
};

/**
 * GetOffererResponseModel
 */
export type GetOffererResponseModel = {
    /**
     * Allowedonadage
     */
    allowedOnAdage: boolean;
    /**
     * Candisplayhighlights
     */
    canDisplayHighlights: boolean;
    /**
     * Hasbankaccountwithpendingcorrections
     */
    hasBankAccountWithPendingCorrections: boolean;
    /**
     * Hasnonfreeoffer
     */
    hasNonFreeOffer: boolean;
    /**
     * Haspendingbankaccount
     */
    hasPendingBankAccount: boolean;
    /**
     * Hasvalidbankaccount
     */
    hasValidBankAccount: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Iscaledonian
     */
    isCaledonian: boolean;
    /**
     * Isclosed
     */
    isClosed: boolean;
    /**
     * Isonboarded
     */
    isOnboarded: boolean;
    /**
     * Isvalidated
     */
    isValidated: boolean;
    /**
     * Managedvenues
     */
    managedVenues: Array<GetOffererVenueResponseModel>;
    /**
     * Name
     */
    name: string;
    /**
     * Siren
     */
    siren: string;
    /**
     * Venueswithnonfreeofferswithoutbankaccounts
     */
    venuesWithNonFreeOffersWithoutBankAccounts: Array<number>;
};

/**
 * GetOffererVenueResponseModel
 */
export type GetOffererVenueResponseModel = {
    activity: DisplayableActivity | null;
    bannerMeta: BannerMetaModel | null;
    /**
     * Bannerurl
     */
    bannerUrl: string | null;
    /**
     * Bookingemail
     */
    bookingEmail: string | null;
    /**
     * Hasadageid
     */
    hasAdageId: boolean;
    /**
     * Hascreatedoffer
     */
    hasCreatedOffer: boolean;
    /**
     * Hasvenueproviders
     */
    hasVenueProviders: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Ispermanent
     */
    isPermanent: boolean;
    lastCollectiveDmsApplication: DMSApplicationForEAC | null;
    /**
     * Name
     */
    name: string;
    /**
     * Publicname
     */
    publicName: string;
    /**
     * Siret
     */
    siret: string | null;
    state: VenueState | null;
    /**
     * Withdrawaldetails
     */
    withdrawalDetails: string | null;
};

/**
 * GetOfferersNamesResponseModel
 */
export type GetOfferersNamesResponseModel = {
    /**
     * Offerersnames
     */
    offerersNames: Array<GetOffererNameResponseModel>;
};

/**
 * GetProductInformations
 */
export type GetProductInformations = {
    /**
     * Author
     */
    author: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Ean
     */
    ean?: string | null;
    /**
     * Gtlid
     */
    gtlId: string;
    /**
     * Id
     */
    id: number;
    /**
     * Images
     */
    images: {
        [key: string]: unknown;
    };
    /**
     * Name
     */
    name: string;
    /**
     * Performer
     */
    performer: string;
    /**
     * Subcategoryid
     */
    subcategoryId: string;
};

/**
 * GetRejectedBankAccountsQueryModel
 */
export type GetRejectedBankAccountsQueryModel = {
    /**
     * Offererid
     */
    offererId: number;
};

/**
 * GetStocksResponseModel
 */
export type GetStocksResponseModel = {
    /**
     * Editedstockcount
     */
    editedStockCount: number;
    /**
     * Stocks
     */
    stocks: Array<GetOfferStockResponseModel>;
    /**
     * Totalstockcount
     */
    totalStockCount: number;
};

/**
 * GetVenueAddressResponseModel
 */
export type GetVenueAddressResponseModel = {
    /**
     * Addressid
     */
    addressId: number;
    /**
     * City
     */
    city: string;
    /**
     * Departmentcode
     */
    departmentCode: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Label
     */
    label: string | null;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Street
     */
    street: string | null;
    /**
     * Venueid
     */
    venueId: number;
    /**
     * Venuename
     */
    venueName: string | null;
};

/**
 * GetVenueAddressesQueryModel
 */
export type GetVenueAddressesQueryModel = {
    withOffersOption: GetVenueAddressesWithOffersOption;
};

/**
 * GetVenueAddressesResponseModel
 */
export type GetVenueAddressesResponseModel = Array<GetVenueAddressResponseModel>;

/**
 * GetVenueAddressesWithOffersOption
 */
export enum GetVenueAddressesWithOffersOption {
    INDIVIDUAL_OFFERS_ONLY = 'INDIVIDUAL_OFFERS_ONLY',
    COLLECTIVE_OFFERS_ONLY = 'COLLECTIVE_OFFERS_ONLY',
    COLLECTIVE_OFFER_TEMPLATES_ONLY = 'COLLECTIVE_OFFER_TEMPLATES_ONLY'
}

/**
 * GetVenueDomainResponseModel
 */
export type GetVenueDomainResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * GetVenueListResponseModel
 */
export type GetVenueListResponseModel = {
    /**
     * Venues
     */
    venues: Array<VenueListItemResponseModel>;
    /**
     * Venueswithpendingvalidation
     */
    venuesWithPendingValidation: Array<VenueListItemResponseModel>;
};

/**
 * GetVenueManagingOffererResponseModel
 */
export type GetVenueManagingOffererResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Isclosed
     */
    isClosed: boolean;
    /**
     * Isvalidated
     */
    isValidated: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Siren
     */
    siren: string;
};

/**
 * GetVenueOffersStatsV2ResponseModel
 */
export type GetVenueOffersStatsV2ResponseModel = {
    last3Months: VenueOffersPeriodStatsModel;
    last6Months: VenueOffersPeriodStatsModel;
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * GetVenuePricingPointResponseModel
 */
export type GetVenuePricingPointResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Siret
     */
    siret: string;
    /**
     * Venuename
     */
    venueName: string;
};

/**
 * GetVenueResponseModel
 */
export type GetVenueResponseModel = {
    activity: DisplayableActivity | null;
    /**
     * Adageinscriptiondate
     */
    adageInscriptionDate: string | null;
    /**
     * Allowedonadage
     */
    allowedOnAdage: boolean;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean | null;
    bankAccountStatus: SimplifiedBankAccountStatus | null;
    bannerMeta: BannerMetaModel | null;
    /**
     * Bannerurl
     */
    bannerUrl: string | null;
    /**
     * Bookingemail
     */
    bookingEmail: string | null;
    /**
     * Candisplayhighlights
     */
    canDisplayHighlights: boolean;
    /**
     * Collectivedescription
     */
    collectiveDescription: string | null;
    /**
     * Collectivedomains
     */
    collectiveDomains: Array<GetVenueDomainResponseModel>;
    /**
     * Collectiveemail
     */
    collectiveEmail: string | null;
    /**
     * Collectiveinterventionarea
     */
    collectiveInterventionArea: Array<string> | null;
    collectiveLegalStatus: LegalStatusResponseModel | null;
    /**
     * Collectivephone
     */
    collectivePhone: string | null;
    /**
     * Collectivestudents
     */
    collectiveStudents: Array<StudentLevels> | null;
    /**
     * Collectivewebsite
     */
    collectiveWebsite: string | null;
    /**
     * Comment
     */
    comment: string | null;
    contact: VenueContactModel | null;
    /**
     * Criteria
     */
    criteria: Array<string | CriteriaEnum>;
    /**
     * Datecreated
     */
    dateCreated: string;
    /**
     * Description
     */
    description: string | null;
    externalAccessibilityData: ExternalAccessibilityDataModel | null;
    /**
     * Externalaccessibilityid
     */
    externalAccessibilityId: string | null;
    /**
     * Hasactiveindividualoffer
     */
    hasActiveIndividualOffer: boolean;
    /**
     * Hasadageid
     */
    hasAdageId: boolean;
    /**
     * Hasatleastonebookableoffer
     */
    hasAtLeastOneBookableOffer: boolean;
    /**
     * Hashighlightrequest
     */
    hasHighlightRequest: boolean;
    /**
     * Hasnondraftoffers
     */
    hasNonDraftOffers: boolean;
    /**
     * Hasnonfreeoffers
     */
    hasNonFreeOffers: boolean;
    /**
     * Hasoffers
     */
    hasOffers: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Iscaledonian
     */
    isCaledonian: boolean;
    /**
     * Isonboarded
     */
    isOnboarded: boolean;
    /**
     * Isopentopublic
     */
    isOpenToPublic: boolean;
    /**
     * Ispermanent
     */
    isPermanent: boolean | null;
    /**
     * Ispricingpoint
     */
    isPricingPoint: boolean;
    /**
     * Isvalidated
     */
    isValidated: boolean;
    lastCollectiveDmsApplication: DMSApplicationForEAC | null;
    location: LocationResponseModelV2;
    managingOfferer: GetVenueManagingOffererResponseModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean | null;
    /**
     * Name
     */
    name: string;
    openingHours: WeekdayOpeningHoursTimespans | null;
    pricingPoint: GetVenuePricingPointResponseModel | null;
    /**
     * Publicname
     */
    publicName: string;
    /**
     * Siret
     */
    siret: string | null;
    state: VenueState | null;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean | null;
    /**
     * Volunteeringurl
     */
    volunteeringUrl: string | null;
    /**
     * Withdrawaldetails
     */
    withdrawalDetails: string | null;
};

/**
 * GetVenueStatsResponseModel
 */
export type GetVenueStatsResponseModel = {
    jsonData: VenueStatsDataModel;
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * GetVenuesOfOffererFromSiretResponseModel
 */
export type GetVenuesOfOffererFromSiretResponseModel = {
    /**
     * Offerername
     */
    offererName?: string | null;
    /**
     * Offerersiren
     */
    offererSiren?: string | null;
    /**
     * Venues
     */
    venues: Array<VenueOfOffererFromSiretResponseModel>;
};

/**
 * HasInvoiceQueryModel
 */
export type HasInvoiceQueryModel = {
    /**
     * Offererid
     */
    offererId: number;
};

/**
 * HasInvoiceResponseModel
 */
export type HasInvoiceResponseModel = {
    /**
     * Hasinvoice
     */
    hasInvoice: boolean;
};

/**
 * HasSettlementQueryModel
 */
export type HasSettlementQueryModel = {
    /**
     * Offererid
     */
    offererId: number;
};

/**
 * HasSettlementResponseModel
 */
export type HasSettlementResponseModel = {
    /**
     * Hassettlement
     */
    hasSettlement: boolean;
};

/**
 * HeadLineOfferResponseModel
 */
export type HeadLineOfferResponseModel = {
    /**
     * Id
     */
    id: number;
    image?: OfferImageV2 | null;
    /**
     * Name
     */
    name: string;
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * HeadlineOfferCreationBodyModel
 */
export type HeadlineOfferCreationBodyModel = {
    /**
     * Offerid
     */
    offerId: number;
};

/**
 * HeadlineOfferDeleteBodyModel
 */
export type HeadlineOfferDeleteBodyModel = {
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * HighlightResponseModel
 */
export type HighlightResponseModel = {
    /**
     * Availabilitydatespan
     */
    availabilityDatespan: Array<string>;
    /**
     * Communicationdate
     */
    communicationDate: string;
    /**
     * Description
     */
    description: string;
    /**
     * Highlightdatespan
     */
    highlightDatespan: Array<string>;
    /**
     * Id
     */
    id: number;
    /**
     * Mediationurl
     */
    mediationUrl: string;
    /**
     * Name
     */
    name: string;
};

/**
 * HighlightsResponseModel
 */
export type HighlightsResponseModel = Array<HighlightResponseModel>;

/**
 * HistoryStep
 */
export type HistoryStep = {
    /**
     * Datetime
     */
    datetime: string | null;
    status: CollectiveOfferDisplayedStatus;
};

/**
 * IndividualRevenue
 */
export type IndividualRevenue = {
    /**
     * Individual
     */
    individual: number;
};

/**
 * InviteMemberQueryModel
 */
export type InviteMemberQueryModel = {
    /**
     * Email
     */
    email: string;
};

/**
 * InvoiceListQueryModel
 */
export type InvoiceListQueryModel = {
    /**
     * Amountnegativeonly
     */
    amountNegativeOnly?: boolean | null;
    /**
     * Amountpositiveonly
     */
    amountPositiveOnly?: boolean | null;
    /**
     * Bankaccountid
     */
    bankAccountId?: number | null;
    /**
     * Offererid
     */
    offererId?: number | null;
    /**
     * Periodbeginningdate
     */
    periodBeginningDate?: string | null;
    /**
     * Periodendingdate
     */
    periodEndingDate?: string | null;
};

/**
 * InvoiceListResponseModel
 */
export type InvoiceListResponseModel = Array<InvoiceResponseModel>;

/**
 * InvoiceResponseModel
 */
export type InvoiceResponseModel = {
    /**
     * Amount
     */
    amount: number;
    /**
     * Date
     */
    date: string;
    /**
     * Reference
     */
    reference: string;
    status: InvoiceStatus;
    /**
     * Url
     */
    url: string;
};

/**
 * InvoiceStatus
 */
export enum InvoiceStatus {
    PENDING = 'pending',
    PENDING_PAYMENT = 'pending_payment',
    PAID = 'paid'
}

/**
 * LegalStatusResponseModel
 */
export type LegalStatusResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * LinkVenueToBankAccountBodyModel
 */
export type LinkVenueToBankAccountBodyModel = {
    /**
     * Venuesids
     */
    venuesIds: Array<number>;
};

/**
 * LinkVenueToPricingPointBodyModel
 */
export type LinkVenueToPricingPointBodyModel = {
    /**
     * Pricingpointid
     */
    pricingPointId: number;
};

/**
 * LinkedVenue
 *
 * A venue that is already linked to a bank account.
 */
export type LinkedVenue = {
    /**
     * Commonname
     */
    commonName: string;
    /**
     * Id
     */
    id: number;
    state: VenueState | null;
};

/**
 * ListCollectiveOfferTemplatesResponseModel
 */
export type ListCollectiveOfferTemplatesResponseModel = Array<CollectiveOfferTemplateResponseModel>;

/**
 * ListCollectiveOffersHomeQueryModel
 */
export type ListCollectiveOffersHomeQueryModel = {
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * ListCollectiveOffersHomeResponseModel
 */
export type ListCollectiveOffersHomeResponseModel = {
    /**
     * Hasoffers
     */
    hasOffers: boolean;
    /**
     * Offers
     */
    offers: Array<CollectiveOfferHomeResponseModel>;
};

/**
 * ListCollectiveOffersQueryModel
 */
export type ListCollectiveOffersQueryModel = {
    format?: EacFormat | null;
    locationType?: CollectiveLocationType | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Offereraddressid
     */
    offererAddressId?: number | null;
    /**
     * Offererid
     */
    offererId?: number | null;
    /**
     * Periodbeginningdate
     */
    periodBeginningDate?: string | null;
    /**
     * Periodendingdate
     */
    periodEndingDate?: string | null;
    /**
     * Status
     */
    status?: Array<CollectiveOfferDisplayedStatus> | null;
    /**
     * Venueid
     */
    venueId?: number | null;
};

/**
 * ListCollectiveOffersResponseModel
 */
export type ListCollectiveOffersResponseModel = Array<CollectiveOfferResponseModel>;

/**
 * ListFeatureResponseModel
 */
export type ListFeatureResponseModel = Array<FeatureResponseModel>;

/**
 * ListOffersHomeQueryModel
 */
export type ListOffersHomeQueryModel = {
    /**
     * Venueid
     */
    venueId: number;
};

/**
 * ListOffersHomeResponseModel
 */
export type ListOffersHomeResponseModel = Array<OfferHomeResponseModel>;

/**
 * ListOffersOfferResponseModel
 */
export type ListOffersOfferResponseModel = {
    /**
     * Bookingalloweddatetime
     */
    bookingAllowedDatetime?: string;
    /**
     * Bookingscount
     */
    bookingsCount?: number;
    /**
     * Highlightrequests
     */
    highlightRequests: Array<ShortHighlightResponseModel>;
    /**
     * Id
     */
    id: number;
    /**
     * Isevent
     */
    isEvent: boolean;
    /**
     * LocationResponseModel
     */
    location?: LocationResponseModel;
    /**
     * Name
     */
    name: string;
    /**
     * Productid
     */
    productId?: number;
    /**
     * Productisbn
     */
    productIsbn?: string;
    /**
     * Publicationdatetime
     */
    publicationDatetime?: string;
    status: OfferStatus;
    /**
     * Stocks
     */
    stocks: Array<ListOffersStockResponseModel>;
    subcategoryId: SubcategoryIdEnum;
    /**
     * Thumburl
     */
    thumbUrl?: string;
};

/**
 * ListOffersQueryModel
 */
export type ListOffersQueryModel = {
    /**
     * Categoryid
     */
    categoryId?: string;
    /**
     * Creationmode
     */
    creationMode?: string;
    /**
     * Nameorisbn
     */
    nameOrIsbn?: string;
    /**
     * Offereraddressid
     */
    offererAddressId?: number;
    /**
     * Periodbeginningdate
     */
    periodBeginningDate?: string;
    /**
     * Periodendingdate
     */
    periodEndingDate?: string;
    status?: OfferStatus;
    /**
     * Venueid
     */
    venueId?: number;
};

/**
 * ListOffersResponseModel
 */
export type ListOffersResponseModel = Array<ListOffersOfferResponseModel>;

/**
 * ListOffersStockResponseModel
 */
export type ListOffersStockResponseModel = {
    /**
     * Beginningdatetime
     */
    beginningDatetime?: string;
    /**
     * Id
     */
    id: number;
    /**
     * Remainingquantity
     */
    remainingQuantity: number | string;
};

/**
 * ListProviderResponse
 */
export type ListProviderResponse = Array<ProviderResponse>;

/**
 * ListVenueProviderResponse
 */
export type ListVenueProviderResponse = {
    /**
     * Venueproviders
     */
    venueProviders: Array<VenueProviderResponse>;
};

/**
 * LocationBodyModelV2
 */
export type LocationBodyModelV2 = {
    /**
     * Banid
     */
    banId?: string | null;
    /**
     * City
     */
    city: string;
    /**
     * Inseecode
     */
    inseeCode?: string | null;
    /**
     * Ismanualedition
     */
    isManualEdition?: boolean;
    /**
     * Isvenuelocation
     */
    isVenueLocation?: false;
    /**
     * Label
     */
    label?: string | null;
    /**
     * Latitude
     */
    latitude: number | string;
    /**
     * Longitude
     */
    longitude: number | string;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Street
     */
    street: string;
};

/**
 * LocationModelV2
 */
export type LocationModelV2 = {
    /**
     * Banid
     */
    banId?: string | null;
    /**
     * City
     */
    city: string;
    /**
     * Inseecode
     */
    inseeCode?: string | null;
    /**
     * Ismanualedition
     */
    isManualEdition?: boolean;
    /**
     * Isvenuelocation
     */
    isVenueLocation?: boolean;
    /**
     * Label
     */
    label?: string | null;
    /**
     * Latitude
     */
    latitude: string;
    /**
     * Longitude
     */
    longitude: string;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Street
     */
    street: string;
};

/**
 * LocationOnlyOnVenueBodyModelV2
 */
export type LocationOnlyOnVenueBodyModelV2 = {
    /**
     * Isvenuelocation
     */
    isVenueLocation?: true;
};

/**
 * LocationResponseModel
 */
export type LocationResponseModel = {
    /**
     * Banid
     */
    banId?: string;
    /**
     * City
     */
    city: string;
    /**
     * Departmentcode
     */
    departmentCode?: string;
    /**
     * Id
     */
    id: number;
    /**
     * Inseecode
     */
    inseeCode?: string;
    /**
     * Ismanualedition
     */
    isManualEdition: boolean;
    /**
     * Isvenuelocation
     */
    isVenueLocation: boolean;
    /**
     * Label
     */
    label?: string;
    /**
     * Latitude
     */
    latitude: number;
    /**
     * Longitude
     */
    longitude: number;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Street
     */
    street?: string;
};

/**
 * LocationResponseModelV2
 */
export type LocationResponseModelV2 = {
    /**
     * Banid
     */
    banId: string | null;
    /**
     * City
     */
    city: string;
    /**
     * Departmentcode
     */
    departmentCode: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Inseecode
     */
    inseeCode: string | null;
    /**
     * Ismanualedition
     */
    isManualEdition: boolean;
    /**
     * Isvenuelocation
     */
    isVenueLocation: boolean;
    /**
     * Label
     */
    label: string | null;
    /**
     * Latitude
     */
    latitude: number;
    /**
     * Longitude
     */
    longitude: number;
    /**
     * Postalcode
     */
    postalCode: string;
    /**
     * Street
     */
    street: string | null;
};

/**
 * LoginUserBodyModel
 */
export type LoginUserBodyModel = {
    /**
     * Captchatoken
     */
    captchaToken?: string | null;
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Password
     */
    password: string;
};

/**
 * ManagedVenue
 */
export type ManagedVenue = {
    /**
     * Bankaccountid
     */
    bankAccountId: number | null;
    /**
     * Commonname
     */
    commonName: string;
    /**
     * Haspricingpoint
     */
    hasPricingPoint: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Siret
     */
    siret: string | null;
    state: VenueState | null;
};

/**
 * MentalDisabilityModel
 */
export type MentalDisabilityModel = {
    /**
     * Trainedpersonnel
     */
    trainedPersonnel?: string;
};

/**
 * MotorDisabilityModel
 */
export type MotorDisabilityModel = {
    /**
     * Entrance
     */
    entrance?: string;
    /**
     * Exterior
     */
    exterior?: string;
    /**
     * Facilities
     */
    facilities?: string;
    /**
     * Parking
     */
    parking?: string;
};

/**
 * MusicTypeResponse
 */
export type MusicTypeResponse = {
    /**
     * Canbeevent
     */
    canBeEvent: boolean;
    /**
     * Gtl Id
     */
    gtl_id: string;
    /**
     * Label
     */
    label: string;
};

/**
 * NationalProgramResponseModel
 */
export type NationalProgramResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * NatureEnum
 */
export enum NatureEnum {
    BIEN = 'BIEN',
    CARTE_ABONNEMENT = 'CARTE_ABONNEMENT',
    EVENEMENT = 'EVENEMENT',
    NUMERIQUE = 'NUMERIQUE'
}

/**
 * NatureFormatDomainListResponseModel
 */
export type NatureFormatDomainListResponseModel = Array<NatureFormatDomainResponseModel>;

/**
 * NatureFormatDomainResponseModel
 */
export type NatureFormatDomainResponseModel = {
    /**
     * Formats
     */
    formats: Array<FormatResponseModel>;
    /**
     * Label
     */
    label: string;
    name: NatureEnum;
};

/**
 * NewPasswordBodyModel
 */
export type NewPasswordBodyModel = {
    /**
     * Newpassword
     */
    newPassword: string;
    /**
     * Token
     */
    token: string;
};

/**
 * OfferContactFormEnum
 */
export enum OfferContactFormEnum {
    FORM = 'form'
}

/**
 * OfferDomain
 */
export type OfferDomain = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * OfferExtraData
 */
export type OfferExtraData = {
    /**
     * Allocineid
     */
    allocineId?: number;
    /**
     * Artist
     */
    artist?: string;
    /**
     * Author
     */
    author?: string;
    /**
     * Backlink
     */
    backlink?: string;
    /**
     * Bookformat
     */
    bookFormat?: string;
    /**
     * Cast
     */
    cast?: Array<string>;
    /**
     * Certificate
     */
    certificate?: string;
    /**
     * Code Clil
     */
    code_clil?: string;
    /**
     * Collection
     */
    collection?: string;
    /**
     * Comic Series
     */
    comic_series?: string;
    /**
     * Comment
     */
    comment?: string;
    /**
     * Companies
     */
    companies?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Contenu Explicite
     */
    contenu_explicite?: string;
    /**
     * Countries
     */
    countries?: Array<string>;
    /**
     * Credits
     */
    credits?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Csr Id
     */
    csr_id?: string;
    /**
     * Date Parution
     */
    date_parution?: string;
    /**
     * Dewey
     */
    dewey?: string;
    /**
     * Diffusionversion
     */
    diffusionVersion?: string;
    /**
     * Dispo
     */
    dispo?: number;
    /**
     * Dispo Label
     */
    dispo_label?: string;
    /**
     * Distributeur
     */
    distributeur?: string;
    /**
     * Ean
     */
    ean?: string;
    /**
     * Editeur
     */
    editeur?: string;
    /**
     * Eidr
     */
    eidr?: string;
    /**
     * Genres
     */
    genres?: Array<string>;
    /**
     * Gtl Id
     */
    gtl_id?: string;
    /**
     * Langue
     */
    langue?: string;
    /**
     * Langueiso
     */
    langueiso?: string;
    /**
     * Musicsubtype
     */
    musicSubType?: string;
    /**
     * Musictype
     */
    musicType?: string;
    /**
     * Music Label
     */
    music_label?: string;
    /**
     * Nb Galettes
     */
    nb_galettes?: string;
    /**
     * Nb Pages
     */
    nb_pages?: string;
    /**
     * Num In Collection
     */
    num_in_collection?: string;
    /**
     * Originaltitle
     */
    originalTitle?: string;
    /**
     * Performer
     */
    performer?: string;
    /**
     * Posterurl
     */
    posterUrl?: string;
    /**
     * Prix Livre
     */
    prix_livre?: string;
    /**
     * Prix Musique
     */
    prix_musique?: string;
    /**
     * Productionyear
     */
    productionYear?: number;
    /**
     * Rayon
     */
    rayon?: string;
    /**
     * Releasedate
     */
    releaseDate?: string;
    /**
     * Releases
     */
    releases?: Array<{
        [key: string]: unknown;
    }>;
    /**
     * Runtime
     */
    runtime?: number;
    /**
     * Schoolbook
     */
    schoolbook?: boolean;
    /**
     * Showsubtype
     */
    showSubType?: string;
    /**
     * Showtype
     */
    showType?: string;
    /**
     * Speaker
     */
    speaker?: string;
    /**
     * Stagedirector
     */
    stageDirector?: string;
    /**
     * Synopsis
     */
    synopsis?: string;
    /**
     * Theater
     */
    theater?: {
        [key: string]: unknown;
    };
    /**
     * Titelive Regroup
     */
    titelive_regroup?: string;
    /**
     * Title
     */
    title?: string;
    /**
     * Top
     */
    top?: string;
    /**
     * Type
     */
    type?: string;
    /**
     * Visa
     */
    visa?: string;
};

/**
 * OfferExtraDataV2
 */
export type OfferExtraDataV2 = {
    /**
     * Allocineid
     */
    allocineId?: number | null;
    /**
     * Artist
     */
    artist?: string | null;
    /**
     * Author
     */
    author?: string | null;
    /**
     * Backlink
     */
    backlink?: string | null;
    /**
     * Bookformat
     */
    bookFormat?: string | null;
    /**
     * Cast
     */
    cast?: Array<string> | null;
    /**
     * Certificate
     */
    certificate?: string | null;
    /**
     * Code Clil
     */
    code_clil?: string | null;
    /**
     * Collection
     */
    collection?: string | null;
    /**
     * Comic Series
     */
    comic_series?: string | null;
    /**
     * Comment
     */
    comment?: string | null;
    /**
     * Companies
     */
    companies?: Array<{
        [key: string]: unknown;
    }> | null;
    /**
     * Contenu Explicite
     */
    contenu_explicite?: string | null;
    /**
     * Countries
     */
    countries?: Array<string> | null;
    /**
     * Credits
     */
    credits?: Array<{
        [key: string]: unknown;
    }> | null;
    /**
     * Csr Id
     */
    csr_id?: string | null;
    /**
     * Date Parution
     */
    date_parution?: string | null;
    /**
     * Dewey
     */
    dewey?: string | null;
    /**
     * Diffusionversion
     */
    diffusionVersion?: string | null;
    /**
     * Dispo
     */
    dispo?: number | null;
    /**
     * Dispo Label
     */
    dispo_label?: string | null;
    /**
     * Distributeur
     */
    distributeur?: string | null;
    /**
     * Ean
     */
    ean?: string | null;
    /**
     * Editeur
     */
    editeur?: string | null;
    /**
     * Eidr
     */
    eidr?: string | null;
    /**
     * Genres
     */
    genres?: Array<string> | null;
    /**
     * Gtl Id
     */
    gtl_id?: string | null;
    /**
     * Langue
     */
    langue?: string | null;
    /**
     * Langueiso
     */
    langueiso?: string | null;
    /**
     * Musicsubtype
     */
    musicSubType?: string | null;
    /**
     * Musictype
     */
    musicType?: string | null;
    /**
     * Music Label
     */
    music_label?: string | null;
    /**
     * Nb Galettes
     */
    nb_galettes?: string | null;
    /**
     * Nb Pages
     */
    nb_pages?: string | null;
    /**
     * Num In Collection
     */
    num_in_collection?: string | null;
    /**
     * Originaltitle
     */
    originalTitle?: string | null;
    /**
     * Performer
     */
    performer?: string | null;
    /**
     * Posterurl
     */
    posterUrl?: string | null;
    /**
     * Prix Livre
     */
    prix_livre?: string | null;
    /**
     * Prix Musique
     */
    prix_musique?: string | null;
    /**
     * Productionyear
     */
    productionYear?: number | null;
    /**
     * Rayon
     */
    rayon?: string | null;
    /**
     * Releasedate
     */
    releaseDate?: string | null;
    /**
     * Releases
     */
    releases?: Array<{
        [key: string]: unknown;
    }> | null;
    /**
     * Runtime
     */
    runtime?: number | null;
    /**
     * Schoolbook
     */
    schoolbook?: boolean | null;
    /**
     * Showsubtype
     */
    showSubType?: string | null;
    /**
     * Showtype
     */
    showType?: string | null;
    /**
     * Speaker
     */
    speaker?: string | null;
    /**
     * Stagedirector
     */
    stageDirector?: string | null;
    /**
     * Synopsis
     */
    synopsis?: string | null;
    /**
     * Theater
     */
    theater?: {
        [key: string]: unknown;
    } | null;
    /**
     * Titelive Regroup
     */
    titelive_regroup?: string | null;
    /**
     * Title
     */
    title?: string | null;
    /**
     * Top
     */
    top?: string | null;
    /**
     * Type
     */
    type?: string | null;
    /**
     * Visa
     */
    visa?: string | null;
};

/**
 * OfferHomeResponseModel
 */
export type OfferHomeResponseModel = {
    /**
     * Bookingscount
     */
    bookingsCount: number;
    /**
     * Departmentcode
     */
    departmentCode: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Isevent
     */
    isEvent: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Publicationdatetime
     */
    publicationDatetime: string | null;
    status: OfferStatus;
    /**
     * Stocks
     */
    stocks: Array<StockHomeResponseModel>;
    /**
     * Thumburl
     */
    thumbUrl: string | null;
};

/**
 * OfferImage
 */
export type OfferImage = {
    /**
     * Credit
     */
    credit?: string | null;
    /**
     * Url
     */
    url: string;
};

/**
 * OfferImageV2
 */
export type OfferImageV2 = {
    /**
     * Credit
     */
    credit?: string | null;
    /**
     * Url
     */
    url: string;
};

/**
 * OfferStatus
 *
 * An enumeration.
 */
export enum OfferStatus {
    DRAFT = 'DRAFT',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    INACTIVE = 'INACTIVE',
    SCHEDULED = 'SCHEDULED',
    PUBLISHED = 'PUBLISHED',
    ACTIVE = 'ACTIVE',
    SOLD_OUT = 'SOLD_OUT',
    EXPIRED = 'EXPIRED'
}

/**
 * OffererMemberStatus
 */
export enum OffererMemberStatus {
    VALIDATED = 'validated',
    PENDING = 'pending'
}

/**
 * PatchAllOffersActiveStatusBodyModel
 */
export type PatchAllOffersActiveStatusBodyModel = {
    /**
     * Categoryid
     */
    categoryId?: string;
    /**
     * Creationmode
     */
    creationMode?: string;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Nameorisbn
     */
    nameOrIsbn?: string;
    /**
     * Offereraddressid
     */
    offererAddressId?: number;
    /**
     * Offererid
     */
    offererId?: number;
    /**
     * Periodbeginningdate
     */
    periodBeginningDate?: string;
    /**
     * Periodendingdate
     */
    periodEndingDate?: string;
    status?: OfferStatus;
    /**
     * Venueid
     */
    venueId?: number;
};

/**
 * PatchCollectiveOfferActiveStatusBodyModel
 */
export type PatchCollectiveOfferActiveStatusBodyModel = {
    /**
     * Ids
     */
    ids: Array<number>;
    /**
     * Isactive
     */
    isActive: boolean;
};

/**
 * PatchCollectiveOfferArchiveBodyModel
 */
export type PatchCollectiveOfferArchiveBodyModel = {
    /**
     * Ids
     */
    ids: Array<number>;
};

/**
 * PatchCollectiveOfferBodyModel
 */
export type PatchCollectiveOfferBodyModel = {
    /**
     * Additionaldetails
     */
    additionalDetails?: string | null;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean | null;
    /**
     * Bookingemails
     */
    bookingEmails?: Array<string> | null;
    /**
     * Contactemail
     */
    contactEmail?: string | null;
    /**
     * Contactphone
     */
    contactPhone?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Domains
     */
    domains?: Array<number> | null;
    /**
     * Durationminutes
     */
    durationMinutes?: number | null;
    /**
     * Formats
     */
    formats?: Array<EacFormat> | null;
    /**
     * Interventionarea
     */
    interventionArea?: Array<string> | null;
    location?: CollectiveOfferLocationModel | null;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Nationalprogramid
     */
    nationalProgramId?: number | null;
    /**
     * Students
     */
    students?: Array<StudentLevels> | null;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean | null;
};

/**
 * PatchCollectiveOfferEducationalInstitution
 */
export type PatchCollectiveOfferEducationalInstitution = {
    /**
     * Educationalinstitutionid
     */
    educationalInstitutionId: number;
    /**
     * Teacheremail
     */
    teacherEmail?: string | null;
};

/**
 * PatchCollectiveOfferTemplateBodyModel
 */
export type PatchCollectiveOfferTemplateBodyModel = {
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean | null;
    /**
     * Bookingemails
     */
    bookingEmails?: Array<string> | null;
    /**
     * Contactemail
     */
    contactEmail?: string | null;
    contactForm?: OfferContactFormEnum | null;
    /**
     * Contactphone
     */
    contactPhone?: string | null;
    /**
     * Contacturl
     */
    contactUrl?: string | null;
    dates?: PatchDateRangeModel | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Domains
     */
    domains?: Array<number> | null;
    /**
     * Durationminutes
     */
    durationMinutes?: number | null;
    /**
     * Formats
     */
    formats?: Array<EacFormat> | null;
    /**
     * Interventionarea
     */
    interventionArea?: Array<string> | null;
    location?: CollectiveOfferLocationModel | null;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Nationalprogramid
     */
    nationalProgramId?: number | null;
    /**
     * Pricedetail
     */
    priceDetail?: string | null;
    /**
     * Students
     */
    students?: Array<StudentLevels> | null;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean | null;
};

/**
 * PatchDateRangeModel
 */
export type PatchDateRangeModel = {
    /**
     * End
     */
    end: string;
    /**
     * Start
     */
    start: string;
};

/**
 * PatchOfferActiveStatusBodyModel
 */
export type PatchOfferActiveStatusBodyModel = {
    /**
     * Ids
     */
    ids: Array<number>;
    /**
     * Isactive
     */
    isActive: boolean;
};

/**
 * PatchOfferBodyModel
 */
export type PatchOfferBodyModel = {
    /**
     * Artistofferlinks
     */
    artistOfferLinks?: Array<ArtistOfferLinkBodyModelV2> | null;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant?: boolean | null;
    /**
     * Bookingalloweddatetime
     */
    bookingAllowedDatetime?: string | null;
    /**
     * Bookingcontact
     */
    bookingContact?: string | null;
    /**
     * Bookingemail
     */
    bookingEmail?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Durationminutes
     */
    durationMinutes?: number | null;
    /**
     * Externalticketofficeurl
     */
    externalTicketOfficeUrl?: string | null;
    extraData?: OfferExtraDataV2 | null;
    /**
     * Hasculturaloutreachclaim
     */
    hasCulturalOutreachClaim?: boolean | null;
    /**
     * Isduo
     */
    isDuo?: boolean | null;
    /**
     * Isnational
     */
    isNational?: boolean | null;
    /**
     * Location
     */
    location?: ({
        isVenueLocation: false;
    } & LocationBodyModelV2) | ({
        isVenueLocation: true;
    } & LocationOnlyOnVenueBodyModelV2) | null;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant?: boolean | null;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant?: boolean | null;
    /**
     * Name
     */
    name?: string | null;
    /**
     * Publicationdatetime
     */
    publicationDatetime?: string | 'now' | null;
    /**
     * Shouldsendmail
     */
    shouldSendMail?: boolean | null;
    /**
     * Subcategoryid
     */
    subcategoryId?: string | null;
    /**
     * Url
     */
    url?: string | null;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant?: boolean | null;
    /**
     * Withdrawaldelay
     */
    withdrawalDelay?: number | null;
    /**
     * Withdrawaldetails
     */
    withdrawalDetails?: string | null;
    withdrawalType?: WithdrawalTypeEnum | null;
};

/**
 * PatchOfferPublishBodyModel
 */
export type PatchOfferPublishBodyModel = {
    /**
     * Bookingalloweddatetime
     */
    bookingAllowedDatetime?: string;
    /**
     * Id
     */
    id: number;
    /**
     * Publicationdatetime
     */
    publicationDatetime?: string;
};

/**
 * PhoneValidationStatusType
 */
export enum PhoneValidationStatusType {
    SKIPPED_BY_SUPPORT = 'skipped-by-support',
    UNVALIDATED = 'unvalidated',
    VALIDATED = 'validated'
}

/**
 * PostCollectiveOfferBodyModel
 */
export type PostCollectiveOfferBodyModel = {
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean;
    /**
     * Bookingemails
     */
    bookingEmails?: Array<string> | null;
    /**
     * Contactemail
     */
    contactEmail?: string | null;
    /**
     * Contactphone
     */
    contactPhone?: string | null;
    /**
     * Description
     */
    description: string;
    /**
     * Domains
     */
    domains: Array<number>;
    /**
     * Durationminutes
     */
    durationMinutes?: number | null;
    /**
     * Formats
     */
    formats: Array<EacFormat>;
    /**
     * Interventionarea
     */
    interventionArea: Array<string> | null;
    location: CollectiveOfferLocationModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Nationalprogramid
     */
    nationalProgramId?: number | null;
    /**
     * Students
     */
    students: Array<StudentLevels>;
    /**
     * Templateid
     */
    templateId?: number | null;
    /**
     * Venueid
     */
    venueId: number;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean;
};

/**
 * PostCollectiveOfferTemplateBodyModel
 */
export type PostCollectiveOfferTemplateBodyModel = {
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean;
    /**
     * Bookingemails
     */
    bookingEmails?: Array<string> | null;
    /**
     * Contactemail
     */
    contactEmail?: string | null;
    contactForm?: OfferContactFormEnum | null;
    /**
     * Contactphone
     */
    contactPhone?: string | null;
    /**
     * Contacturl
     */
    contactUrl?: string | null;
    dates?: PostDateRangeModel | null;
    /**
     * Description
     */
    description: string;
    /**
     * Domains
     */
    domains: Array<number>;
    /**
     * Durationminutes
     */
    durationMinutes?: number | null;
    /**
     * Formats
     */
    formats: Array<EacFormat>;
    /**
     * Interventionarea
     */
    interventionArea: Array<string> | null;
    location: CollectiveOfferLocationModel;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Nationalprogramid
     */
    nationalProgramId?: number | null;
    /**
     * Pricedetail
     */
    priceDetail?: string | null;
    /**
     * Students
     */
    students: Array<StudentLevels>;
    /**
     * Templateid
     */
    templateId?: number | null;
    /**
     * Venueid
     */
    venueId: number;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean;
};

/**
 * PostDateRangeModel
 */
export type PostDateRangeModel = {
    /**
     * End
     */
    end: string;
    /**
     * Start
     */
    start: string;
};

/**
 * PostOfferBodyModel
 */
export type PostOfferBodyModel = {
    /**
     * Artistofferlinks
     */
    artistOfferLinks: Array<ArtistOfferLinkBodyModelV2> | null;
    /**
     * Audiodisabilitycompliant
     */
    audioDisabilityCompliant: boolean;
    /**
     * Description
     */
    description: string | null;
    /**
     * Durationminutes
     */
    durationMinutes: number | null;
    extraData: OfferExtraDataV2 | null;
    /**
     * Hasculturaloutreachclaim
     */
    hasCulturalOutreachClaim: boolean | null;
    /**
     * Mentaldisabilitycompliant
     */
    mentalDisabilityCompliant: boolean;
    /**
     * Motordisabilitycompliant
     */
    motorDisabilityCompliant: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Productid
     */
    productId: number | null;
    /**
     * Subcategoryid
     */
    subcategoryId: string;
    /**
     * Venueid
     */
    venueId: number;
    /**
     * Visualdisabilitycompliant
     */
    visualDisabilityCompliant: boolean;
};

/**
 * PostOffererResponseModel
 */
export type PostOffererResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Siren
     */
    siren: string;
};

/**
 * PostVenueProviderBody
 */
export type PostVenueProviderBody = {
    /**
     * Isactive
     */
    isActive?: boolean | null;
    /**
     * Isduo
     */
    isDuo?: boolean | null;
    /**
     * Price
     */
    price?: number | null;
    /**
     * Providerid
     */
    providerId: number;
    /**
     * Quantity
     */
    quantity?: number | null;
    /**
     * Venueidatofferprovider
     */
    venueIdAtOfferProvider?: string | null;
};

/**
 * PriceCategoryBody
 */
export type PriceCategoryBody = {
    /**
     * Pricecategories
     */
    priceCategories: Array<UpsertPriceCategoryModel>;
};

/**
 * PriceCategoryResponseModel
 */
export type PriceCategoryResponseModel = {
    /**
     * Hasstocks
     */
    hasStocks: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Label
     */
    label: string;
    /**
     * Price
     */
    price: number;
};

/**
 * ProAnonymizationEligibilityResponseModel
 */
export type ProAnonymizationEligibilityResponseModel = {
    /**
     * Hassuspendedofferer
     */
    hasSuspendedOfferer: boolean;
    /**
     * Isonlypro
     */
    isOnlyPro: boolean;
    /**
     * Issoleuserwithongoingactivities
     */
    isSoleUserWithOngoingActivities: boolean;
};

/**
 * ProUserCreationBodyV2Model
 */
export type ProUserCreationBodyV2Model = {
    /**
     * Contactok
     */
    contactOk: boolean;
    /**
     * Email
     */
    email: string;
    /**
     * Firstname
     */
    firstName: string;
    /**
     * Lastname
     */
    lastName: string;
    /**
     * Password
     */
    password: string;
    /**
     * Phonenumber
     */
    phoneNumber?: string | null;
    structureSimulationInfos?: SignupSimulationPayload | null;
    /**
     * Token
     */
    token: string;
};

/**
 * ProviderResponse
 */
export type ProviderResponse = {
    /**
     * Enabledforpro
     */
    enabledForPro: boolean;
    /**
     * Hasoffererprovider
     */
    hasOffererProvider: boolean;
    /**
     * Id
     */
    id: number;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Name
     */
    name: string;
};

/**
 * PutVenueProviderBody
 */
export type PutVenueProviderBody = {
    /**
     * Isactive
     */
    isActive?: boolean | null;
    /**
     * Isduo
     */
    isDuo?: boolean | null;
    /**
     * Price
     */
    price?: number | null;
    /**
     * Quantity
     */
    quantity?: number | null;
    /**
     * Venueidatofferprovider
     */
    venueIdAtOfferProvider?: string | null;
};

/**
 * ReimbursementCsvByInvoicesModel
 */
export type ReimbursementCsvByInvoicesModel = {
    /**
     * Invoicesreferences
     */
    invoicesReferences: Array<string>;
};

/**
 * RejectedBankAccountResponseModel
 */
export type RejectedBankAccountResponseModel = {
    /**
     * Detachedvenues
     */
    detachedVenues: Array<DetachedVenueResponseModel>;
    /**
     * Id
     */
    id: number;
    /**
     * Label
     */
    label: string;
    /**
     * Obfuscatediban
     */
    obfuscatedIban: string;
    /**
     * Rejectedsettlementlabel
     */
    rejectedSettlementLabel: string;
};

/**
 * RejectedBankAccountsResponseModel
 */
export type RejectedBankAccountsResponseModel = Array<RejectedBankAccountResponseModel>;

/**
 * ResetPasswordBodyModel
 */
export type ResetPasswordBodyModel = {
    /**
     * Email
     */
    email: string;
    /**
     * Token
     */
    token: string;
};

/**
 * SaveNewOnboardingDataQueryModel
 */
export type SaveNewOnboardingDataQueryModel = {
    /**
     * Activity
     */
    activity: ActivityOpenToPublic | ActivityNotOpenToPublic;
    address: LocationBodyModelV2;
    /**
     * Createvenuewithoutsiret
     */
    createVenueWithoutSiret?: boolean;
    /**
     * Culturaldomains
     */
    culturalDomains?: Array<string> | null;
    /**
     * Isopentopublic
     */
    isOpenToPublic: boolean;
    /**
     * Otheractivitycomment
     */
    otherActivityComment?: string | null;
    /**
     * Phonenumber
     */
    phoneNumber?: string | null;
    /**
     * Publicname
     */
    publicName?: string | null;
    /**
     * Siret
     */
    siret: string;
    target: Target;
    /**
     * Token
     */
    token: string;
    /**
     * Webpresence
     */
    webPresence: string;
};

/**
 * SettlementDisplayedStatus
 */
export enum SettlementDisplayedStatus {
    EXECUTED = 'EXECUTED',
    REJECTED_UNRESOLVED = 'REJECTED_UNRESOLVED',
    REJECTED_PROCESSED = 'REJECTED_PROCESSED',
    REJECTED_SOLVED = 'REJECTED_SOLVED'
}

/**
 * SettlementListQueryModel
 */
export type SettlementListQueryModel = {
    /**
     * Bankaccountid
     */
    bankAccountId?: number | null;
    /**
     * Namesearch
     */
    nameSearch?: string | null;
    /**
     * Offererid
     */
    offererId: number;
    /**
     * Periodbeginningdate
     */
    periodBeginningDate?: string | null;
    /**
     * Periodendingdate
     */
    periodEndingDate?: string | null;
};

/**
 * SettlementListResponseModel
 */
export type SettlementListResponseModel = Array<SettlementResponseModel>;

/**
 * SettlementResponseModel
 */
export type SettlementResponseModel = {
    /**
     * Amount
     */
    amount: number;
    /**
     * Bankaccount
     */
    bankAccount: string;
    /**
     * Date
     */
    date: string | null;
    /**
     * Id
     */
    id: number;
    /**
     * Invoices
     */
    invoices: Array<InvoiceResponseModel>;
    /**
     * Label
     */
    label: string | null;
    /**
     * Resolvedby
     */
    resolvedBy: Array<string>;
    status: SettlementDisplayedStatus;
};

/**
 * SharedCurrentUserResponseModel
 */
export type SharedCurrentUserResponseModel = {
    /**
     * Activity
     */
    activity?: string | null;
    /**
     * Address
     */
    address?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Datecreated
     */
    dateCreated: string;
    /**
     * Dateofbirth
     */
    dateOfBirth?: string | null;
    /**
     * Departementcode
     */
    departementCode?: string | null;
    /**
     * Email
     */
    email: string;
    /**
     * Externalids
     */
    externalIds?: {
        [key: string]: unknown;
    } | null;
    /**
     * Firstname
     */
    firstName?: string | null;
    /**
     * Hasuserofferer
     */
    hasUserOfferer?: boolean | null;
    /**
     * Id
     */
    id: number;
    /**
     * Idpiecenumber
     */
    idPieceNumber?: string | null;
    /**
     * Isemailvalidated
     */
    isEmailValidated: boolean;
    /**
     * Isimpersonated
     */
    isImpersonated?: boolean;
    /**
     * Lastconnectiondate
     */
    lastConnectionDate?: string | null;
    /**
     * Lastname
     */
    lastName?: string | null;
    /**
     * Needstofillculturalsurvey
     */
    needsToFillCulturalSurvey?: boolean | null;
    /**
     * Notificationsubscriptions
     */
    notificationSubscriptions?: {
        [key: string]: unknown;
    } | null;
    /**
     * Phonenumber
     */
    phoneNumber?: string | null;
    phoneValidationStatus?: PhoneValidationStatusType | null;
    /**
     * Postalcode
     */
    postalCode?: string | null;
    /**
     * Roles
     */
    roles: Array<UserRole>;
};

/**
 * SharedLoginUserResponseModel
 */
export type SharedLoginUserResponseModel = {
    /**
     * Activity
     */
    activity?: string | null;
    /**
     * Address
     */
    address?: string | null;
    /**
     * City
     */
    city?: string | null;
    /**
     * Datecreated
     */
    dateCreated: string;
    /**
     * Dateofbirth
     */
    dateOfBirth?: string | null;
    /**
     * Departementcode
     */
    departementCode?: string | null;
    /**
     * Email
     */
    email: string;
    /**
     * Firstname
     */
    firstName?: string | null;
    /**
     * Hasuserofferer
     */
    hasUserOfferer?: boolean | null;
    /**
     * Id
     */
    id: number;
    /**
     * Isemailvalidated
     */
    isEmailValidated: boolean;
    /**
     * Lastconnectiondate
     */
    lastConnectionDate?: string | null;
    /**
     * Lastname
     */
    lastName?: string | null;
    /**
     * Needstofillculturalsurvey
     */
    needsToFillCulturalSurvey?: boolean | null;
    /**
     * Phonenumber
     */
    phoneNumber?: string | null;
    /**
     * Postalcode
     */
    postalCode?: string | null;
    /**
     * Roles
     */
    roles: Array<UserRole>;
};

/**
 * ShortHighlightResponseModel
 */
export type ShortHighlightResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * SignupSimulationMessageLevel
 */
export enum SignupSimulationMessageLevel {
    INFO = 'INFO',
    ALERT = 'ALERT'
}

/**
 * SignupSimulationMessageModel
 */
export type SignupSimulationMessageModel = {
    level: SignupSimulationMessageLevel;
    type: SignupSimulationMessageType;
};

/**
 * SignupSimulationMessageType
 */
export enum SignupSimulationMessageType {
    COLLECTIVE = 'COLLECTIVE',
    BOOKSTORE = 'BOOKSTORE',
    UNUSUAL_APE_CODE = 'UNUSUAL_APE_CODE'
}

/**
 * SignupSimulationPayload
 */
export type SignupSimulationPayload = {
    /**
     * Activity
     */
    activity: ActivityOpenToPublic | ActivityNotOpenToPublic;
    /**
     * Isopentopublic
     */
    isOpenToPublic: boolean;
    /**
     * Siret
     */
    siret: string;
    /**
     * Targets
     */
    targets: Array<TargetAudience>;
};

/**
 * SignupSimulationResponseModel
 */
export type SignupSimulationResponseModel = {
    /**
     * Eligibilitydocuments
     */
    eligibilityDocuments: Array<EligibilityDocument>;
    /**
     * Messages
     */
    messages: Array<SignupSimulationMessageModel>;
};

/**
 * SignupSimulationSummaryPayload
 */
export type SignupSimulationSummaryPayload = {
    /**
     * Activity
     */
    activity: ActivityOpenToPublic | ActivityNotOpenToPublic;
    /**
     * Email
     */
    email: string;
    /**
     * Isopentopublic
     */
    isOpenToPublic: boolean;
    /**
     * Siret
     */
    siret: string;
    /**
     * Targets
     */
    targets: Array<TargetAudience>;
};

/**
 * SimplifiedBankAccountStatus
 */
export enum SimplifiedBankAccountStatus {
    PENDING = 'pending',
    VALID = 'valid',
    PENDING_CORRECTIONS = 'pending_corrections'
}

/**
 * StatisticsModel
 */
export type StatisticsModel = {
    /**
     * Incomebyyear
     */
    incomeByYear: {
        [key: string]: AggregatedRevenueModel | {
            [key: string]: null;
        };
    };
};

/**
 * StatisticsQueryModel
 */
export type StatisticsQueryModel = {
    /**
     * Venueids
     */
    venueIds?: Array<number>;
};

/**
 * StockHomeResponseModel
 */
export type StockHomeResponseModel = {
    /**
     * Beginningdatetime
     */
    beginningDatetime: string | null;
};

/**
 * StockStatsResponseModel
 */
export type StockStatsResponseModel = {
    /**
     * Neweststock
     */
    newestStock?: string;
    /**
     * Oldeststock
     */
    oldestStock?: string;
    /**
     * Remainingquantity
     */
    remainingQuantity?: number;
    /**
     * Stockcount
     */
    stockCount?: number;
};

/**
 * StocksOrderedBy
 *
 * An enumeration.
 */
export enum StocksOrderedBy {
    DATE = 'DATE',
    TIME = 'TIME',
    BEGINNING_DATETIME = 'BEGINNING_DATETIME',
    PRICE_CATEGORY_ID = 'PRICE_CATEGORY_ID',
    BOOKING_LIMIT_DATETIME = 'BOOKING_LIMIT_DATETIME',
    REMAINING_QUANTITY = 'REMAINING_QUANTITY',
    DN_BOOKED_QUANTITY = 'DN_BOOKED_QUANTITY'
}

/**
 * StocksQueryModel
 */
export type StocksQueryModel = {
    /**
     * Date
     */
    date?: string;
    /**
     * Only Future Stocks
     */
    only_future_stocks?: boolean;
    order_by?: StocksOrderedBy;
    /**
     * Order By Desc
     */
    order_by_desc?: boolean;
    /**
     * Page
     */
    page?: number;
    /**
     * Price Category Id
     */
    price_category_id?: number;
    /**
     * Stocks Limit Per Page
     */
    stocks_limit_per_page?: number;
    /**
     * Time
     */
    time?: string;
};

/**
 * StructureDataBodyModel
 */
export type StructureDataBodyModel = {
    /**
     * Apecode
     */
    apeCode: string | null;
    /**
     * Isdiffusible
     */
    isDiffusible: boolean;
    location: LocationModelV2 | null;
    /**
     * Name
     */
    name: string | null;
    /**
     * Siren
     */
    siren: string | null;
    /**
     * Siret
     */
    siret: string;
};

/**
 * StudentLevels
 */
export enum StudentLevels {
    _COLES_MARSEILLE_MATERNELLE = 'Écoles Marseille - Maternelle',
    _COLES_MARSEILLE_CP_CE1_CE2 = 'Écoles Marseille - CP, CE1, CE2',
    _COLES_MARSEILLE_CM1_CM2 = 'Écoles Marseille - CM1, CM2',
    COLL_GE_6E = 'Collège - 6e',
    COLL_GE_5E = 'Collège - 5e',
    COLL_GE_4E = 'Collège - 4e',
    COLL_GE_3E = 'Collège - 3e',
    LYC_E_SECONDE = 'Lycée - Seconde',
    LYC_E_PREMI_RE = 'Lycée - Première',
    LYC_E_TERMINALE = 'Lycée - Terminale',
    CAP_2E_ANN_E = 'CAP - 2e année',
    CAP_1RE_ANN_E = 'CAP - 1re année'
}

/**
 * SubcategoryIdEnum
 *
 * An enumeration.
 */
export enum SubcategoryIdEnum {
    ABO_BIBLIOTHEQUE = 'ABO_BIBLIOTHEQUE',
    ABO_CONCERT = 'ABO_CONCERT',
    ABO_JEU_VIDEO = 'ABO_JEU_VIDEO',
    ABO_LIVRE_NUMERIQUE = 'ABO_LIVRE_NUMERIQUE',
    ABO_LUDOTHEQUE = 'ABO_LUDOTHEQUE',
    ABO_MEDIATHEQUE = 'ABO_MEDIATHEQUE',
    ABO_PLATEFORME_MUSIQUE = 'ABO_PLATEFORME_MUSIQUE',
    ABO_PLATEFORME_VIDEO = 'ABO_PLATEFORME_VIDEO',
    ABO_PRATIQUE_ART = 'ABO_PRATIQUE_ART',
    ABO_PRESSE_EN_LIGNE = 'ABO_PRESSE_EN_LIGNE',
    ABO_SPECTACLE = 'ABO_SPECTACLE',
    ACHAT_INSTRUMENT = 'ACHAT_INSTRUMENT',
    ACTIVATION_EVENT = 'ACTIVATION_EVENT',
    ACTIVATION_THING = 'ACTIVATION_THING',
    APP_CULTURELLE = 'APP_CULTURELLE',
    ATELIER_PRATIQUE_ART = 'ATELIER_PRATIQUE_ART',
    AUTRE_SUPPORT_NUMERIQUE = 'AUTRE_SUPPORT_NUMERIQUE',
    BON_ACHAT_INSTRUMENT = 'BON_ACHAT_INSTRUMENT',
    CAPTATION_MUSIQUE = 'CAPTATION_MUSIQUE',
    CARTE_CINE_ILLIMITE = 'CARTE_CINE_ILLIMITE',
    CARTE_CINE_MULTISEANCES = 'CARTE_CINE_MULTISEANCES',
    CARTE_JEUNES = 'CARTE_JEUNES',
    CARTE_MUSEE = 'CARTE_MUSEE',
    CINE_PLEIN_AIR = 'CINE_PLEIN_AIR',
    CINE_VENTE_DISTANCE = 'CINE_VENTE_DISTANCE',
    CONCERT = 'CONCERT',
    CONCOURS = 'CONCOURS',
    CONFERENCE = 'CONFERENCE',
    DECOUVERTE_METIERS = 'DECOUVERTE_METIERS',
    ESCAPE_GAME = 'ESCAPE_GAME',
    EVENEMENT_CINE = 'EVENEMENT_CINE',
    EVENEMENT_JEU = 'EVENEMENT_JEU',
    EVENEMENT_MUSIQUE = 'EVENEMENT_MUSIQUE',
    EVENEMENT_PATRIMOINE = 'EVENEMENT_PATRIMOINE',
    FESTIVAL_ART_VISUEL = 'FESTIVAL_ART_VISUEL',
    FESTIVAL_CINE = 'FESTIVAL_CINE',
    FESTIVAL_LIVRE = 'FESTIVAL_LIVRE',
    FESTIVAL_MUSIQUE = 'FESTIVAL_MUSIQUE',
    FESTIVAL_SPECTACLE = 'FESTIVAL_SPECTACLE',
    JEU_EN_LIGNE = 'JEU_EN_LIGNE',
    JEU_SUPPORT_PHYSIQUE = 'JEU_SUPPORT_PHYSIQUE',
    LIVESTREAM_EVENEMENT = 'LIVESTREAM_EVENEMENT',
    LIVESTREAM_MUSIQUE = 'LIVESTREAM_MUSIQUE',
    LIVESTREAM_PRATIQUE_ARTISTIQUE = 'LIVESTREAM_PRATIQUE_ARTISTIQUE',
    LIVRE_AUDIO_PHYSIQUE = 'LIVRE_AUDIO_PHYSIQUE',
    LIVRE_NUMERIQUE = 'LIVRE_NUMERIQUE',
    LIVRE_PAPIER = 'LIVRE_PAPIER',
    LOCATION_INSTRUMENT = 'LOCATION_INSTRUMENT',
    MATERIEL_ART_CREATIF = 'MATERIEL_ART_CREATIF',
    MUSEE_VENTE_DISTANCE = 'MUSEE_VENTE_DISTANCE',
    OEUVRE_ART = 'OEUVRE_ART',
    PARTITION = 'PARTITION',
    PLATEFORME_PRATIQUE_ARTISTIQUE = 'PLATEFORME_PRATIQUE_ARTISTIQUE',
    PRATIQUE_ART_VENTE_DISTANCE = 'PRATIQUE_ART_VENTE_DISTANCE',
    PODCAST = 'PODCAST',
    RENCONTRE_EN_LIGNE = 'RENCONTRE_EN_LIGNE',
    RENCONTRE_JEU = 'RENCONTRE_JEU',
    RENCONTRE = 'RENCONTRE',
    SALON = 'SALON',
    SEANCE_CINE = 'SEANCE_CINE',
    SEANCE_ESSAI_PRATIQUE_ART = 'SEANCE_ESSAI_PRATIQUE_ART',
    SPECTACLE_ENREGISTRE = 'SPECTACLE_ENREGISTRE',
    SPECTACLE_REPRESENTATION = 'SPECTACLE_REPRESENTATION',
    SPECTACLE_VENTE_DISTANCE = 'SPECTACLE_VENTE_DISTANCE',
    SUPPORT_PHYSIQUE_FILM = 'SUPPORT_PHYSIQUE_FILM',
    SUPPORT_PHYSIQUE_MUSIQUE_CD = 'SUPPORT_PHYSIQUE_MUSIQUE_CD',
    SUPPORT_PHYSIQUE_MUSIQUE_VINYLE = 'SUPPORT_PHYSIQUE_MUSIQUE_VINYLE',
    TELECHARGEMENT_LIVRE_AUDIO = 'TELECHARGEMENT_LIVRE_AUDIO',
    TELECHARGEMENT_MUSIQUE = 'TELECHARGEMENT_MUSIQUE',
    VISITE_GUIDEE = 'VISITE_GUIDEE',
    VISITE_VIRTUELLE = 'VISITE_VIRTUELLE',
    VISITE = 'VISITE',
    VOD = 'VOD'
}

/**
 * SubcategoryResponseModel
 */
export type SubcategoryResponseModel = {
    /**
     * Applabel
     */
    appLabel: string;
    /**
     * Canbeduo
     */
    canBeDuo: boolean;
    /**
     * Canbewithdrawable
     */
    canBeWithdrawable: boolean;
    /**
     * Canexpire
     */
    canExpire: boolean;
    /**
     * Canhaveopeninghours
     */
    canHaveOpeningHours: boolean;
    /**
     * Categoryid
     */
    categoryId: string;
    /**
     * Conditionalfields
     */
    conditionalFields: Array<string>;
    /**
     * Id
     */
    id: string;
    /**
     * Isdigitaldeposit
     */
    isDigitalDeposit: boolean;
    /**
     * Isevent
     */
    isEvent: boolean;
    /**
     * Isphysicaldeposit
     */
    isPhysicalDeposit: boolean;
    /**
     * Isselectable
     */
    isSelectable: boolean;
    /**
     * Onlineofflineplatform
     */
    onlineOfflinePlatform: string;
    /**
     * Prolabel
     */
    proLabel: string;
    /**
     * Reimbursementrule
     */
    reimbursementRule: string;
};

/**
 * SubmitReviewRequestModel
 */
export type SubmitReviewRequestModel = {
    /**
     * Location
     */
    location: string;
    /**
     * Offererid
     */
    offererId: number;
    /**
     * Pagetitle
     */
    pageTitle: string;
    /**
     * Usercomment
     */
    userComment: string;
    /**
     * Usersatisfaction
     */
    userSatisfaction: string;
};

/**
 * Target
 */
export enum Target {
    EDUCATIONAL = 'EDUCATIONAL',
    INDIVIDUAL_AND_EDUCATIONAL = 'INDIVIDUAL_AND_EDUCATIONAL',
    INDIVIDUAL = 'INDIVIDUAL'
}

/**
 * TargetAudience
 */
export enum TargetAudience {
    COLLECTIVE = 'COLLECTIVE',
    INDIVIDUAL = 'INDIVIDUAL'
}

/**
 * ThingStockUpsertBodyModel
 */
export type ThingStockUpsertBodyModel = {
    /**
     * Activationcodes
     */
    activationCodes?: Array<string> | null;
    /**
     * Activationcodesexpirationdatetime
     */
    activationCodesExpirationDatetime?: string | null;
    /**
     * Bookinglimitdatetime
     */
    bookingLimitDatetime?: string | null;
    /**
     * Id
     */
    id?: number | null;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Price
     */
    price: number | string;
    /**
     * Quantity
     */
    quantity?: number | null;
};

/**
 * ThingStocksBulkUpsertBodyModel
 */
export type ThingStocksBulkUpsertBodyModel = {
    /**
     * Stocks
     */
    stocks: Array<ThingStockUpsertBodyModel>;
};

/**
 * TopOfferResponseModel
 */
export type TopOfferResponseModel = {
    image: OfferImage | null;
    /**
     * Isheadlineoffer
     */
    isHeadlineOffer: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Views
     */
    views: number;
};

/**
 * TopOffersResponseData
 */
export type TopOffersResponseData = {
    image: OfferImage | null;
    /**
     * Isheadlineoffer
     */
    isHeadlineOffer: boolean;
    /**
     * Numberofviews
     */
    numberOfViews: number;
    /**
     * Offerid
     */
    offerId: number;
    /**
     * Offername
     */
    offerName: string;
};

/**
 * TotalRevenue
 */
export type TotalRevenue = {
    /**
     * Collective
     */
    collective: number;
    /**
     * Individual
     */
    individual: number;
    /**
     * Total
     */
    total: number;
};

/**
 * UpdateOfferVideoBodyModel
 */
export type UpdateOfferVideoBodyModel = {
    /**
     * Videodescription
     */
    videoDescription?: string | null;
    /**
     * Videourl
     */
    videoUrl: string | null;
};

/**
 * UpsertPriceCategoryModel
 */
export type UpsertPriceCategoryModel = {
    /**
     * Id
     */
    id: number | null;
    /**
     * Label
     */
    label: string;
    /**
     * Price
     */
    price: number;
};

/**
 * UserEmailValidationResponseModel
 */
export type UserEmailValidationResponseModel = {
    /**
     * Newemail
     */
    newEmail?: string | null;
};

/**
 * UserHasBookingResponse
 */
export type UserHasBookingResponse = {
    /**
     * Hasbookings
     */
    hasBookings: boolean;
};

/**
 * UserIdentityBodyModel
 */
export type UserIdentityBodyModel = {
    /**
     * Firstname
     */
    firstName: string;
    /**
     * Lastname
     */
    lastName: string;
};

/**
 * UserIdentityResponseModel
 */
export type UserIdentityResponseModel = {
    /**
     * Firstname
     */
    firstName: string;
    /**
     * Lastname
     */
    lastName: string;
};

/**
 * UserPhoneBodyModel
 */
export type UserPhoneBodyModel = {
    /**
     * Phonenumber
     */
    phoneNumber: string;
};

/**
 * UserPhoneResponseModel
 */
export type UserPhoneResponseModel = {
    /**
     * Phonenumber
     */
    phoneNumber: string;
};

/**
 * UserResetEmailBodyModel
 */
export type UserResetEmailBodyModel = {
    /**
     * Email
     */
    email: string;
    /**
     * Password
     */
    password: string;
};

/**
 * UserRole
 */
export enum UserRole {
    ADMIN = 'ADMIN',
    ANONYMIZED = 'ANONYMIZED',
    BENEFICIARY = 'BENEFICIARY',
    UNDERAGE_BENEFICIARY = 'UNDERAGE_BENEFICIARY',
    FREE_BENEFICIARY = 'FREE_BENEFICIARY',
    PRO = 'PRO',
    NON_ATTACHED_PRO = 'NON_ATTACHED_PRO',
    TEST = 'TEST'
}

/**
 * ValidationError
 *
 * Model of a validation error response.
 */
export type ValidationError = Array<ValidationErrorElement>;

/**
 * ValidationErrorElement
 *
 * Model of a validation error response element.
 */
export type ValidationErrorElement = {
    /**
     * Error context
     */
    ctx?: {
        [key: string]: unknown;
    };
    /**
     * Missing field name
     */
    loc: Array<string>;
    /**
     * Error message
     */
    msg: string;
    /**
     * Error type
     */
    type: string;
};

/**
 * VenueContactModel
 */
export type VenueContactModel = {
    /**
     * Email
     */
    email?: string | null;
    /**
     * Phonenumber
     */
    phoneNumber?: string | null;
    /**
     * Socialmedias
     */
    socialMedias?: {
        [key: string]: string;
    } | null;
    /**
     * Website
     */
    website?: string | null;
};

/**
 * VenueDailyViewModel
 */
export type VenueDailyViewModel = {
    /**
     * Day
     */
    day: string;
    /**
     * Views
     */
    views: number;
};

/**
 * VenueListItemManagingOffererResponseModel
 */
export type VenueListItemManagingOffererResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Isclosed
     */
    isClosed: boolean;
};

/**
 * VenueListItemResponseModel
 */
export type VenueListItemResponseModel = {
    /**
     * Id
     */
    id: number;
    location: LocationResponseModelV2;
    managingOfferer: VenueListItemManagingOffererResponseModel;
    /**
     * Publicname
     */
    publicName: string;
    state: VenueState | null;
};

/**
 * VenueMonthlyViewModel
 */
export type VenueMonthlyViewModel = {
    /**
     * Month
     */
    month: string;
    /**
     * Views
     */
    views: number;
};

/**
 * VenueOfOffererFromSiretResponseModel
 */
export type VenueOfOffererFromSiretResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Ispermanent
     */
    isPermanent: boolean;
    /**
     * Name
     */
    name: string;
    /**
     * Publicname
     */
    publicName: string;
    /**
     * Siret
     */
    siret?: string | null;
};

/**
 * VenueOffersPeriodStatsModel
 */
export type VenueOffersPeriodStatsModel = {
    /**
     * Cumulatedviews
     */
    cumulatedViews: number;
    /**
     * Topoffers
     */
    topOffers: Array<TopOfferResponseModel>;
    /**
     * Viewsbymonth
     */
    viewsByMonth: Array<VenueMonthlyViewModel>;
};

/**
 * VenueProviderResponse
 */
export type VenueProviderResponse = {
    /**
     * Datecreated
     */
    dateCreated: string;
    /**
     * Id
     */
    id: number;
    /**
     * Isactive
     */
    isActive: boolean;
    /**
     * Isduo
     */
    isDuo: boolean | null;
    /**
     * Isfromallocineprovider
     */
    isFromAllocineProvider: boolean;
    /**
     * Lastsyncdate
     */
    lastSyncDate: string | null;
    /**
     * Price
     */
    price?: number | null;
    provider: ProviderResponse;
    /**
     * Quantity
     */
    quantity?: number | null;
    /**
     * Venueid
     */
    venueId: number;
    /**
     * Venueidatofferprovider
     */
    venueIdAtOfferProvider: string | null;
};

/**
 * VenueState
 */
export enum VenueState {
    CLOSED = 'CLOSED'
}

/**
 * VenueStatsDataModel
 */
export type VenueStatsDataModel = {
    /**
     * Dailyviews
     */
    dailyViews: Array<VenueDailyViewModel>;
    /**
     * Topoffers
     */
    topOffers: Array<TopOffersResponseData>;
    /**
     * Totalviewslast30Days
     */
    totalViewsLast30Days: number;
};

/**
 * VenuesEducationalStatusResponseModel
 */
export type VenuesEducationalStatusResponseModel = {
    /**
     * Id
     */
    id: number;
    /**
     * Name
     */
    name: string;
};

/**
 * VenuesEducationalStatusesResponseModel
 */
export type VenuesEducationalStatusesResponseModel = {
    /**
     * Statuses
     */
    statuses: Array<VenuesEducationalStatusResponseModel>;
};

/**
 * VideoData
 */
export type VideoData = {
    /**
     * Videodescription
     */
    videoDescription?: string;
    /**
     * Videoduration
     */
    videoDuration?: number;
    /**
     * Videoexternalid
     */
    videoExternalId?: string;
    /**
     * Videothumbnailurl
     */
    videoThumbnailUrl?: string;
    /**
     * Videotitle
     */
    videoTitle?: string;
    /**
     * Videourl
     */
    videoUrl?: string;
};

/**
 * VideoMetatdataQueryModel
 */
export type VideoMetatdataQueryModel = {
    /**
     * Videourl
     */
    videoUrl: string;
};

/**
 * VisualDisabilityModel
 */
export type VisualDisabilityModel = {
    /**
     * Audiodescription
     */
    audioDescription?: Array<string>;
    /**
     * Soundbeacon
     */
    soundBeacon?: string;
};

/**
 * WeekdayOpeningHoursTimespans
 */
export type WeekdayOpeningHoursTimespans = {
    /**
     * Friday
     */
    FRIDAY?: Array<Array<string>> | null;
    /**
     * Monday
     */
    MONDAY?: Array<Array<string>> | null;
    /**
     * Saturday
     */
    SATURDAY?: Array<Array<string>> | null;
    /**
     * Sunday
     */
    SUNDAY?: Array<Array<string>> | null;
    /**
     * Thursday
     */
    THURSDAY?: Array<Array<string>> | null;
    /**
     * Tuesday
     */
    TUESDAY?: Array<Array<string>> | null;
    /**
     * Wednesday
     */
    WEDNESDAY?: Array<Array<string>> | null;
};

/**
 * WithdrawalTypeEnum
 *
 * An enumeration.
 */
export enum WithdrawalTypeEnum {
    BY_EMAIL = 'by_email',
    IN_APP = 'in_app',
    NO_TICKET = 'no_ticket',
    ON_SITE = 'on_site'
}

export type getArtistsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Search
         */
        search: string;
    };
    url: '/artists';
};

export type getArtistsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getArtistsError = getArtistsErrors[keyof getArtistsErrors];

export type getArtistsResponses = {
    /**
     * OK
     */
    200: ArtistsResponseModel;
};

export type getArtistsResponse = getArtistsResponses[keyof getArtistsResponses];

export type getBookingsCsvData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page
         */
        page?: number;
        /**
         * Offerid
         */
        offerId?: number | null;
        /**
         * Eventdate
         */
        eventDate?: string | null;
        bookingStatusFilter?: BookingStatusFilter | null;
        /**
         * Bookingperiodbeginningdate
         */
        bookingPeriodBeginningDate?: string | null;
        /**
         * Bookingperiodendingdate
         */
        bookingPeriodEndingDate?: string | null;
        /**
         * Offereraddressid
         */
        offererAddressId?: number | null;
        /**
         * Offererid
         */
        offererId: number;
        /**
         * Venueid
         */
        venueId?: number | null;
        exportType?: BookingExportType | null;
    };
    url: '/bookings/csv';
};

export type getBookingsCsvErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsCsvError = getBookingsCsvErrors[keyof getBookingsCsvErrors];

export type getBookingsCsvResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getBookingsDatesByOfferIdData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/bookings/dates/{offer_id}';
};

export type getBookingsDatesByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsDatesByOfferIdError = getBookingsDatesByOfferIdErrors[keyof getBookingsDatesByOfferIdErrors];

export type getBookingsDatesByOfferIdResponses = {
    /**
     * OK
     */
    200: EventDatesInfos;
};

export type getBookingsDatesByOfferIdResponse = getBookingsDatesByOfferIdResponses[keyof getBookingsDatesByOfferIdResponses];

export type getBookingsExcelData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page
         */
        page?: number;
        /**
         * Offerid
         */
        offerId?: number | null;
        /**
         * Eventdate
         */
        eventDate?: string | null;
        bookingStatusFilter?: BookingStatusFilter | null;
        /**
         * Bookingperiodbeginningdate
         */
        bookingPeriodBeginningDate?: string | null;
        /**
         * Bookingperiodendingdate
         */
        bookingPeriodEndingDate?: string | null;
        /**
         * Offereraddressid
         */
        offererAddressId?: number | null;
        /**
         * Offererid
         */
        offererId: number;
        /**
         * Venueid
         */
        venueId?: number | null;
        exportType?: BookingExportType | null;
    };
    url: '/bookings/excel';
};

export type getBookingsExcelErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsExcelError = getBookingsExcelErrors[keyof getBookingsExcelErrors];

export type getBookingsExcelResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type patchBookingsKeepTokenByTokenData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/bookings/keep/token/{token}';
};

export type patchBookingsKeepTokenByTokenErrors = {
    /**
     * Authentification nécessaire
     */
    401: unknown;
    /**
     * La contremarque n'existe pas, ou vous n'avez pas les droits nécessaires pour y accéder.
     */
    404: unknown;
    /**
     * La requête est refusée car la contremarque n'a pas encore été validée, a été annulée, ou son remboursement a été initié
     */
    410: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchBookingsKeepTokenByTokenError = patchBookingsKeepTokenByTokenErrors[keyof patchBookingsKeepTokenByTokenErrors];

export type patchBookingsKeepTokenByTokenResponses = {
    /**
     * L'annulation de la validation de la contremarque a bien été effectuée
     */
    204: void;
};

export type patchBookingsKeepTokenByTokenResponse = patchBookingsKeepTokenByTokenResponses[keyof patchBookingsKeepTokenByTokenResponses];

export type getBookingsOfferByOfferIdCsvData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query: {
        status: BookingsExportStatusFilter;
        /**
         * Eventdate
         */
        eventDate: string;
    };
    url: '/bookings/offer/{offer_id}/csv';
};

export type getBookingsOfferByOfferIdCsvErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsOfferByOfferIdCsvError = getBookingsOfferByOfferIdCsvErrors[keyof getBookingsOfferByOfferIdCsvErrors];

export type getBookingsOfferByOfferIdCsvResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getBookingsOfferByOfferIdExcelData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query: {
        status: BookingsExportStatusFilter;
        /**
         * Eventdate
         */
        eventDate: string;
    };
    url: '/bookings/offer/{offer_id}/excel';
};

export type getBookingsOfferByOfferIdExcelErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsOfferByOfferIdExcelError = getBookingsOfferByOfferIdExcelErrors[keyof getBookingsOfferByOfferIdExcelErrors];

export type getBookingsOfferByOfferIdExcelResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getBookingsProData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Page
         */
        page?: number;
        /**
         * Offerid
         */
        offerId?: number | null;
        /**
         * Eventdate
         */
        eventDate?: string | null;
        bookingStatusFilter?: BookingStatusFilter | null;
        /**
         * Bookingperiodbeginningdate
         */
        bookingPeriodBeginningDate?: string | null;
        /**
         * Bookingperiodendingdate
         */
        bookingPeriodEndingDate?: string | null;
        /**
         * Offereraddressid
         */
        offererAddressId?: number | null;
        /**
         * Venueid
         */
        venueId: number;
    };
    url: '/bookings/pro';
};

export type getBookingsProErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsProError = getBookingsProErrors[keyof getBookingsProErrors];

export type getBookingsProResponses = {
    /**
     * OK
     */
    200: GetBookingsProResponseModel;
};

export type getBookingsProResponse = getBookingsProResponses[keyof getBookingsProResponses];

export type getBookingsProUserHasBookingsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/bookings/pro/userHasBookings';
};

export type getBookingsProUserHasBookingsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsProUserHasBookingsError = getBookingsProUserHasBookingsErrors[keyof getBookingsProUserHasBookingsErrors];

export type getBookingsProUserHasBookingsResponses = {
    /**
     * OK
     */
    200: UserHasBookingResponse;
};

export type getBookingsProUserHasBookingsResponse = getBookingsProUserHasBookingsResponses[keyof getBookingsProUserHasBookingsResponses];

export type getBookingsTokenByTokenData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/bookings/token/{token}';
};

export type getBookingsTokenByTokenErrors = {
    /**
     * Authentification nécessaire
     */
    401: unknown;
    /**
     * La contremarque n'existe pas, ou vous n'avez pas les droits nécessaires pour y accéder.
     */
    404: unknown;
    /**
     * Cette contremarque a été validée.
     * En l’invalidant vous indiquez qu’elle n’a pas été utilisée et vous ne serez pas remboursé.
     */
    410: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getBookingsTokenByTokenError = getBookingsTokenByTokenErrors[keyof getBookingsTokenByTokenErrors];

export type getBookingsTokenByTokenResponses = {
    /**
     * La contremarque existe et n’est pas validée
     */
    200: GetBookingResponse;
};

export type getBookingsTokenByTokenResponse = getBookingsTokenByTokenResponses[keyof getBookingsTokenByTokenResponses];

export type patchBookingsUseTokenByTokenData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/bookings/use/token/{token}';
};

export type patchBookingsUseTokenByTokenErrors = {
    /**
     * Authentification nécessaire
     */
    401: unknown;
    /**
     * La contremarque n'existe pas, ou vous n'avez pas les droits nécessaires pour y accéder.
     */
    404: unknown;
    /**
     * Cette contremarque a été validée.
     * En l’invalidant vous indiquez qu’elle n’a pas été utilisée et vous ne serez pas remboursé.
     */
    410: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchBookingsUseTokenByTokenError = patchBookingsUseTokenByTokenErrors[keyof patchBookingsUseTokenByTokenErrors];

export type patchBookingsUseTokenByTokenResponses = {
    /**
     * La contremarque a bien été validée
     */
    204: void;
};

export type patchBookingsUseTokenByTokenResponse = patchBookingsUseTokenByTokenResponses[keyof patchBookingsUseTokenByTokenResponses];

export type getCollectiveBookableOffersData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Name
         */
        name?: string | null;
        /**
         * Offererid
         */
        offererId?: number | null;
        /**
         * Status
         */
        status?: Array<CollectiveOfferDisplayedStatus> | null;
        /**
         * Venueid
         */
        venueId?: number | null;
        /**
         * Periodbeginningdate
         */
        periodBeginningDate?: string | null;
        /**
         * Periodendingdate
         */
        periodEndingDate?: string | null;
        format?: EacFormat | null;
        locationType?: CollectiveLocationType | null;
        /**
         * Offereraddressid
         */
        offererAddressId?: number | null;
    };
    url: '/collective/bookable-offers';
};

export type getCollectiveBookableOffersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveBookableOffersError = getCollectiveBookableOffersErrors[keyof getCollectiveBookableOffersErrors];

export type getCollectiveBookableOffersResponses = {
    /**
     * OK
     */
    200: ListCollectiveOffersResponseModel;
};

export type getCollectiveBookableOffersResponse = getCollectiveBookableOffersResponses[keyof getCollectiveBookableOffersResponses];

export type getCollectiveEducationalDomainsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/collective/educational-domains';
};

export type getCollectiveEducationalDomainsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveEducationalDomainsError = getCollectiveEducationalDomainsErrors[keyof getCollectiveEducationalDomainsErrors];

export type getCollectiveEducationalDomainsResponses = {
    /**
     * OK
     */
    200: EducationalDomainsResponseModel;
};

export type getCollectiveEducationalDomainsResponse = getCollectiveEducationalDomainsResponses[keyof getCollectiveEducationalDomainsResponses];

export type getCollectiveHomeBookableOffersData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Venueid
         */
        venueId: number;
    };
    url: '/collective/home/bookable-offers';
};

export type getCollectiveHomeBookableOffersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveHomeBookableOffersError = getCollectiveHomeBookableOffersErrors[keyof getCollectiveHomeBookableOffersErrors];

export type getCollectiveHomeBookableOffersResponses = {
    /**
     * OK
     */
    200: ListCollectiveOffersHomeResponseModel;
};

export type getCollectiveHomeBookableOffersResponse = getCollectiveHomeBookableOffersResponses[keyof getCollectiveHomeBookableOffersResponses];

export type getCollectiveHomeOffersTemplateData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Venueid
         */
        venueId: number;
    };
    url: '/collective/home/offers-template';
};

export type getCollectiveHomeOffersTemplateErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveHomeOffersTemplateError = getCollectiveHomeOffersTemplateErrors[keyof getCollectiveHomeOffersTemplateErrors];

export type getCollectiveHomeOffersTemplateResponses = {
    /**
     * OK
     */
    200: CollectiveOfferTemplatesHomeResponseModel;
};

export type getCollectiveHomeOffersTemplateResponse = getCollectiveHomeOffersTemplateResponses[keyof getCollectiveHomeOffersTemplateResponses];

export type postCollectiveOffersData = {
    body: PostCollectiveOfferBodyModel;
    path?: never;
    query?: never;
    url: '/collective/offers';
};

export type postCollectiveOffersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postCollectiveOffersError = postCollectiveOffersErrors[keyof postCollectiveOffersErrors];

export type postCollectiveOffersResponses = {
    /**
     * Created
     */
    201: CollectiveOfferResponseIdModel;
};

export type postCollectiveOffersResponse = postCollectiveOffersResponses[keyof postCollectiveOffersResponses];

export type getCollectiveOffersTemplateData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Name
         */
        name?: string | null;
        /**
         * Offererid
         */
        offererId?: number | null;
        /**
         * Status
         */
        status?: Array<CollectiveOfferDisplayedStatus> | null;
        /**
         * Venueid
         */
        venueId?: number | null;
        /**
         * Periodbeginningdate
         */
        periodBeginningDate?: string | null;
        /**
         * Periodendingdate
         */
        periodEndingDate?: string | null;
        format?: EacFormat | null;
        locationType?: CollectiveLocationType | null;
        /**
         * Offereraddressid
         */
        offererAddressId?: number | null;
    };
    url: '/collective/offers-template';
};

export type getCollectiveOffersTemplateErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveOffersTemplateError = getCollectiveOffersTemplateErrors[keyof getCollectiveOffersTemplateErrors];

export type getCollectiveOffersTemplateResponses = {
    /**
     * OK
     */
    200: ListCollectiveOfferTemplatesResponseModel;
};

export type getCollectiveOffersTemplateResponse = getCollectiveOffersTemplateResponses[keyof getCollectiveOffersTemplateResponses];

export type postCollectiveOffersTemplateData = {
    body: PostCollectiveOfferTemplateBodyModel;
    path?: never;
    query?: never;
    url: '/collective/offers-template';
};

export type postCollectiveOffersTemplateErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postCollectiveOffersTemplateError = postCollectiveOffersTemplateErrors[keyof postCollectiveOffersTemplateErrors];

export type postCollectiveOffersTemplateResponses = {
    /**
     * Created
     */
    201: CollectiveOfferResponseIdModel;
};

export type postCollectiveOffersTemplateResponse = postCollectiveOffersTemplateResponses[keyof postCollectiveOffersTemplateResponses];

export type patchCollectiveOffersTemplateActiveStatusData = {
    body: PatchCollectiveOfferActiveStatusBodyModel;
    path?: never;
    query?: never;
    url: '/collective/offers-template/active-status';
};

export type patchCollectiveOffersTemplateActiveStatusErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersTemplateActiveStatusError = patchCollectiveOffersTemplateActiveStatusErrors[keyof patchCollectiveOffersTemplateActiveStatusErrors];

export type patchCollectiveOffersTemplateActiveStatusResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchCollectiveOffersTemplateActiveStatusResponse = patchCollectiveOffersTemplateActiveStatusResponses[keyof patchCollectiveOffersTemplateActiveStatusResponses];

export type patchCollectiveOffersTemplateArchiveData = {
    body: PatchCollectiveOfferArchiveBodyModel;
    path?: never;
    query?: never;
    url: '/collective/offers-template/archive';
};

export type patchCollectiveOffersTemplateArchiveErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersTemplateArchiveError = patchCollectiveOffersTemplateArchiveErrors[keyof patchCollectiveOffersTemplateArchiveErrors];

export type patchCollectiveOffersTemplateArchiveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchCollectiveOffersTemplateArchiveResponse = patchCollectiveOffersTemplateArchiveResponses[keyof patchCollectiveOffersTemplateArchiveResponses];

export type getCollectiveOffersTemplateRequestByRequestIdData = {
    body?: never;
    path: {
        request_id: number;
    };
    query?: never;
    url: '/collective/offers-template/request/{request_id}';
};

export type getCollectiveOffersTemplateRequestByRequestIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveOffersTemplateRequestByRequestIdError = getCollectiveOffersTemplateRequestByRequestIdErrors[keyof getCollectiveOffersTemplateRequestByRequestIdErrors];

export type getCollectiveOffersTemplateRequestByRequestIdResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferRequestResponseModel;
};

export type getCollectiveOffersTemplateRequestByRequestIdResponse = getCollectiveOffersTemplateRequestByRequestIdResponses[keyof getCollectiveOffersTemplateRequestByRequestIdResponses];

export type getCollectiveOffersTemplateByOfferIdData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers-template/{offer_id}';
};

export type getCollectiveOffersTemplateByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveOffersTemplateByOfferIdError = getCollectiveOffersTemplateByOfferIdErrors[keyof getCollectiveOffersTemplateByOfferIdErrors];

export type getCollectiveOffersTemplateByOfferIdResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferTemplateResponseModel;
};

export type getCollectiveOffersTemplateByOfferIdResponse = getCollectiveOffersTemplateByOfferIdResponses[keyof getCollectiveOffersTemplateByOfferIdResponses];

export type patchCollectiveOffersTemplateByOfferIdData = {
    body: PatchCollectiveOfferTemplateBodyModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers-template/{offer_id}';
};

export type patchCollectiveOffersTemplateByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersTemplateByOfferIdError = patchCollectiveOffersTemplateByOfferIdErrors[keyof patchCollectiveOffersTemplateByOfferIdErrors];

export type patchCollectiveOffersTemplateByOfferIdResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferTemplateResponseModel;
};

export type patchCollectiveOffersTemplateByOfferIdResponse = patchCollectiveOffersTemplateByOfferIdResponses[keyof patchCollectiveOffersTemplateByOfferIdResponses];

export type deleteCollectiveOffersTemplateByOfferIdImageData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers-template/{offer_id}/image';
};

export type deleteCollectiveOffersTemplateByOfferIdImageErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type deleteCollectiveOffersTemplateByOfferIdImageError = deleteCollectiveOffersTemplateByOfferIdImageErrors[keyof deleteCollectiveOffersTemplateByOfferIdImageErrors];

export type deleteCollectiveOffersTemplateByOfferIdImageResponses = {
    /**
     * No Content
     */
    204: void;
};

export type deleteCollectiveOffersTemplateByOfferIdImageResponse = deleteCollectiveOffersTemplateByOfferIdImageResponses[keyof deleteCollectiveOffersTemplateByOfferIdImageResponses];

export type postCollectiveOffersTemplateByOfferIdImageData = {
    body: AttachImageFormModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers-template/{offer_id}/image';
};

export type postCollectiveOffersTemplateByOfferIdImageErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postCollectiveOffersTemplateByOfferIdImageError = postCollectiveOffersTemplateByOfferIdImageErrors[keyof postCollectiveOffersTemplateByOfferIdImageErrors];

export type postCollectiveOffersTemplateByOfferIdImageResponses = {
    /**
     * OK
     */
    200: AttachImageResponseModel;
};

export type postCollectiveOffersTemplateByOfferIdImageResponse = postCollectiveOffersTemplateByOfferIdImageResponses[keyof postCollectiveOffersTemplateByOfferIdImageResponses];

export type patchCollectiveOffersTemplateByOfferIdPublishData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers-template/{offer_id}/publish';
};

export type patchCollectiveOffersTemplateByOfferIdPublishErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersTemplateByOfferIdPublishError = patchCollectiveOffersTemplateByOfferIdPublishErrors[keyof patchCollectiveOffersTemplateByOfferIdPublishErrors];

export type patchCollectiveOffersTemplateByOfferIdPublishResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferTemplateResponseModel;
};

export type patchCollectiveOffersTemplateByOfferIdPublishResponse = patchCollectiveOffersTemplateByOfferIdPublishResponses[keyof patchCollectiveOffersTemplateByOfferIdPublishResponses];

export type patchCollectiveOffersArchiveData = {
    body: PatchCollectiveOfferArchiveBodyModel;
    path?: never;
    query?: never;
    url: '/collective/offers/archive';
};

export type patchCollectiveOffersArchiveErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersArchiveError = patchCollectiveOffersArchiveErrors[keyof patchCollectiveOffersArchiveErrors];

export type patchCollectiveOffersArchiveResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchCollectiveOffersArchiveResponse = patchCollectiveOffersArchiveResponses[keyof patchCollectiveOffersArchiveResponses];

export type getCollectiveOffersCsvData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Name
         */
        name?: string | null;
        /**
         * Offererid
         */
        offererId?: number | null;
        /**
         * Status
         */
        status?: Array<CollectiveOfferDisplayedStatus> | null;
        /**
         * Venueid
         */
        venueId?: number | null;
        /**
         * Periodbeginningdate
         */
        periodBeginningDate?: string | null;
        /**
         * Periodendingdate
         */
        periodEndingDate?: string | null;
        format?: EacFormat | null;
        locationType?: CollectiveLocationType | null;
        /**
         * Offereraddressid
         */
        offererAddressId?: number | null;
    };
    url: '/collective/offers/csv';
};

export type getCollectiveOffersCsvErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveOffersCsvError = getCollectiveOffersCsvErrors[keyof getCollectiveOffersCsvErrors];

export type getCollectiveOffersCsvResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getCollectiveOffersExcelData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Name
         */
        name?: string | null;
        /**
         * Offererid
         */
        offererId?: number | null;
        /**
         * Status
         */
        status?: Array<CollectiveOfferDisplayedStatus> | null;
        /**
         * Venueid
         */
        venueId?: number | null;
        /**
         * Periodbeginningdate
         */
        periodBeginningDate?: string | null;
        /**
         * Periodendingdate
         */
        periodEndingDate?: string | null;
        format?: EacFormat | null;
        locationType?: CollectiveLocationType | null;
        /**
         * Offereraddressid
         */
        offererAddressId?: number | null;
    };
    url: '/collective/offers/excel';
};

export type getCollectiveOffersExcelErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveOffersExcelError = getCollectiveOffersExcelErrors[keyof getCollectiveOffersExcelErrors];

export type getCollectiveOffersExcelResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getCollectiveOffersRedactorsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Uai
         */
        uai: string;
        /**
         * Candidate
         */
        candidate: string;
    };
    url: '/collective/offers/redactors';
};

export type getCollectiveOffersRedactorsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveOffersRedactorsError = getCollectiveOffersRedactorsErrors[keyof getCollectiveOffersRedactorsErrors];

export type getCollectiveOffersRedactorsResponses = {
    /**
     * OK
     */
    200: EducationalRedactors;
};

export type getCollectiveOffersRedactorsResponse = getCollectiveOffersRedactorsResponses[keyof getCollectiveOffersRedactorsResponses];

export type getCollectiveOffersByOfferIdData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}';
};

export type getCollectiveOffersByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getCollectiveOffersByOfferIdError = getCollectiveOffersByOfferIdErrors[keyof getCollectiveOffersByOfferIdErrors];

export type getCollectiveOffersByOfferIdResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferResponseModel;
};

export type getCollectiveOffersByOfferIdResponse = getCollectiveOffersByOfferIdResponses[keyof getCollectiveOffersByOfferIdResponses];

export type patchCollectiveOffersByOfferIdData = {
    body: PatchCollectiveOfferBodyModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}';
};

export type patchCollectiveOffersByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersByOfferIdError = patchCollectiveOffersByOfferIdErrors[keyof patchCollectiveOffersByOfferIdErrors];

export type patchCollectiveOffersByOfferIdResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferResponseModel;
};

export type patchCollectiveOffersByOfferIdResponse = patchCollectiveOffersByOfferIdResponses[keyof patchCollectiveOffersByOfferIdResponses];

export type patchCollectiveOffersByOfferIdCancelBookingData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}/cancel_booking';
};

export type patchCollectiveOffersByOfferIdCancelBookingErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersByOfferIdCancelBookingError = patchCollectiveOffersByOfferIdCancelBookingErrors[keyof patchCollectiveOffersByOfferIdCancelBookingErrors];

export type patchCollectiveOffersByOfferIdCancelBookingResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchCollectiveOffersByOfferIdCancelBookingResponse = patchCollectiveOffersByOfferIdCancelBookingResponses[keyof patchCollectiveOffersByOfferIdCancelBookingResponses];

export type postCollectiveOffersByOfferIdDuplicateData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}/duplicate';
};

export type postCollectiveOffersByOfferIdDuplicateErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postCollectiveOffersByOfferIdDuplicateError = postCollectiveOffersByOfferIdDuplicateErrors[keyof postCollectiveOffersByOfferIdDuplicateErrors];

export type postCollectiveOffersByOfferIdDuplicateResponses = {
    /**
     * Created
     */
    201: GetCollectiveOfferResponseModel;
};

export type postCollectiveOffersByOfferIdDuplicateResponse = postCollectiveOffersByOfferIdDuplicateResponses[keyof postCollectiveOffersByOfferIdDuplicateResponses];

export type patchCollectiveOffersByOfferIdEducationalInstitutionData = {
    body: PatchCollectiveOfferEducationalInstitution;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}/educational_institution';
};

export type patchCollectiveOffersByOfferIdEducationalInstitutionErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersByOfferIdEducationalInstitutionError = patchCollectiveOffersByOfferIdEducationalInstitutionErrors[keyof patchCollectiveOffersByOfferIdEducationalInstitutionErrors];

export type patchCollectiveOffersByOfferIdEducationalInstitutionResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferResponseModel;
};

export type patchCollectiveOffersByOfferIdEducationalInstitutionResponse = patchCollectiveOffersByOfferIdEducationalInstitutionResponses[keyof patchCollectiveOffersByOfferIdEducationalInstitutionResponses];

export type deleteCollectiveOffersByOfferIdImageData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}/image';
};

export type deleteCollectiveOffersByOfferIdImageErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type deleteCollectiveOffersByOfferIdImageError = deleteCollectiveOffersByOfferIdImageErrors[keyof deleteCollectiveOffersByOfferIdImageErrors];

export type deleteCollectiveOffersByOfferIdImageResponses = {
    /**
     * No Content
     */
    204: void;
};

export type deleteCollectiveOffersByOfferIdImageResponse = deleteCollectiveOffersByOfferIdImageResponses[keyof deleteCollectiveOffersByOfferIdImageResponses];

export type postCollectiveOffersByOfferIdImageData = {
    body: AttachImageFormModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}/image';
};

export type postCollectiveOffersByOfferIdImageErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postCollectiveOffersByOfferIdImageError = postCollectiveOffersByOfferIdImageErrors[keyof postCollectiveOffersByOfferIdImageErrors];

export type postCollectiveOffersByOfferIdImageResponses = {
    /**
     * OK
     */
    200: AttachImageResponseModel;
};

export type postCollectiveOffersByOfferIdImageResponse = postCollectiveOffersByOfferIdImageResponses[keyof postCollectiveOffersByOfferIdImageResponses];

export type patchCollectiveOffersByOfferIdPublishData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/collective/offers/{offer_id}/publish';
};

export type patchCollectiveOffersByOfferIdPublishErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveOffersByOfferIdPublishError = patchCollectiveOffersByOfferIdPublishErrors[keyof patchCollectiveOffersByOfferIdPublishErrors];

export type patchCollectiveOffersByOfferIdPublishResponses = {
    /**
     * OK
     */
    200: GetCollectiveOfferResponseModel;
};

export type patchCollectiveOffersByOfferIdPublishResponse = patchCollectiveOffersByOfferIdPublishResponses[keyof patchCollectiveOffersByOfferIdPublishResponses];

export type postCollectiveStocksData = {
    body: CollectiveStockCreationBodyModel;
    path?: never;
    query?: never;
    url: '/collective/stocks';
};

export type postCollectiveStocksErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postCollectiveStocksError = postCollectiveStocksErrors[keyof postCollectiveStocksErrors];

export type postCollectiveStocksResponses = {
    /**
     * Created
     */
    201: CollectiveStockResponseModel;
};

export type postCollectiveStocksResponse = postCollectiveStocksResponses[keyof postCollectiveStocksResponses];

export type patchCollectiveStocksByCollectiveStockIdData = {
    body: CollectiveStockEditionBodyModel;
    path: {
        collective_stock_id: number;
    };
    query?: never;
    url: '/collective/stocks/{collective_stock_id}';
};

export type patchCollectiveStocksByCollectiveStockIdErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchCollectiveStocksByCollectiveStockIdError = patchCollectiveStocksByCollectiveStockIdErrors[keyof patchCollectiveStocksByCollectiveStockIdErrors];

export type patchCollectiveStocksByCollectiveStockIdResponses = {
    /**
     * OK
     */
    200: CollectiveStockResponseModel;
};

export type patchCollectiveStocksByCollectiveStockIdResponse = patchCollectiveStocksByCollectiveStockIdResponses[keyof patchCollectiveStocksByCollectiveStockIdResponses];

export type getEducationalInstitutionsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Perpagelimit
         */
        perPageLimit?: number;
        /**
         * Page
         */
        page?: number;
    };
    url: '/educational_institutions';
};

export type getEducationalInstitutionsErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getEducationalInstitutionsError = getEducationalInstitutionsErrors[keyof getEducationalInstitutionsErrors];

export type getEducationalInstitutionsResponses = {
    /**
     * OK
     */
    200: EducationalInstitutionsResponseModel;
};

export type getEducationalInstitutionsResponse = getEducationalInstitutionsResponses[keyof getEducationalInstitutionsResponses];

export type getFeaturesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/features';
};

export type getFeaturesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFeaturesError = getFeaturesErrors[keyof getFeaturesErrors];

export type getFeaturesResponses = {
    /**
     * OK
     */
    200: ListFeatureResponseModel;
};

export type getFeaturesResponse = getFeaturesResponses[keyof getFeaturesResponses];

export type getFinanceCombinedInvoicesData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Invoicereferences
         */
        invoiceReferences: Array<string>;
    };
    url: '/finance/combined-invoices';
};

export type getFinanceCombinedInvoicesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFinanceCombinedInvoicesError = getFinanceCombinedInvoicesErrors[keyof getFinanceCombinedInvoicesErrors];

export type getFinanceCombinedInvoicesResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getFinanceHasInvoiceData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Offererid
         */
        offererId: number;
    };
    url: '/finance/has-invoice';
};

export type getFinanceHasInvoiceErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFinanceHasInvoiceError = getFinanceHasInvoiceErrors[keyof getFinanceHasInvoiceErrors];

export type getFinanceHasInvoiceResponses = {
    /**
     * OK
     */
    200: HasInvoiceResponseModel;
};

export type getFinanceHasInvoiceResponse = getFinanceHasInvoiceResponses[keyof getFinanceHasInvoiceResponses];

export type getFinanceHasSettlementData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Offererid
         */
        offererId: number;
    };
    url: '/finance/has-settlement';
};

export type getFinanceHasSettlementErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFinanceHasSettlementError = getFinanceHasSettlementErrors[keyof getFinanceHasSettlementErrors];

export type getFinanceHasSettlementResponses = {
    /**
     * OK
     */
    200: HasSettlementResponseModel;
};

export type getFinanceHasSettlementResponse = getFinanceHasSettlementResponses[keyof getFinanceHasSettlementResponses];

export type getFinanceInvoicesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Periodbeginningdate
         */
        periodBeginningDate?: string | null;
        /**
         * Periodendingdate
         */
        periodEndingDate?: string | null;
        /**
         * Bankaccountid
         */
        bankAccountId?: number | null;
        /**
         * Offererid
         */
        offererId?: number | null;
        /**
         * Amountpositiveonly
         */
        amountPositiveOnly?: boolean | null;
        /**
         * Amountnegativeonly
         */
        amountNegativeOnly?: boolean | null;
    };
    url: '/finance/invoices';
};

export type getFinanceInvoicesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFinanceInvoicesError = getFinanceInvoicesErrors[keyof getFinanceInvoicesErrors];

export type getFinanceInvoicesResponses = {
    /**
     * OK
     */
    200: InvoiceListResponseModel;
};

export type getFinanceInvoicesResponse = getFinanceInvoicesResponses[keyof getFinanceInvoicesResponses];

export type getFinanceReimbursementsCsvData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Invoicesreferences
         */
        invoicesReferences: Array<string>;
    };
    url: '/finance/reimbursements/csv';
};

export type getFinanceReimbursementsCsvErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFinanceReimbursementsCsvError = getFinanceReimbursementsCsvErrors[keyof getFinanceReimbursementsCsvErrors];

export type getFinanceReimbursementsCsvResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type getFinanceRejectedBankAccountsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Offererid
         */
        offererId: number;
    };
    url: '/finance/rejected-bank-accounts';
};

export type getFinanceRejectedBankAccountsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFinanceRejectedBankAccountsError = getFinanceRejectedBankAccountsErrors[keyof getFinanceRejectedBankAccountsErrors];

export type getFinanceRejectedBankAccountsResponses = {
    /**
     * OK
     */
    200: RejectedBankAccountsResponseModel;
};

export type getFinanceRejectedBankAccountsResponse = getFinanceRejectedBankAccountsResponses[keyof getFinanceRejectedBankAccountsResponses];

export type getFinanceSettlementsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Offererid
         */
        offererId: number;
        /**
         * Periodbeginningdate
         */
        periodBeginningDate?: string | null;
        /**
         * Periodendingdate
         */
        periodEndingDate?: string | null;
        /**
         * Bankaccountid
         */
        bankAccountId?: number | null;
        /**
         * Namesearch
         */
        nameSearch?: string | null;
    };
    url: '/finance/settlements';
};

export type getFinanceSettlementsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getFinanceSettlementsError = getFinanceSettlementsErrors[keyof getFinanceSettlementsErrors];

export type getFinanceSettlementsResponses = {
    /**
     * OK
     */
    200: SettlementListResponseModel;
};

export type getFinanceSettlementsResponse = getFinanceSettlementsResponses[keyof getFinanceSettlementsResponses];

export type getGetOfferVideoDataData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Videourl
         */
        videoUrl: string;
    };
    url: '/get-offer-video-data';
};

export type getGetOfferVideoDataErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getGetOfferVideoDataError = getGetOfferVideoDataErrors[keyof getGetOfferVideoDataErrors];

export type getGetOfferVideoDataResponses = {
    /**
     * OK
     */
    200: VideoData;
};

export type getGetOfferVideoDataResponse = getGetOfferVideoDataResponses[keyof getGetOfferVideoDataResponses];

export type getGetStatisticsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Venueids
         */
        venueIds?: Array<number>;
    };
    url: '/get-statistics';
};

export type getGetStatisticsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getGetStatisticsError = getGetStatisticsErrors[keyof getGetStatisticsErrors];

export type getGetStatisticsResponses = {
    /**
     * OK
     */
    200: StatisticsModel;
};

export type getGetStatisticsResponse = getGetStatisticsResponses[keyof getGetStatisticsResponses];

export type getGetProductByEanByEanByOffererIdData = {
    body?: never;
    path: {
        ean: string;
        offerer_id: number;
    };
    query?: never;
    url: '/get_product_by_ean/{ean}/{offerer_id}';
};

export type getGetProductByEanByEanByOffererIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getGetProductByEanByEanByOffererIdError = getGetProductByEanByEanByOffererIdErrors[keyof getGetProductByEanByEanByOffererIdErrors];

export type getGetProductByEanByEanByOffererIdResponses = {
    /**
     * OK
     */
    200: GetProductInformations;
};

export type getGetProductByEanByEanByOffererIdResponse = getGetProductByEanByEanByOffererIdResponses[keyof getGetProductByEanByEanByOffererIdResponses];

export type getHighlightsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/highlights';
};

export type getHighlightsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getHighlightsError = getHighlightsErrors[keyof getHighlightsErrors];

export type getHighlightsResponses = {
    /**
     * OK
     */
    200: HighlightsResponseModel;
};

export type getHighlightsResponse = getHighlightsResponses[keyof getHighlightsResponses];

export type getNatureFormatDomainData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/nature-format-domain';
};

export type getNatureFormatDomainErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getNatureFormatDomainError = getNatureFormatDomainErrors[keyof getNatureFormatDomainErrors];

export type getNatureFormatDomainResponses = {
    /**
     * OK
     */
    200: NatureFormatDomainListResponseModel;
};

export type getNatureFormatDomainResponse = getNatureFormatDomainResponses[keyof getNatureFormatDomainResponses];

export type postOfferersData = {
    body: CreateOffererBodyModel;
    path?: never;
    query?: never;
    url: '/offerers';
};

export type postOfferersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOfferersError = postOfferersErrors[keyof postOfferersErrors];

export type postOfferersResponses = {
    /**
     * Created
     */
    201: PostOffererResponseModel;
};

export type postOfferersResponse = postOfferersResponses[keyof postOfferersResponses];

export type getOfferersEducationalData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Offererid
         */
        offererId?: number | null;
    };
    url: '/offerers/educational';
};

export type getOfferersEducationalErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOfferersEducationalError = getOfferersEducationalErrors[keyof getOfferersEducationalErrors];

export type getOfferersEducationalResponses = {
    /**
     * OK
     */
    200: GetEducationalOfferersResponseModel;
};

export type getOfferersEducationalResponse = getOfferersEducationalResponses[keyof getOfferersEducationalResponses];

export type getOfferersNamesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/offerers/names';
};

export type getOfferersNamesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOfferersNamesError = getOfferersNamesErrors[keyof getOfferersNamesErrors];

export type getOfferersNamesResponses = {
    /**
     * OK
     */
    200: GetOfferersNamesResponseModel;
};

export type getOfferersNamesResponse = getOfferersNamesResponses[keyof getOfferersNamesResponses];

export type postOfferersNewData = {
    body: SaveNewOnboardingDataQueryModel;
    path?: never;
    query?: never;
    url: '/offerers/new';
};

export type postOfferersNewErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOfferersNewError = postOfferersNewErrors[keyof postOfferersNewErrors];

export type postOfferersNewResponses = {
    /**
     * Created
     */
    201: PostOffererResponseModel;
};

export type postOfferersNewResponse = postOfferersNewResponses[keyof postOfferersNewResponses];

export type getOfferersByOffererIdData = {
    body?: never;
    path: {
        offerer_id: number;
    };
    query?: never;
    url: '/offerers/{offerer_id}';
};

export type getOfferersByOffererIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOfferersByOffererIdError = getOfferersByOffererIdErrors[keyof getOfferersByOffererIdErrors];

export type getOfferersByOffererIdResponses = {
    /**
     * OK
     */
    200: GetOffererResponseModel;
};

export type getOfferersByOffererIdResponse = getOfferersByOffererIdResponses[keyof getOfferersByOffererIdResponses];

export type getOfferersByOffererIdBankAccountsData = {
    body?: never;
    path: {
        offerer_id: number;
    };
    query?: never;
    url: '/offerers/{offerer_id}/bank-accounts';
};

export type getOfferersByOffererIdBankAccountsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOfferersByOffererIdBankAccountsError = getOfferersByOffererIdBankAccountsErrors[keyof getOfferersByOffererIdBankAccountsErrors];

export type getOfferersByOffererIdBankAccountsResponses = {
    /**
     * OK
     */
    200: GetOffererBankAccountsResponseModel;
};

export type getOfferersByOffererIdBankAccountsResponse = getOfferersByOffererIdBankAccountsResponses[keyof getOfferersByOffererIdBankAccountsResponses];

export type patchOfferersByOffererIdBankAccountsByBankAccountIdData = {
    body: LinkVenueToBankAccountBodyModel;
    path: {
        offerer_id: number;
        bank_account_id: number;
    };
    query?: never;
    url: '/offerers/{offerer_id}/bank-accounts/{bank_account_id}';
};

export type patchOfferersByOffererIdBankAccountsByBankAccountIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchOfferersByOffererIdBankAccountsByBankAccountIdError = patchOfferersByOffererIdBankAccountsByBankAccountIdErrors[keyof patchOfferersByOffererIdBankAccountsByBankAccountIdErrors];

export type patchOfferersByOffererIdBankAccountsByBankAccountIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchOfferersByOffererIdBankAccountsByBankAccountIdResponse = patchOfferersByOffererIdBankAccountsByBankAccountIdResponses[keyof patchOfferersByOffererIdBankAccountsByBankAccountIdResponses];

export type postOfferersByOffererIdInviteData = {
    body: InviteMemberQueryModel;
    path: {
        offerer_id: number;
    };
    query?: never;
    url: '/offerers/{offerer_id}/invite';
};

export type postOfferersByOffererIdInviteErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOfferersByOffererIdInviteError = postOfferersByOffererIdInviteErrors[keyof postOfferersByOffererIdInviteErrors];

export type postOfferersByOffererIdInviteResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postOfferersByOffererIdInviteResponse = postOfferersByOffererIdInviteResponses[keyof postOfferersByOffererIdInviteResponses];

export type postOfferersByOffererIdInviteAgainData = {
    body: InviteMemberQueryModel;
    path: {
        offerer_id: number;
    };
    query?: never;
    url: '/offerers/{offerer_id}/invite-again';
};

export type postOfferersByOffererIdInviteAgainErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOfferersByOffererIdInviteAgainError = postOfferersByOffererIdInviteAgainErrors[keyof postOfferersByOffererIdInviteAgainErrors];

export type postOfferersByOffererIdInviteAgainResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postOfferersByOffererIdInviteAgainResponse = postOfferersByOffererIdInviteAgainResponses[keyof postOfferersByOffererIdInviteAgainResponses];

export type getOfferersByOffererIdMembersData = {
    body?: never;
    path: {
        offerer_id: number;
    };
    query?: never;
    url: '/offerers/{offerer_id}/members';
};

export type getOfferersByOffererIdMembersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOfferersByOffererIdMembersError = getOfferersByOffererIdMembersErrors[keyof getOfferersByOffererIdMembersErrors];

export type getOfferersByOffererIdMembersResponses = {
    /**
     * OK
     */
    200: GetOffererMembersResponseModel;
};

export type getOfferersByOffererIdMembersResponse = getOfferersByOffererIdMembersResponses[keyof getOfferersByOffererIdMembersResponses];

export type getOfferersByOffererIdOffererAddressesData = {
    body?: never;
    path: {
        offerer_id: number;
    };
    query?: {
        withOffersOption?: GetOffererAddressesWithOffersOption | null;
    };
    url: '/offerers/{offerer_id}/offerer_addresses';
};

export type getOfferersByOffererIdOffererAddressesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOfferersByOffererIdOffererAddressesError = getOfferersByOffererIdOffererAddressesErrors[keyof getOfferersByOffererIdOffererAddressesErrors];

export type getOfferersByOffererIdOffererAddressesResponses = {
    /**
     * OK
     */
    200: GetOffererAddressesResponseModel;
};

export type getOfferersByOffererIdOffererAddressesResponse = getOfferersByOffererIdOffererAddressesResponses[keyof getOfferersByOffererIdOffererAddressesResponses];

export type postOfferersByOffererIdSynchronizeOnboardingData = {
    body?: never;
    path: {
        offerer_id: number;
    };
    query?: never;
    url: '/offerers/{offerer_id}/synchronize-onboarding';
};

export type postOfferersByOffererIdSynchronizeOnboardingErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOfferersByOffererIdSynchronizeOnboardingError = postOfferersByOffererIdSynchronizeOnboardingErrors[keyof postOfferersByOffererIdSynchronizeOnboardingErrors];

export type postOfferersByOffererIdSynchronizeOnboardingResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postOfferersByOffererIdSynchronizeOnboardingResponse = postOfferersByOffererIdSynchronizeOnboardingResponses[keyof postOfferersByOffererIdSynchronizeOnboardingResponses];

export type getOffersData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Nameorisbn
         */
        nameOrIsbn?: string;
        status?: OfferStatus;
        /**
         * Venueid
         */
        venueId?: number;
        /**
         * Categoryid
         */
        categoryId?: string;
        /**
         * Creationmode
         */
        creationMode?: string;
        /**
         * Periodbeginningdate
         */
        periodBeginningDate?: string;
        /**
         * Periodendingdate
         */
        periodEndingDate?: string;
        /**
         * Offereraddressid
         */
        offererAddressId?: number;
    };
    url: '/offers';
};

export type getOffersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersError = getOffersErrors[keyof getOffersErrors];

export type getOffersResponses = {
    /**
     * OK
     */
    200: ListOffersResponseModel;
};

export type getOffersResponse = getOffersResponses[keyof getOffersResponses];

export type patchOffersActiveStatusData = {
    body: PatchOfferActiveStatusBodyModel;
    path?: never;
    query?: never;
    url: '/offers/active-status';
};

export type patchOffersActiveStatusErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchOffersActiveStatusError = patchOffersActiveStatusErrors[keyof patchOffersActiveStatusErrors];

export type patchOffersActiveStatusResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchOffersActiveStatusResponse = patchOffersActiveStatusResponses[keyof patchOffersActiveStatusResponses];

export type patchOffersAllActiveStatusData = {
    body: PatchAllOffersActiveStatusBodyModel;
    path?: never;
    query?: never;
    url: '/offers/all-active-status';
};

export type patchOffersAllActiveStatusErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchOffersAllActiveStatusError = patchOffersAllActiveStatusErrors[keyof patchOffersAllActiveStatusErrors];

export type patchOffersAllActiveStatusResponses = {
    /**
     * Accepted
     */
    202: unknown;
};

export type getOffersCategoriesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/offers/categories';
};

export type getOffersCategoriesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersCategoriesError = getOffersCategoriesErrors[keyof getOffersCategoriesErrors];

export type getOffersCategoriesResponses = {
    /**
     * OK
     */
    200: CategoriesResponseModel;
};

export type getOffersCategoriesResponse = getOffersCategoriesResponses[keyof getOffersCategoriesResponses];

export type postOffersDeleteDraftData = {
    body: DeleteOfferRequestBody;
    path?: never;
    query?: never;
    url: '/offers/delete-draft';
};

export type postOffersDeleteDraftErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOffersDeleteDraftError = postOffersDeleteDraftErrors[keyof postOffersDeleteDraftErrors];

export type postOffersDeleteDraftResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postOffersDeleteDraftResponse = postOffersDeleteDraftResponses[keyof postOffersDeleteDraftResponses];

export type postOffersDeleteHeadlineData = {
    body: HeadlineOfferDeleteBodyModel;
    path?: never;
    query?: never;
    url: '/offers/delete_headline';
};

export type postOffersDeleteHeadlineErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOffersDeleteHeadlineError = postOffersDeleteHeadlineErrors[keyof postOffersDeleteHeadlineErrors];

export type postOffersDeleteHeadlineResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postOffersDeleteHeadlineResponse = postOffersDeleteHeadlineResponses[keyof postOffersDeleteHeadlineResponses];

export type getOffersHomeData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Venueid
         */
        venueId: number;
    };
    url: '/offers/home';
};

export type getOffersHomeErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersHomeError = getOffersHomeErrors[keyof getOffersHomeErrors];

export type getOffersHomeResponses = {
    /**
     * OK
     */
    200: ListOffersHomeResponseModel;
};

export type getOffersHomeResponse = getOffersHomeResponses[keyof getOffersHomeResponses];

export type getOffersMusicTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/offers/music-types';
};

export type getOffersMusicTypesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersMusicTypesError = getOffersMusicTypesErrors[keyof getOffersMusicTypesErrors];

export type getOffersMusicTypesResponses = {
    /**
     * OK
     */
    200: GetMusicTypesResponse;
};

export type getOffersMusicTypesResponse = getOffersMusicTypesResponses[keyof getOffersMusicTypesResponses];

export type patchOffersPublishData = {
    body: PatchOfferPublishBodyModel;
    path?: never;
    query?: never;
    url: '/offers/publish';
};

export type patchOffersPublishErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchOffersPublishError = patchOffersPublishErrors[keyof patchOffersPublishErrors];

export type patchOffersPublishResponses = {
    /**
     * OK
     */
    200: GetIndividualOfferResponseModel;
};

export type patchOffersPublishResponse = patchOffersPublishResponses[keyof patchOffersPublishResponses];

export type postOffersThumbnailsData = {
    body: CreateThumbnailBodyModel;
    path?: never;
    query?: never;
    url: '/offers/thumbnails';
};

export type postOffersThumbnailsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOffersThumbnailsError = postOffersThumbnailsErrors[keyof postOffersThumbnailsErrors];

export type postOffersThumbnailsResponses = {
    /**
     * Created
     */
    201: CreateThumbnailResponseModel;
};

export type postOffersThumbnailsResponse = postOffersThumbnailsResponses[keyof postOffersThumbnailsResponses];

export type deleteOffersThumbnailsByOfferIdData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/thumbnails/{offer_id}';
};

export type deleteOffersThumbnailsByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type deleteOffersThumbnailsByOfferIdError = deleteOffersThumbnailsByOfferIdErrors[keyof deleteOffersThumbnailsByOfferIdErrors];

export type deleteOffersThumbnailsByOfferIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type deleteOffersThumbnailsByOfferIdResponse = deleteOffersThumbnailsByOfferIdResponses[keyof deleteOffersThumbnailsByOfferIdResponses];

export type postOffersUpsertHeadlineData = {
    body: HeadlineOfferCreationBodyModel;
    path?: never;
    query?: never;
    url: '/offers/upsert_headline';
};

export type postOffersUpsertHeadlineErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOffersUpsertHeadlineError = postOffersUpsertHeadlineErrors[keyof postOffersUpsertHeadlineErrors];

export type postOffersUpsertHeadlineResponses = {
    /**
     * Created
     */
    201: HeadLineOfferResponseModel;
};

export type postOffersUpsertHeadlineResponse = postOffersUpsertHeadlineResponses[keyof postOffersUpsertHeadlineResponses];

export type getOffersByOfferIdData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}';
};

export type getOffersByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersByOfferIdError = getOffersByOfferIdErrors[keyof getOffersByOfferIdErrors];

export type getOffersByOfferIdResponses = {
    /**
     * OK
     */
    200: GetIndividualOfferResponseModel;
};

export type getOffersByOfferIdResponse = getOffersByOfferIdResponses[keyof getOffersByOfferIdResponses];

export type patchOffersByOfferIdData = {
    body: PatchOfferBodyModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}';
};

export type patchOffersByOfferIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchOffersByOfferIdError = patchOffersByOfferIdErrors[keyof patchOffersByOfferIdErrors];

export type patchOffersByOfferIdResponses = {
    /**
     * OK
     */
    200: GetIndividualOfferResponseModel;
};

export type patchOffersByOfferIdResponse = patchOffersByOfferIdResponses[keyof patchOffersByOfferIdResponses];

export type getOffersByOfferIdExposureData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}/exposure';
};

export type getOffersByOfferIdExposureErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersByOfferIdExposureError = getOffersByOfferIdExposureErrors[keyof getOffersByOfferIdExposureErrors];

export type getOffersByOfferIdExposureResponses = {
    /**
     * OK
     */
    200: GetOfferExposureResponseModel;
};

export type getOffersByOfferIdExposureResponse = getOffersByOfferIdExposureResponses[keyof getOffersByOfferIdExposureResponses];

export type postOffersByOfferIdHighlightRequestsData = {
    body: CreateOfferHighlightRequestBodyModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}/highlight-requests';
};

export type postOffersByOfferIdHighlightRequestsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOffersByOfferIdHighlightRequestsError = postOffersByOfferIdHighlightRequestsErrors[keyof postOffersByOfferIdHighlightRequestsErrors];

export type postOffersByOfferIdHighlightRequestsResponses = {
    /**
     * Created
     */
    201: GetIndividualOfferResponseModel;
};

export type postOffersByOfferIdHighlightRequestsResponse = postOffersByOfferIdHighlightRequestsResponses[keyof postOffersByOfferIdHighlightRequestsResponses];

export type putOffersByOfferIdPriceCategoriesData = {
    body: PriceCategoryBody;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}/price_categories';
};

export type putOffersByOfferIdPriceCategoriesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type putOffersByOfferIdPriceCategoriesError = putOffersByOfferIdPriceCategoriesErrors[keyof putOffersByOfferIdPriceCategoriesErrors];

export type putOffersByOfferIdPriceCategoriesResponses = {
    /**
     * OK
     */
    200: GetIndividualOfferResponseModel;
};

export type putOffersByOfferIdPriceCategoriesResponse = putOffersByOfferIdPriceCategoriesResponses[keyof putOffersByOfferIdPriceCategoriesResponses];

export type getOffersByOfferIdStocksStatsData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}/stocks-stats';
};

export type getOffersByOfferIdStocksStatsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersByOfferIdStocksStatsError = getOffersByOfferIdStocksStatsErrors[keyof getOffersByOfferIdStocksStatsErrors];

export type getOffersByOfferIdStocksStatsResponses = {
    /**
     * OK
     */
    200: StockStatsResponseModel;
};

export type getOffersByOfferIdStocksStatsResponse = getOffersByOfferIdStocksStatsResponses[keyof getOffersByOfferIdStocksStatsResponses];

export type getOffersByOfferIdStocksData = {
    body?: never;
    path: {
        offer_id: number;
    };
    query?: {
        /**
         * Date
         */
        date?: string;
        /**
         * Time
         */
        time?: string;
        /**
         * Price Category Id
         */
        price_category_id?: number;
        order_by?: StocksOrderedBy;
        /**
         * Order By Desc
         */
        order_by_desc?: boolean;
        /**
         * Page
         */
        page?: number;
        /**
         * Stocks Limit Per Page
         */
        stocks_limit_per_page?: number;
        /**
         * Only Future Stocks
         */
        only_future_stocks?: boolean;
    };
    url: '/offers/{offer_id}/stocks/';
};

export type getOffersByOfferIdStocksErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersByOfferIdStocksError = getOffersByOfferIdStocksErrors[keyof getOffersByOfferIdStocksErrors];

export type getOffersByOfferIdStocksResponses = {
    /**
     * OK
     */
    200: GetStocksResponseModel;
};

export type getOffersByOfferIdStocksResponse = getOffersByOfferIdStocksResponses[keyof getOffersByOfferIdStocksResponses];

export type patchOffersByOfferIdStocksData = {
    body: ThingStocksBulkUpsertBodyModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}/stocks/';
};

export type patchOffersByOfferIdStocksErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchOffersByOfferIdStocksError = patchOffersByOfferIdStocksErrors[keyof patchOffersByOfferIdStocksErrors];

export type patchOffersByOfferIdStocksResponses = {
    /**
     * OK
     */
    200: GetStocksResponseModel;
};

export type patchOffersByOfferIdStocksResponse = patchOffersByOfferIdStocksResponses[keyof patchOffersByOfferIdStocksResponses];

export type postOffersByOfferIdStocksDeleteData = {
    body: DeleteStockListBody;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}/stocks/delete';
};

export type postOffersByOfferIdStocksDeleteErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postOffersByOfferIdStocksDeleteError = postOffersByOfferIdStocksDeleteErrors[keyof postOffersByOfferIdStocksDeleteErrors];

export type postOffersByOfferIdStocksDeleteResponses = {
    /**
     * OK
     */
    200: GetStocksResponseModel;
};

export type postOffersByOfferIdStocksDeleteResponse = postOffersByOfferIdStocksDeleteResponses[keyof postOffersByOfferIdStocksDeleteResponses];

export type putOffersByOfferIdVideoData = {
    body: UpdateOfferVideoBodyModel;
    path: {
        offer_id: number;
    };
    query?: never;
    url: '/offers/{offer_id}/video';
};

export type putOffersByOfferIdVideoErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type putOffersByOfferIdVideoError = putOffersByOfferIdVideoErrors[keyof putOffersByOfferIdVideoErrors];

export type putOffersByOfferIdVideoResponses = {
    /**
     * OK
     */
    200: VideoData;
};

export type putOffersByOfferIdVideoResponse = putOffersByOfferIdVideoResponses[keyof putOffersByOfferIdVideoResponses];

export type getOffersByVenueIdEanByEanData = {
    body?: never;
    path: {
        venue_id: number;
        ean: string;
    };
    query?: never;
    url: '/offers/{venue_id}/ean/{ean}';
};

export type getOffersByVenueIdEanByEanErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getOffersByVenueIdEanByEanError = getOffersByVenueIdEanByEanErrors[keyof getOffersByVenueIdEanByEanErrors];

export type getOffersByVenueIdEanByEanResponses = {
    /**
     * OK
     */
    200: GetActiveEANOfferResponseModel;
};

export type getOffersByVenueIdEanByEanResponse = getOffersByVenueIdEanByEanResponses[keyof getOffersByVenueIdEanByEanResponses];

export type patchStocksBulkData = {
    body: EventStocksBulkUpdateBodyModel;
    path?: never;
    query?: never;
    url: '/stocks/bulk';
};

export type patchStocksBulkErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchStocksBulkError = patchStocksBulkErrors[keyof patchStocksBulkErrors];

export type patchStocksBulkResponses = {
    /**
     * OK
     */
    200: GetStocksResponseModel;
};

export type patchStocksBulkResponse = patchStocksBulkResponses[keyof patchStocksBulkResponses];

export type postStocksBulkData = {
    body: EventStocksBulkCreateBodyModel;
    path?: never;
    query?: never;
    url: '/stocks/bulk';
};

export type postStocksBulkErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postStocksBulkError = postStocksBulkErrors[keyof postStocksBulkErrors];

export type postStocksBulkResponses = {
    /**
     * Created
     */
    201: GetStocksResponseModel;
};

export type postStocksBulkResponse = postStocksBulkResponses[keyof postStocksBulkResponses];

export type getStructureCheckBySearchInputData = {
    body?: never;
    path: {
        search_input: string;
    };
    query?: never;
    url: '/structure/check/{search_input}';
};

export type getStructureCheckBySearchInputErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getStructureCheckBySearchInputError = getStructureCheckBySearchInputErrors[keyof getStructureCheckBySearchInputErrors];

export type getStructureCheckBySearchInputResponses = {
    /**
     * No Content
     */
    204: void;
};

export type getStructureCheckBySearchInputResponse = getStructureCheckBySearchInputResponses[keyof getStructureCheckBySearchInputResponses];

export type getStructureSearchBySearchInputData = {
    body?: never;
    path: {
        search_input: string;
    };
    query?: never;
    url: '/structure/search/{search_input}';
};

export type getStructureSearchBySearchInputErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getStructureSearchBySearchInputError = getStructureSearchBySearchInputErrors[keyof getStructureSearchBySearchInputErrors];

export type getStructureSearchBySearchInputResponses = {
    /**
     * OK
     */
    200: StructureDataBodyModel;
};

export type getStructureSearchBySearchInputResponse = getStructureSearchBySearchInputResponses[keyof getStructureSearchBySearchInputResponses];

export type postStructureSimulateSignupData = {
    body: SignupSimulationPayload;
    path?: never;
    query?: never;
    url: '/structure/simulate-signup';
};

export type postStructureSimulateSignupErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postStructureSimulateSignupError = postStructureSimulateSignupErrors[keyof postStructureSimulateSignupErrors];

export type postStructureSimulateSignupResponses = {
    /**
     * OK
     */
    200: SignupSimulationResponseModel;
};

export type postStructureSimulateSignupResponse = postStructureSimulateSignupResponses[keyof postStructureSimulateSignupResponses];

export type postStructureSummariseSignupData = {
    body: SignupSimulationSummaryPayload;
    path?: never;
    query?: never;
    url: '/structure/summarise-signup';
};

export type postStructureSummariseSignupErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postStructureSummariseSignupError = postStructureSummariseSignupErrors[keyof postStructureSummariseSignupErrors];

export type postStructureSummariseSignupResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postStructureSummariseSignupResponse = postStructureSummariseSignupResponses[keyof postStructureSummariseSignupResponses];

export type postUsersAnonymizeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/anonymize';
};

export type postUsersAnonymizeErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersAnonymizeError = postUsersAnonymizeErrors[keyof postUsersAnonymizeErrors];

export type postUsersAnonymizeResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersAnonymizeResponse = postUsersAnonymizeResponses[keyof postUsersAnonymizeResponses];

export type getUsersAnonymizeEligibilityData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/anonymize/eligibility';
};

export type getUsersAnonymizeEligibilityErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getUsersAnonymizeEligibilityError = getUsersAnonymizeEligibilityErrors[keyof getUsersAnonymizeEligibilityErrors];

export type getUsersAnonymizeEligibilityResponses = {
    /**
     * OK
     */
    200: ProAnonymizationEligibilityResponseModel;
};

export type getUsersAnonymizeEligibilityResponse = getUsersAnonymizeEligibilityResponses[keyof getUsersAnonymizeEligibilityResponses];

export type postUsersCheckTokenData = {
    body: CheckTokenBodyModel;
    path?: never;
    query?: never;
    url: '/users/check-token';
};

export type postUsersCheckTokenErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersCheckTokenError = postUsersCheckTokenErrors[keyof postUsersCheckTokenErrors];

export type postUsersCheckTokenResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersCheckTokenResponse = postUsersCheckTokenResponses[keyof postUsersCheckTokenResponses];

export type getUsersConnectAsByTokenData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/users/connect-as/{token}';
};

export type getUsersConnectAsByTokenErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getUsersConnectAsByTokenError = getUsersConnectAsByTokenErrors[keyof getUsersConnectAsByTokenErrors];

export type getUsersConnectAsByTokenResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type postUsersCookiesData = {
    body: CookieConsentRequest;
    path?: never;
    query?: never;
    url: '/users/cookies';
};

export type postUsersCookiesErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersCookiesError = postUsersCookiesErrors[keyof postUsersCookiesErrors];

export type postUsersCookiesResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersCookiesResponse = postUsersCookiesResponses[keyof postUsersCookiesResponses];

export type getUsersCurrentData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/current';
};

export type getUsersCurrentErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getUsersCurrentError = getUsersCurrentErrors[keyof getUsersCurrentErrors];

export type getUsersCurrentResponses = {
    /**
     * OK
     */
    200: SharedCurrentUserResponseModel;
};

export type getUsersCurrentResponse = getUsersCurrentResponses[keyof getUsersCurrentResponses];

export type postUsersEmailData = {
    body: UserResetEmailBodyModel;
    path?: never;
    query?: never;
    url: '/users/email';
};

export type postUsersEmailErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersEmailError = postUsersEmailErrors[keyof postUsersEmailErrors];

export type postUsersEmailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersEmailResponse = postUsersEmailResponses[keyof postUsersEmailResponses];

export type getUsersEmailPendingValidationData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/email_pending_validation';
};

export type getUsersEmailPendingValidationErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getUsersEmailPendingValidationError = getUsersEmailPendingValidationErrors[keyof getUsersEmailPendingValidationErrors];

export type getUsersEmailPendingValidationResponses = {
    /**
     * OK
     */
    200: UserEmailValidationResponseModel;
};

export type getUsersEmailPendingValidationResponse = getUsersEmailPendingValidationResponses[keyof getUsersEmailPendingValidationResponses];

export type patchUsersIdentityData = {
    body: UserIdentityBodyModel;
    path?: never;
    query?: never;
    url: '/users/identity';
};

export type patchUsersIdentityErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchUsersIdentityError = patchUsersIdentityErrors[keyof patchUsersIdentityErrors];

export type patchUsersIdentityResponses = {
    /**
     * OK
     */
    200: UserIdentityResponseModel;
};

export type patchUsersIdentityResponse = patchUsersIdentityResponses[keyof patchUsersIdentityResponses];

export type postUsersLogUserReviewData = {
    body: SubmitReviewRequestModel;
    path?: never;
    query?: never;
    url: '/users/log-user-review';
};

export type postUsersLogUserReviewErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersLogUserReviewError = postUsersLogUserReviewErrors[keyof postUsersLogUserReviewErrors];

export type postUsersLogUserReviewResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersLogUserReviewResponse = postUsersLogUserReviewResponses[keyof postUsersLogUserReviewResponses];

export type postUsersNewPasswordData = {
    body: NewPasswordBodyModel;
    path?: never;
    query?: never;
    url: '/users/new-password';
};

export type postUsersNewPasswordErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersNewPasswordError = postUsersNewPasswordErrors[keyof postUsersNewPasswordErrors];

export type postUsersNewPasswordResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersNewPasswordResponse = postUsersNewPasswordResponses[keyof postUsersNewPasswordResponses];

export type postUsersPasswordData = {
    body: ChangePasswordBodyModel;
    path?: never;
    query?: never;
    url: '/users/password';
};

export type postUsersPasswordErrors = {
    /**
     * Bad Request
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersPasswordError = postUsersPasswordErrors[keyof postUsersPasswordErrors];

export type postUsersPasswordResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersPasswordResponse = postUsersPasswordResponses[keyof postUsersPasswordResponses];

export type patchUsersPhoneData = {
    body: UserPhoneBodyModel;
    path?: never;
    query?: never;
    url: '/users/phone';
};

export type patchUsersPhoneErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchUsersPhoneError = patchUsersPhoneErrors[keyof patchUsersPhoneErrors];

export type patchUsersPhoneResponses = {
    /**
     * OK
     */
    200: UserPhoneResponseModel;
};

export type patchUsersPhoneResponse = patchUsersPhoneResponses[keyof patchUsersPhoneResponses];

export type postUsersResetPasswordData = {
    body: ResetPasswordBodyModel;
    path?: never;
    query?: never;
    url: '/users/reset-password';
};

export type postUsersResetPasswordErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersResetPasswordError = postUsersResetPasswordErrors[keyof postUsersResetPasswordErrors];

export type postUsersResetPasswordResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersResetPasswordResponse = postUsersResetPasswordResponses[keyof postUsersResetPasswordResponses];

export type postUsersSigninData = {
    body: LoginUserBodyModel;
    path?: never;
    query?: never;
    url: '/users/signin';
};

export type postUsersSigninErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersSigninError = postUsersSigninErrors[keyof postUsersSigninErrors];

export type postUsersSigninResponses = {
    /**
     * OK
     */
    200: SharedLoginUserResponseModel;
};

export type postUsersSigninResponse = postUsersSigninResponses[keyof postUsersSigninResponses];

export type getUsersSignoutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/users/signout';
};

export type getUsersSignoutErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getUsersSignoutError = getUsersSignoutErrors[keyof getUsersSignoutErrors];

export type getUsersSignoutResponses = {
    /**
     * No Content
     */
    204: void;
};

export type getUsersSignoutResponse = getUsersSignoutResponses[keyof getUsersSignoutResponses];

export type postUsersSignupData = {
    body: ProUserCreationBodyV2Model;
    path?: never;
    query?: never;
    url: '/users/signup';
};

export type postUsersSignupErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postUsersSignupError = postUsersSignupErrors[keyof postUsersSignupErrors];

export type postUsersSignupResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postUsersSignupResponse = postUsersSignupResponses[keyof postUsersSignupResponses];

export type patchUsersValidateEmailData = {
    body: ChangeProEmailBody;
    path?: never;
    query?: never;
    url: '/users/validate_email';
};

export type patchUsersValidateEmailErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchUsersValidateEmailError = patchUsersValidateEmailErrors[keyof patchUsersValidateEmailErrors];

export type patchUsersValidateEmailResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchUsersValidateEmailResponse = patchUsersValidateEmailResponses[keyof patchUsersValidateEmailResponses];

export type patchUsersValidateSignupByTokenData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/users/validate_signup/{token}';
};

export type patchUsersValidateSignupByTokenErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchUsersValidateSignupByTokenError = patchUsersValidateSignupByTokenErrors[keyof patchUsersValidateSignupByTokenErrors];

export type patchUsersValidateSignupByTokenResponses = {
    /**
     * No Content
     */
    204: void;
};

export type patchUsersValidateSignupByTokenResponse = patchUsersValidateSignupByTokenResponses[keyof patchUsersValidateSignupByTokenResponses];

export type postV2OffersData = {
    body: PostOfferBodyModel;
    path?: never;
    query?: never;
    url: '/v2/offers';
};

export type postV2OffersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postV2OffersError = postV2OffersErrors[keyof postV2OffersErrors];

export type postV2OffersResponses = {
    /**
     * Created
     */
    201: GetIndividualOfferResponseModel;
};

export type postV2OffersResponse = postV2OffersResponses[keyof postV2OffersResponses];

export type deleteVenueProvidersByVenueProviderIdData = {
    body?: never;
    path: {
        venue_provider_id: number;
    };
    query?: never;
    url: '/venue-providers/{venue_provider_id}';
};

export type deleteVenueProvidersByVenueProviderIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type deleteVenueProvidersByVenueProviderIdError = deleteVenueProvidersByVenueProviderIdErrors[keyof deleteVenueProvidersByVenueProviderIdErrors];

export type deleteVenueProvidersByVenueProviderIdResponses = {
    /**
     * No Content
     */
    204: void;
};

export type deleteVenueProvidersByVenueProviderIdResponse = deleteVenueProvidersByVenueProviderIdResponses[keyof deleteVenueProvidersByVenueProviderIdResponses];

export type putVenueProvidersByVenueProviderIdData = {
    body: PutVenueProviderBody;
    path: {
        venue_provider_id: number;
    };
    query?: never;
    url: '/venue-providers/{venue_provider_id}';
};

export type putVenueProvidersByVenueProviderIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type putVenueProvidersByVenueProviderIdError = putVenueProvidersByVenueProviderIdErrors[keyof putVenueProvidersByVenueProviderIdErrors];

export type putVenueProvidersByVenueProviderIdResponses = {
    /**
     * OK
     */
    200: VenueProviderResponse;
};

export type putVenueProvidersByVenueProviderIdResponse = putVenueProvidersByVenueProviderIdResponses[keyof putVenueProvidersByVenueProviderIdResponses];

export type getVenuesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/venues';
};

export type getVenuesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesError = getVenuesErrors[keyof getVenuesErrors];

export type getVenuesResponses = {
    /**
     * OK
     */
    200: GetVenueListResponseModel;
};

export type getVenuesResponse = getVenuesResponses[keyof getVenuesResponses];

export type getVenuesEducationalStatusesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/venues-educational-statuses';
};

export type getVenuesEducationalStatusesErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesEducationalStatusesError = getVenuesEducationalStatusesErrors[keyof getVenuesEducationalStatusesErrors];

export type getVenuesEducationalStatusesResponses = {
    /**
     * OK
     */
    200: VenuesEducationalStatusesResponseModel;
};

export type getVenuesEducationalStatusesResponse = getVenuesEducationalStatusesResponses[keyof getVenuesEducationalStatusesResponses];

export type getVenuesSiretBySiretData = {
    body?: never;
    path: {
        siret: string;
    };
    query?: never;
    url: '/venues/siret/{siret}';
};

export type getVenuesSiretBySiretErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesSiretBySiretError = getVenuesSiretBySiretErrors[keyof getVenuesSiretBySiretErrors];

export type getVenuesSiretBySiretResponses = {
    /**
     * OK
     */
    200: GetVenuesOfOffererFromSiretResponseModel;
};

export type getVenuesSiretBySiretResponse = getVenuesSiretBySiretResponses[keyof getVenuesSiretBySiretResponses];

export type getVenuesByVenueIdData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}';
};

export type getVenuesByVenueIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesByVenueIdError = getVenuesByVenueIdErrors[keyof getVenuesByVenueIdErrors];

export type getVenuesByVenueIdResponses = {
    /**
     * OK
     */
    200: GetVenueResponseModel;
};

export type getVenuesByVenueIdResponse = getVenuesByVenueIdResponses[keyof getVenuesByVenueIdResponses];

export type patchVenuesByVenueIdData = {
    body: EditVenueBodyModel;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}';
};

export type patchVenuesByVenueIdErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchVenuesByVenueIdError = patchVenuesByVenueIdErrors[keyof patchVenuesByVenueIdErrors];

export type patchVenuesByVenueIdResponses = {
    /**
     * OK
     */
    200: GetVenueResponseModel;
};

export type patchVenuesByVenueIdResponse = patchVenuesByVenueIdResponses[keyof patchVenuesByVenueIdResponses];

export type deleteVenuesByVenueIdBannerData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/banner';
};

export type deleteVenuesByVenueIdBannerErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type deleteVenuesByVenueIdBannerError = deleteVenuesByVenueIdBannerErrors[keyof deleteVenuesByVenueIdBannerErrors];

export type deleteVenuesByVenueIdBannerResponses = {
    /**
     * No Content
     */
    204: void;
};

export type deleteVenuesByVenueIdBannerResponse = deleteVenuesByVenueIdBannerResponses[keyof deleteVenuesByVenueIdBannerResponses];

export type postVenuesByVenueIdCloseData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/close';
};

export type postVenuesByVenueIdCloseErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postVenuesByVenueIdCloseError = postVenuesByVenueIdCloseErrors[keyof postVenuesByVenueIdCloseErrors];

export type postVenuesByVenueIdCloseResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postVenuesByVenueIdCloseResponse = postVenuesByVenueIdCloseResponses[keyof postVenuesByVenueIdCloseResponses];

export type patchVenuesByVenueIdCollectiveDataData = {
    body: EditVenueCollectiveDataBodyModel;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/collective-data';
};

export type patchVenuesByVenueIdCollectiveDataErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type patchVenuesByVenueIdCollectiveDataError = patchVenuesByVenueIdCollectiveDataErrors[keyof patchVenuesByVenueIdCollectiveDataErrors];

export type patchVenuesByVenueIdCollectiveDataResponses = {
    /**
     * OK
     */
    200: GetVenueResponseModel;
};

export type patchVenuesByVenueIdCollectiveDataResponse = patchVenuesByVenueIdCollectiveDataResponses[keyof patchVenuesByVenueIdCollectiveDataResponses];

export type getVenuesByVenueIdHeadlineOfferData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/headline-offer';
};

export type getVenuesByVenueIdHeadlineOfferErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesByVenueIdHeadlineOfferError = getVenuesByVenueIdHeadlineOfferErrors[keyof getVenuesByVenueIdHeadlineOfferErrors];

export type getVenuesByVenueIdHeadlineOfferResponses = {
    /**
     * OK
     */
    200: HeadLineOfferResponseModel;
};

export type getVenuesByVenueIdHeadlineOfferResponse = getVenuesByVenueIdHeadlineOfferResponses[keyof getVenuesByVenueIdHeadlineOfferResponses];

export type getVenuesByVenueIdLocationsData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query: {
        withOffersOption: GetVenueAddressesWithOffersOption;
    };
    url: '/venues/{venue_id}/locations';
};

export type getVenuesByVenueIdLocationsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesByVenueIdLocationsError = getVenuesByVenueIdLocationsErrors[keyof getVenuesByVenueIdLocationsErrors];

export type getVenuesByVenueIdLocationsResponses = {
    /**
     * OK
     */
    200: GetVenueAddressesResponseModel;
};

export type getVenuesByVenueIdLocationsResponse = getVenuesByVenueIdLocationsResponses[keyof getVenuesByVenueIdLocationsResponses];

export type getVenuesByVenueIdOffersStatisticsData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/offers-statistics';
};

export type getVenuesByVenueIdOffersStatisticsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesByVenueIdOffersStatisticsError = getVenuesByVenueIdOffersStatisticsErrors[keyof getVenuesByVenueIdOffersStatisticsErrors];

export type getVenuesByVenueIdOffersStatisticsResponses = {
    /**
     * OK
     */
    200: GetVenueStatsResponseModel;
};

export type getVenuesByVenueIdOffersStatisticsResponse = getVenuesByVenueIdOffersStatisticsResponses[keyof getVenuesByVenueIdOffersStatisticsResponses];

export type getVenuesByVenueIdOffersStatisticsV2Data = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/offers-statistics-v2';
};

export type getVenuesByVenueIdOffersStatisticsV2Errors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesByVenueIdOffersStatisticsV2Error = getVenuesByVenueIdOffersStatisticsV2Errors[keyof getVenuesByVenueIdOffersStatisticsV2Errors];

export type getVenuesByVenueIdOffersStatisticsV2Responses = {
    /**
     * OK
     */
    200: GetVenueOffersStatsV2ResponseModel;
};

export type getVenuesByVenueIdOffersStatisticsV2Response = getVenuesByVenueIdOffersStatisticsV2Responses[keyof getVenuesByVenueIdOffersStatisticsV2Responses];

export type postVenuesByVenueIdPricingPointData = {
    body: LinkVenueToPricingPointBodyModel;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/pricing-point';
};

export type postVenuesByVenueIdPricingPointErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postVenuesByVenueIdPricingPointError = postVenuesByVenueIdPricingPointErrors[keyof postVenuesByVenueIdPricingPointErrors];

export type postVenuesByVenueIdPricingPointResponses = {
    /**
     * No Content
     */
    204: void;
};

export type postVenuesByVenueIdPricingPointResponse = postVenuesByVenueIdPricingPointResponses[keyof postVenuesByVenueIdPricingPointResponses];

export type getVenuesByVenueIdProvidersData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/providers';
};

export type getVenuesByVenueIdProvidersErrors = {
    /**
     * Unauthorized
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not Found
     */
    404: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesByVenueIdProvidersError = getVenuesByVenueIdProvidersErrors[keyof getVenuesByVenueIdProvidersErrors];

export type getVenuesByVenueIdProvidersResponses = {
    /**
     * OK
     */
    200: ListProviderResponse;
};

export type getVenuesByVenueIdProvidersResponse = getVenuesByVenueIdProvidersResponses[keyof getVenuesByVenueIdProvidersResponses];

export type getVenuesByVenueIdVenueProvidersData = {
    body?: never;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/venue-providers';
};

export type getVenuesByVenueIdVenueProvidersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type getVenuesByVenueIdVenueProvidersError = getVenuesByVenueIdVenueProvidersErrors[keyof getVenuesByVenueIdVenueProvidersErrors];

export type getVenuesByVenueIdVenueProvidersResponses = {
    /**
     * OK
     */
    200: ListVenueProviderResponse;
};

export type getVenuesByVenueIdVenueProvidersResponse = getVenuesByVenueIdVenueProvidersResponses[keyof getVenuesByVenueIdVenueProvidersResponses];

export type postVenuesByVenueIdVenueProvidersData = {
    body: PostVenueProviderBody;
    path: {
        venue_id: number;
    };
    query?: never;
    url: '/venues/{venue_id}/venue-providers';
};

export type postVenuesByVenueIdVenueProvidersErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Unprocessable Content
     */
    422: ValidationError;
};

export type postVenuesByVenueIdVenueProvidersError = postVenuesByVenueIdVenueProvidersErrors[keyof postVenuesByVenueIdVenueProvidersErrors];

export type postVenuesByVenueIdVenueProvidersResponses = {
    /**
     * Created
     */
    201: VenueProviderResponse;
};

export type postVenuesByVenueIdVenueProvidersResponse = postVenuesByVenueIdVenueProvidersResponses[keyof postVenuesByVenueIdVenueProvidersResponses];
